import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import { CONTACT_CAT_ORDER } from '../constants';
import useIdleLogout from '../utils/useIdleLogout';
import usePwaManifest from '../utils/usePwaManifest';

const IconPhone = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg>
);
const IconWhatsApp = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
);
const IconFacebook = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
);
const PdfIcon = ({ size = 28 }) => (
  <img src="/pdf-icon.png" alt="PDF" width={size} height={size} style={{ objectFit: 'contain', display: 'block' }} />
);
const EyeIcon = ({ size = 20, color = '#8a8570' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const DownloadIcon = ({ size = 20, color = '#b8862f' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3v12" />
    <path d="M7 10l5 5 5-5" />
    <path d="M5 20h14" />
  </svg>
);

const IconInstagram = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
);

// pos format: "x% y% scale" — x/y are translate offsets (as % of container), scale is zoom factor.
// A zoom > 1 is required because the stored photo is already cropped to a tight square,
// so without extra zoom there is no overflow left to pan within.
function parsePhotoTransform(pos) {
  const parts = (pos || '50% 50% 1').split(' ');
  const x = parseFloat(parts[0]) || 50;
  const y = parseFloat(parts[1]) || 50;
  const scale = parseFloat(parts[2]) || 1;
  return { x, y, scale };
}

function RepositionModal({ src, initialPos, onSave, onCancel }) {
  const init = parsePhotoTransform(initialPos);
  const [x, setX] = React.useState(init.x);
  const [y, setY] = React.useState(init.y);
  const [scale, setScale] = React.useState(Math.max(init.scale, 1));
  const containerRef = React.useRef(null);
  const dragRef = React.useRef(null);
  const pos = `${x}% ${y}% ${scale}`;

  React.useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const prevent = e => { if (dragRef.current) e.preventDefault(); };
    el.addEventListener('touchmove', prevent, { passive: false });
    return () => el.removeEventListener('touchmove', prevent);
  }, []);

  return (
    <div onClick={onCancel} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 20, padding: 24, width: 320, maxWidth: '95vw', direction: 'rtl' }}>
        <div style={{ fontWeight: 700, fontSize: '1rem', marginBottom: 6 }}>✏️ עריכת מיקום תמונה</div>
        <div style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: 14 }}>הגדל וגרור את התמונה לשינוי מיקום:</div>
        <div
          ref={containerRef}
          style={{ width: 240, height: 240, borderRadius: '50%', overflow: 'hidden', border: '2px solid #e5e7eb', margin: '0 auto 16px', cursor: 'grab', userSelect: 'none', touchAction: 'none', position: 'relative', background: '#111' }}
          onPointerDown={e => {
            e.preventDefault();
            const el = containerRef.current;
            el.setPointerCapture(e.pointerId);
            const rect = el.getBoundingClientRect();
            dragRef.current = { sx: e.clientX, sy: e.clientY, startX: x, startY: y, rect };
          }}
          onPointerMove={e => {
            if (!dragRef.current) return;
            e.preventDefault();
            const { sx, sy, startX, startY, rect } = dragRef.current;
            const nx = Math.max(0, Math.min(100, startX + ((e.clientX - sx) / rect.width) * -100));
            const ny = Math.max(0, Math.min(100, startY + ((e.clientY - sy) / rect.height) * -100));
            setX(Math.round(nx)); setY(Math.round(ny));
          }}
          onPointerUp={() => { dragRef.current = null; }}
          onPointerCancel={() => { dragRef.current = null; }}
        >
          <img src={src} alt="" style={{
            position: 'absolute', top: '50%', left: '50%',
            width: `${scale * 100}%`, height: `${scale * 100}%`,
            transform: `translate(-50%, -50%) translate(${(x - 50) * -1}%, ${(y - 50) * -1}%)`,
            objectFit: 'cover', pointerEvents: 'none', display: 'block',
          }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
          <span style={{ fontSize: '0.85rem', color: '#6b7280' }}>🔍</span>
          <input type="range" min="1" max="3" step="0.05" value={scale} onChange={e => setScale(parseFloat(e.target.value))} style={{ flex: 1 }} />
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onCancel} style={{ flex: 1, padding: '11px', borderRadius: 10, border: '1px solid #d1d5db', background: 'white', color: '#374151', fontWeight: 600, cursor: 'pointer', fontSize: '0.95rem' }}>ביטול</button>
          <button onClick={() => onSave(pos)} style={{ flex: 1, padding: '11px', borderRadius: 10, border: 'none', background: '#1a4a8a', color: 'white', fontWeight: 700, cursor: 'pointer', fontSize: '0.95rem' }}>שמור</button>
        </div>
      </div>
    </div>
  );
}

const PROJECT_DISPLAY_NAMES = {
  'ג החדשה': "ג' החדשה",
  'אייזיקחריף': 'אייזיק חריף',
};
const displayName = n => PROJECT_DISPLAY_NAMES[n] || n;

// avatar_pos stores "X% Y%" as a translate() offset (0,0 = centered) — a
// leftover "50% 50%" from before this rework meant "centered" too under the
// old object-position semantics, so it also maps to (0,0) here. Must match
// the identical helper in Portal.jsx (admin panel).
function avatarTransform(pos, zoom) {
  const [x, y] = (!pos || pos === '50% 50%' ? '0% 0%' : pos).replace(/%/g, '').split(' ').map(Number);
  return `translate(${isNaN(x) ? 0 : x}%, ${isNaN(y) ? 0 : y}%) scale(${zoom || 1})`;
}

// Locally-hosted emoji artwork (Twemoji) so the icon renders as the exact
// same image on every device, instead of each OS/browser drawing its own
// emoji glyph (Samsung vs Windows vs iOS all differ, which is what looked
// inconsistent between phone and desktop before).
const TILE_ICON_FILES = {
  home: '1f3e0', 'my-apartment': '1f3e1', stages: '1f4ca', announcements: '1f4e2',
  gallery: '1f4f7', files: '1f4c1', contacts: '1f4de', robot: '1f916',
};
const TILE_EMOJI_FALLBACK = { about: 'ℹ️', events: '🎉' };
function LogoutIcon({ size = 16, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ verticalAlign: 'middle' }}>
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 17l5-5-5-5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 12H3" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function TileIcon({ name, size = 28 }) {
  const file = TILE_ICON_FILES[name];
  if (file) {
    return (
      <img
        src={`/emoji/${file}.png`}
        alt=""
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: 'contain', display: 'block', flexShrink: 0 }}
      />
    );
  }
  return <span style={{ fontSize: size * 0.75 }}>{TILE_EMOJI_FALLBACK[name] || ''}</span>;
}

const PROJECT_LOGOS = {
  'ד החדשה': '/logos/jaffad.png',
  'אייזיקחריף': '/logos/jaffag.png',
  'ג החדשה': '/logos/jaffag.png',
  'סקייליין בת ים': '/logos/skyline.png',
  'ראשון החדשה': '/logos/rishon.jpg',
  'אפלטון 6': '/logos/aplaton6.jpeg',
  'שארית ישראל': '/logos/sherit_israel.jpg',
};

// אחוזי מיקום (top/left) שנקבעו ידנית ע"י המשתמש מול ההדמיה החיה (כלי סימון מיוחד).
const BUILDING_RENDERINGS = {
  'ד החדשה': {
    image: 'https://aura-tenant-portal-files.s3.us-east-1.amazonaws.com/renderings/jd-hachadasha.png',
    markers: [],
  },
  'ג החדשה': {
    image: '/renderings/ja-hachadasha.jpg',
    markers: [
      { num: 'A', top: '18.6%', left: '48.3%' },
      { num: 'B', top: '7.1%', left: '53.6%' },
      { num: 'C', top: '10.7%', left: '59.0%' },
      { num: 'D', top: '16.8%', left: '63.8%' },
      { num: '1', top: '31.4%', left: '75.1%' },
      { num: '2', top: '41.9%', left: '72.1%' },
      { num: '3', top: '51.4%', left: '70.1%' },
      { num: '4', top: '61.0%', left: '67.1%' },
      { num: '5', top: '76.0%', left: '64.6%' },
      { num: '6', top: '32.4%', left: '43.7%' },
      { num: '7', top: '40.1%', left: '50.3%' },
      { num: '8', top: '56.1%', left: '43.4%' },
      { num: '9', top: '49.6%', left: '35.8%' },
      { num: '10', top: '40.5%', left: '28.1%' },
      { num: '11', top: '34.4%', left: '22.2%' },
      { num: '12', top: '25.7%', left: '12.8%' },
    ],
  },
  'אייזיקחריף': {
    image: '/renderings/aizik-harif.jpg',
    markers: [
      // Positions for buildings 1/2/3/4 to be filled in once confirmed.
    ],
  },
  'סקייליין בת ים': {
    image: '/renderings/skyline.jpg',
    markers: [
      { num: '1', top: '41%', left: '70%' },
    ],
  },
};

// Jagged seal/medal-shaped clip-path (28-point starburst) for the header logo badge.
const SEAL_CLIP_PATH = 'polygon(50.00% 0.00%, 54.81% 7.27%, 61.13% 1.25%, 64.20% 9.41%, 71.69% 4.95%, 72.88% 13.59%, 81.17% 10.91%, 80.41% 19.59%, 89.09% 18.83%, 86.41% 27.12%, 95.05% 28.31%, 90.59% 35.80%, 98.75% 38.87%, 92.73% 45.19%, 100.00% 50.00%, 92.73% 54.81%, 98.75% 61.13%, 90.59% 64.20%, 95.05% 71.69%, 86.41% 72.88%, 89.09% 81.17%, 80.41% 80.41%, 81.17% 89.09%, 72.88% 86.41%, 71.69% 95.05%, 64.20% 90.59%, 61.13% 98.75%, 54.81% 92.73%, 50.00% 100.00%, 45.19% 92.73%, 38.87% 98.75%, 35.80% 90.59%, 28.31% 95.05%, 27.12% 86.41%, 18.83% 89.09%, 19.59% 80.41%, 10.91% 81.17%, 13.59% 72.88%, 4.95% 71.69%, 9.41% 64.20%, 1.25% 61.13%, 7.27% 54.81%, 0.00% 50.00%, 7.27% 45.19%, 1.25% 38.87%, 9.41% 35.80%, 4.95% 28.31%, 13.59% 27.12%, 10.91% 18.83%, 19.59% 19.59%, 18.83% 10.91%, 27.12% 13.59%, 28.31% 4.95%, 35.80% 9.41%, 38.87% 1.25%, 45.19% 7.27%)';

// Shared "image + red dot + leader line + badge" renderer, used both for the
// aerial site rendering (marks the tenant's building) and the per-building
// floorplan (marks the tenant's specific apartment letter within it).
// The AI chat's answers routinely include markdown links — [label](url) — and
// **bold** text. This renders both correctly instead of treating a markdown
// link as plain text with a bare URL glued to it: without markdown-link
// awareness, a naive "find any http... substring" regex grabs the link's
// closing ")" as part of the URL (e.g. a real S3 file path becomes
// ".../file.pdf)" ), which 404s/403s when clicked — this was a real bug users
// hit trying to open a document the chat linked them to.
function renderChatMessage(text) {
  const linkPattern = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s)\].,]+)/g;
  const parts = [];
  let lastIndex = 0, match, key = 0;
  while ((match = linkPattern.exec(text)) !== null) {
    if (match.index > lastIndex) parts.push({ text: text.slice(lastIndex, match.index) });
    if (match[1] && match[2]) parts.push({ link: match[2], label: match[1] });
    else if (match[3]) parts.push({ link: match[3], label: match[3] });
    lastIndex = linkPattern.lastIndex;
  }
  if (lastIndex < text.length) parts.push({ text: text.slice(lastIndex) });

  return parts.map(p => {
    key++;
    if (p.link) {
      return <a key={key} href={p.link} target="_blank" rel="noopener noreferrer" style={{ color: '#6d28d9', wordBreak: 'break-all' }}>{p.label}</a>;
    }
    return (
      <React.Fragment key={key}>
        {p.text.split(/(\*\*[^*]+\*\*)/).map((seg, k) =>
          seg.startsWith('**') && seg.endsWith('**') ? <strong key={k}>{seg.slice(2, -2)}</strong> : seg
        )}
      </React.Fragment>
    );
  });
}

function MarkerCard({ title, image, markers, myKey, labelText, isMobile, polygonColor = '#2563eb', polygonFill = 'rgba(96,165,250,0.45)', captionAboveOverride, overlayOnImage = false, lang }) {
  const [zoomed, setZoomed] = useState(false);
  const mine = (markers || []).find(m => String(m.key) === String(myKey));
  const dotX = mine ? parseFloat(mine.left) : null;
  const dotY = mine ? parseFloat(mine.top) : null;
  // A pill+line drawn ON TOP of the image was positioned in percent-space,
  // calibrated once by an admin looking at one screen size — on a busy
  // floorplan drawing it kept landing on top of the plan's own lines (or a
  // neighboring room) on a phone, where the image renders at a very
  // different physical size than the desktop half-width card it was tuned
  // on. The aerial photo has no such dense linework to collide with, so it
  // keeps the on-image pill (overlayOnImage) — only the floorplan card uses
  // the safer outside-the-image caption, sitting on whichever side (above/
  // below) is closer to the marked apartment.
  const captionAboveImage = captionAboveOverride != null ? captionAboveOverride : (dotY != null && dotY < 50);
  const caption = mine && !overlayOnImage && (
    <div style={{ textAlign: 'center', color: '#7B1E2B', fontWeight: 700, fontSize: '0.82rem', margin: captionAboveImage ? '0 0 10px' : '10px 0 0' }}>
      📍 {tr(labelText, lang)}
    </div>
  );
  // Overlay-mode label: an admin can drag it to an explicit calibrated spot
  // per-marker (labelLeft/labelTop, set in the floorplan editor) — used when
  // set, so it can be parked over empty/white space on a busy floorplan.
  // Otherwise it's pinned near the dot, growing away from whichever edge
  // it's closest to so it never spills past the image border.
  const hasCustomLabelPos = mine && mine.labelLeft != null && mine.labelTop != null;
  const overlayLabelX = hasCustomLabelPos ? parseFloat(mine.labelLeft) : (dotX != null ? (dotX > 80 ? 6 : 94) : null);
  const overlayLabelY = hasCustomLabelPos ? parseFloat(mine.labelTop) : (dotY != null ? Math.min(Math.max(dotY, 14), 88) : null);
  const overlayLabelTransform = hasCustomLabelPos ? 'translate(-50%,-50%)' : `translate(${dotX > 80 ? '0%' : '-100%'}, -50%)`;
  return (
    <div style={{ background: 'white', borderRadius: 20, padding: 16, flex: '1 1 0', minWidth: 280, maxWidth: isMobile ? 'none' : '50%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ fontWeight: 700, fontSize: '1.05rem', color: '#1a3320', marginBottom: 12 }}>{tr(title, lang)}</div>
      {captionAboveImage && caption}
      <div
        style={{ position: 'relative', width: '100%', margin: 'auto 0', borderRadius: 12, overflow: 'visible', cursor: 'zoom-in' }}
        onClick={() => setZoomed(true)}
      >
        <div style={{ position: 'relative', width: '100%', borderRadius: 12, overflow: 'hidden', border: !overlayOnImage && mine ? `2px solid ${polygonColor}` : 'none' }}>
          <img src={image} alt="" style={{ width: '100%', display: 'block' }} />
          {mine && Array.isArray(mine.polygon) && mine.polygon.length >= 2 && (
            <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }} viewBox="0 0 100 100" preserveAspectRatio="none">
              <polygon points={mine.polygon.map(p => `${p.x},${p.y}`).join(' ')} fill={polygonFill} stroke={polygonColor} strokeWidth="0.4" vectorEffect="non-scaling-stroke" />
            </svg>
          )}
          {mine && !mine.polygon && mine.rectWidth != null && (
            <div style={{
              position: 'absolute', top: `${mine.rectTop}%`, left: `${mine.rectLeft}%`,
              width: `${mine.rectWidth}%`, height: `${mine.rectHeight}%`,
              background: polygonFill, border: `2px solid ${polygonColor}`, borderRadius: 3,
              pointerEvents: 'none',
            }} />
          )}
          {mine && (
            <div style={{ position: 'absolute', top: `${dotY}%`, left: `${dotX}%`, width: 14, height: 14, borderRadius: '50%', background: '#7B1E2B', border: '3px solid white', boxShadow: '0 0 0 3px rgba(123,30,43,0.4)', transform: 'translate(-50%,-50%)' }} />
          )}
          {/* Caption sits outside the image (floorplans are too busy for an
              overlay pill) — this short line from the dot to the nearest
              edge is what visually ties the dot to the caption beyond it. */}
          {mine && !overlayOnImage && (
            <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }} viewBox="0 0 100 100" preserveAspectRatio="none">
              <line x1={dotX} y1={dotY} x2={dotX} y2={captionAboveImage ? 0 : 100} stroke={polygonColor} strokeWidth="0.4" vectorEffect="non-scaling-stroke" />
            </svg>
          )}
        </div>
        {mine && overlayOnImage && (
          <React.Fragment>
            <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }} viewBox="0 0 100 100" preserveAspectRatio="none">
              <line x1={dotX} y1={dotY} x2={overlayLabelX} y2={overlayLabelY} stroke="#7B1E2B" strokeWidth="0.35" vectorEffect="non-scaling-stroke" />
            </svg>
            <div style={{ position: 'absolute', top: `${overlayLabelY}%`, left: `${overlayLabelX}%`, transform: overlayLabelTransform, pointerEvents: 'none' }}>
              <div style={{ background: '#7B1E2B', color: 'white', fontWeight: 700, fontSize: '0.72rem', padding: '3px 9px', borderRadius: 999, whiteSpace: 'nowrap', boxShadow: '0 2px 6px rgba(123,30,43,0.35)' }}>{tr(labelText, lang)}</div>
            </div>
          </React.Fragment>
        )}
      </div>
      {!captionAboveImage && caption}
      {zoomed && (
        <div
          onClick={() => setZoomed(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, cursor: 'zoom-out' }}
        >
          <div onClick={e => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '95vw', maxHeight: '92vh' }}>
            {captionAboveImage && !overlayOnImage && mine && (
              <div style={{ textAlign: 'center', color: 'white', fontWeight: 700, fontSize: '0.9rem', marginBottom: 10 }}>📍 {tr(labelText, lang)}</div>
            )}
            <div style={{ position: 'relative', maxWidth: '95vw', maxHeight: 'calc(92vh - 40px)' }}>
              <img src={image} alt="" style={{ maxWidth: '95vw', maxHeight: 'calc(92vh - 40px)', display: 'block', borderRadius: 10, boxShadow: '0 10px 40px rgba(0,0,0,0.5)' }} />
              {mine && Array.isArray(mine.polygon) && mine.polygon.length >= 2 && (
                <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }} viewBox="0 0 100 100" preserveAspectRatio="none">
                  <polygon points={mine.polygon.map(p => `${p.x},${p.y}`).join(' ')} fill={polygonFill} stroke={polygonColor} strokeWidth="0.4" vectorEffect="non-scaling-stroke" />
                </svg>
              )}
              {mine && !mine.polygon && mine.rectWidth != null && (
                <div style={{
                  position: 'absolute', top: `${mine.rectTop}%`, left: `${mine.rectLeft}%`,
                  width: `${mine.rectWidth}%`, height: `${mine.rectHeight}%`,
                  background: polygonFill, border: `2px solid ${polygonColor}`, borderRadius: 3,
                  pointerEvents: 'none',
                }} />
              )}
              {mine && (
                <div style={{ position: 'absolute', top: `${dotY}%`, left: `${dotX}%`, width: 16, height: 16, borderRadius: '50%', background: '#7B1E2B', border: '3px solid white', boxShadow: '0 0 0 3px rgba(123,30,43,0.4)', transform: 'translate(-50%,-50%)' }} />
              )}
              {mine && overlayOnImage && (
                <React.Fragment>
                  <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }} viewBox="0 0 100 100" preserveAspectRatio="none">
                    <line x1={dotX} y1={dotY} x2={overlayLabelX} y2={overlayLabelY} stroke="#7B1E2B" strokeWidth="0.35" vectorEffect="non-scaling-stroke" />
                  </svg>
                  <div style={{ position: 'absolute', top: `${overlayLabelY}%`, left: `${overlayLabelX}%`, transform: overlayLabelTransform, pointerEvents: 'none' }}>
                    <div style={{ background: '#7B1E2B', color: 'white', fontWeight: 700, fontSize: '0.85rem', padding: '4px 12px', borderRadius: 999, whiteSpace: 'nowrap', boxShadow: '0 2px 6px rgba(123,30,43,0.35)' }}>{tr(labelText, lang)}</div>
                  </div>
                </React.Fragment>
              )}
            </div>
            {!captionAboveImage && !overlayOnImage && mine && (
              <div style={{ textAlign: 'center', color: 'white', fontWeight: 700, fontSize: '0.9rem', marginTop: 10 }}>📍 {tr(labelText, lang)}</div>
            )}
          </div>
          <button
            onClick={() => setZoomed(false)}
            style={{ position: 'absolute', top: 20, insetInlineEnd: 20, width: 40, height: 40, borderRadius: '50%', border: 'none', background: 'white', color: '#1f2937', fontSize: '1.2rem', cursor: 'pointer', fontWeight: 700 }}
          >✕</button>
        </div>
      )}
    </div>
  );
}

const CATEGORY_COLORS = {
  'תב"ע':                 { bg: '#7c3aed', light: '#f5f3ff', border: '#ddd6fe' },
  'תכנית עיצוב אדריכלי': { bg: '#1d4ed8', light: '#eff6ff', border: '#bfdbfe' },
  'היתר בנייה':           { bg: '#15803d', light: '#f0fdf4', border: '#bbf7d0' },
};
const DEFAULT_COLOR = { bg: '#374151', light: '#f9fafb', border: '#e5e7eb' }

const STAGE_HIERARCHY = {
  'תכנון ואישור התב"ע מול העירייה': ['תכנון התב"ע מול העירייה', 'פורום מהנדס העיר (תב"ע)', 'סבב הערות לתוכנית'],
  'תכנון ואישור התבע מול העירייה': ['תכנון התב"ע מול העירייה', 'פורום מהנדס העיר (תב"ע)', 'סבב הערות לתוכנית'],
  'דיון להפקדה בועדה המקומית ומתן תוקף': ['הפקדה להתנגדויות', 'אישור התכנית למתן תוקף'],
};
const ALL_CHILD_NAMES_TENANT = new Set(Object.values(STAGE_HIERARCHY).flat());;

const STATUS_LABELS = { pending: 'טרם התחיל', active: 'בביצוע', completed: 'הושלם' };
const STATUS_STYLES = {
  pending:   { bg: '#f3f4f6', text: '#6b7280', border: '#e5e7eb' },
  active:    { bg: '#dbeafe', text: '#1d4ed8', border: '#bfdbfe' },
  completed: { bg: '#dcfce7', text: '#15803d', border: '#bbf7d0' },
};

const TABS = [
  { id: 'home',          key: 'tab_home',          icon: 'home' },
  { id: 'my-apartment',  key: 'tab_myApt',         icon: 'my-apartment' },
  { id: 'stages',        key: 'tab_stages',        icon: 'stages' },
  { id: 'announcements', key: 'tab_announcements', icon: 'announcements' },
  { id: 'events',        key: 'tab_events',        icon: 'events' },
  { id: 'gallery',       key: 'tab_gallery',       icon: 'gallery' },
  { id: 'contacts',      key: 'tab_contacts',      icon: 'contacts' },
  { id: 'files',         key: 'tab_files',         icon: 'files' },
  { id: 'about-manhelet', key: 'tab_about_manhelet', icon: 'about' },
  { id: 'about',         key: 'tab_about',         icon: 'about' },
];

const TRANSLATIONS = {
  he: {
    tab_home: 'בית', tab_myApt: 'הדירה שלי', tab_newComp: 'תמורות חדשות', tab_stages: 'שלבים',
    tab_announcements: 'הודעות', tab_gallery: 'גלריית תמונות', tab_events: 'כנסים',
    tab_contacts: 'אנשי קשר', tab_files: 'קבצים', tab_about: 'אודות היזם', tab_about_manhelet: 'אודות המנהלת',
    event_rsvp_question: 'האם תגיע/י?', event_attending: '✅ אישרת הגעה', event_not_attending: '❌ ציינת שלא תגיע',
    event_btn_attending: '✅ מגיע/ה', event_btn_not_attending: '❌ לא מגיע/ה', event_change_answer: 'לשנות תשובה',
    event_btn_unknown: 'עדיין לא יודע/ת', event_unknown: 'ציינת שעדיין לא ידוע',
    no_events: 'אין כנסים כרגע',
    status_pending: 'טרם התחיל', status_active: 'בביצוע', status_completed: 'הושלם',
    hello: 'שלום', logout: 'התנתק', logout_mobile: 'התנתק', back_to_projects: 'לרשימת הפרויקטים',
    my_apt_title: 'פרטי הדירה שלי', apt_data: 'נתוני הדירה',
    col_current: 'נוכחי', col_new: 'חדש',
    apt_size: 'שטח דירה', floor: 'קומה', balcony: 'שטח מרפסת שמש חדשה',
    parking: 'חנייה בטאבו', storage: 'מחסן בטאבו',
    project: 'פרויקט', address: 'כתובת', apt_number: 'מספר דירה', name_label: 'שם',
    per_plan: 'בהתאם לתוכנית שתאושר',
    ann_general: '📢 כלליות', ann_personal: '👤 אישיות', no_ann: 'אין הודעות בקטגוריה זו',
    file_general: 'כללי', file_personal: 'אישי', no_files: 'אין קבצים עדיין',
    view: '👁 צפה', download: '⬇ הורד',
    no_contacts: 'אין אנשי קשר עדיין',
    last_ann: '📢 הודעה אחרונה', current_stage: '📊 שלב נוכחי בפרויקט',
    tasks: 'משימות', task_pending: '⏳ ממתין', task_done: '✅ בוצע',
    building_specs: 'מפרט בניין', apt_specs: 'מפרט דירה',
    no_content: 'אין תוכן עדיין',
    to_website: 'לאתר 🌐', to_article: 'לכתבה המלאה 🌐',
    company_desc: '👑 תיאור החברה', projects_label: '📌 פרויקטים', press_label: '📰 מן העיתונות',
    stages_count: 'שלבי פרויקט', of_n_stages: 'מתוך {n} שלבים', overall_progress: 'התקדמות כללית', current_stage_word: 'שלב',
    view_link: 'לצפייה ←', all_services: 'כל השירותים ←',
    old_new_compare: 'הדירה הישנה מול הדירה החדשה', old_apt: 'הדירה הישנה', new_apt: 'הדירה החדשה',
    located_in_building: 'הנך ממוקם בבניין',
    size_sqm: 'שטח (מ"ר)', balcony_sqm: 'מרפסת שמש (מ"ר)', storage_sqm: 'מחסן (מ"ר)',
    change_note: 'יתכנו שינויים בהתאם לאילוצי תכנון של היזם', change_note2: 'על פי הנתונים הקיימים במנהלת הפרויקט', apt_of: 'הדירה של', apt_word: 'דירה',
    tech_spec_title: 'עיקרי המפרט הטכני', building_docs: 'מסמכי בניין', personal_docs: 'מסמכים אישיים', view_full_agreement: '📋 צפה בהסכם המלא / הורד', link_to_website: 'קישור לאתר', full_article: 'לכתבה המלאה ←', all_word: 'הכל',
    we_are_at_stage: 'אנחנו בשלב', project_completed: 'הפרויקט הושלם!', project_starting: 'הפרויקט בהתחלה', no_stages_yet: 'אין שלבים עדיין',
    send_to_manager_btn: '✉️ הודעה למנהל פרויקט', ann_search_placeholder: '🔍 חפש הודעה לפי מילה או תאריך (למשל 23.8)',
    send_msg_modal_title: '✉️ שליחת הודעה למנהל פרויקט', send_to_label: 'שלח אל:', all_project_managers: 'כל מנהלי הפרויקט',
    msg_placeholder: 'כתוב את הודעתך כאן...', send_msg_btn: 'שלח הודעה', sending_msg: 'שולח...', cancel_btn: 'ביטול', msg_sent: '✅ ההודעה נשלחה!',
    no_gallery_images: 'אין תמונות בקטגוריה זו', files_search_placeholder: '🔍 חפש קובץ לפי שם או תאריך (למשל פרוטוקול)', no_matching_files: 'לא נמצאו קבצים תואמים',
    personal_note: 'קצת אישי', projects_heading: 'פרויקטים', press_heading: 'מן העיתונות',
  },
  en: {
    tab_home: 'Home', tab_myApt: 'My Apartment', tab_newComp: 'New Compensation', tab_stages: 'Stages',
    tab_announcements: 'Announcements', tab_gallery: 'Gallery', tab_events: 'Events',
    event_rsvp_question: 'Will you attend?', event_attending: '✅ You confirmed attendance', event_not_attending: "❌ You said you won't attend",
    event_btn_attending: '✅ Attending', event_btn_not_attending: '❌ Not attending', event_change_answer: 'Change answer',
    event_btn_unknown: "Don't know yet", event_unknown: "You marked you don't know yet",
    no_events: 'No events right now',
    tab_contacts: 'Contacts', tab_files: 'Files', tab_about: 'About Developer', tab_about_manhelet: 'About Management',
    status_pending: 'Not Started', status_active: 'In Progress', status_completed: 'Completed',
    hello: 'Hello', logout: 'Logout', logout_mobile: 'Logout', back_to_projects: 'Back to Projects',
    my_apt_title: 'My Apartment Details', apt_data: 'Apartment Data',
    col_current: 'Current', col_new: 'New',
    apt_size: 'Apartment Size', floor: 'Floor', balcony: 'New Balcony Size',
    parking: 'Parking (Tabu)', storage: 'Storage (Tabu)',
    project: 'Project', address: 'Address', apt_number: 'Apt No.', name_label: 'Name',
    per_plan: 'Per approved plan',
    ann_general: '📢 General', ann_personal: '👤 Personal', no_ann: 'No messages in this category',
    file_general: 'General', file_personal: 'Personal', no_files: 'No files yet',
    view: '👁 View', download: '⬇ Download',
    no_contacts: 'No contacts yet',
    last_ann: '📢 Latest Announcement', current_stage: '📊 Current Stage',
    tasks: 'Tasks', task_pending: '⏳ Pending', task_done: '✅ Done',
    building_specs: 'Building Specs', apt_specs: 'Apartment Specs',
    no_content: 'No content yet',
    to_website: 'Website 🌐', to_article: 'Full article 🌐',
    company_desc: '👑 Company Description', projects_label: '📌 Projects', press_label: '📰 Press',
    stages_count: 'Project Stages', of_n_stages: 'of {n} stages', overall_progress: 'Overall Progress', current_stage_word: 'Stage',
    view_link: 'View →', all_services: 'All services →',
    old_new_compare: 'Old Apartment vs New Apartment', old_apt: 'Old Apartment', new_apt: 'New Apartment',
    located_in_building: 'You are located in building',
    size_sqm: 'Size (sqm)', balcony_sqm: 'Balcony (sqm)', storage_sqm: 'Storage (sqm)',
    change_note: 'Changes may occur due to developer planning constraints', change_note2: 'Based on existing data in the project management system', apt_of: 'Apartment of', apt_word: 'Apt',
    tech_spec_title: 'Main Technical Specifications', building_docs: 'Building Documents', personal_docs: 'Personal Documents', view_full_agreement: '📋 View Full Agreement / Download', link_to_website: 'Website Link', full_article: 'Full Article →', all_word: 'All',
    we_are_at_stage: 'We are at the stage of', project_completed: 'The project is complete!', project_starting: 'The project is starting', no_stages_yet: 'No stages yet',
    send_to_manager_btn: '✉️ Message to Project Manager', ann_search_placeholder: '🔍 Search message by word or date (e.g. 23.8)',
    send_msg_modal_title: '✉️ Send Message to Project Manager', send_to_label: 'Send to:', all_project_managers: 'All project managers',
    msg_placeholder: 'Write your message here...', send_msg_btn: 'Send Message', sending_msg: 'Sending...', cancel_btn: 'Cancel', msg_sent: '✅ Message sent!',
    no_gallery_images: 'No images in this category', files_search_placeholder: '🔍 Search file by name or date (e.g. protocol)', no_matching_files: 'No matching files found',
    personal_note: 'A Bit Personal', projects_heading: 'Projects', press_heading: 'Press',
  },
  ru: {
    tab_home: 'Главная', tab_myApt: 'Моя квартира', tab_newComp: 'Новая компенсация', tab_stages: 'Этапы',
    tab_announcements: 'Объявления', tab_gallery: 'Галерея', tab_events: 'Мероприятия',
    event_rsvp_question: 'Вы придёте?', event_attending: '✅ Вы подтвердили участие', event_not_attending: '❌ Вы отметили, что не придёте',
    event_btn_attending: '✅ Приду', event_btn_not_attending: '❌ Не приду', event_change_answer: 'Изменить ответ',
    event_btn_unknown: 'Пока не знаю', event_unknown: 'Вы отметили, что пока не знаете',
    no_events: 'Пока нет мероприятий',
    tab_contacts: 'Контакты', tab_files: 'Файлы', tab_about: 'О проекте', tab_about_manhelet: 'Об управляющей компании',
    status_pending: 'Не начат', status_active: 'В процессе', status_completed: 'Завершён',
    hello: 'Привет', logout: 'Выйти', logout_mobile: 'Выйти', back_to_projects: 'К списку проектов',
    my_apt_title: 'Данные моей квартиры', apt_data: 'Данные квартиры',
    col_current: 'Текущее', col_new: 'Новое',
    apt_size: 'Площадь квартиры', floor: 'Этаж', balcony: 'Площадь балкона',
    parking: 'Парковка (табу)', storage: 'Кладовая (табу)',
    project: 'Проект', address: 'Адрес', apt_number: '№ квартиры', name_label: 'Имя',
    per_plan: 'По утверждённому плану',
    ann_general: '📢 Общие', ann_personal: '👤 Личные', no_ann: 'Нет сообщений в этой категории',
    file_general: 'Общие', file_personal: 'Личные', no_files: 'Файлов пока нет',
    view: '👁 Смотреть', download: '⬇ Скачать',
    no_contacts: 'Контактов пока нет',
    last_ann: '📢 Последнее объявление', current_stage: '📊 Текущий этап',
    tasks: 'Задачи', task_pending: '⏳ Ожидание', task_done: '✅ Выполнено',
    building_specs: 'Харак. здания', apt_specs: 'Харак. квартиры',
    no_content: 'Контент пока отсутствует',
    to_website: 'Сайт 🌐', to_article: 'Читать 🌐',
    company_desc: '👑 О компании', projects_label: '📌 Проекты', press_label: '📰 Пресса',
    stages_count: 'Этапы проекта', of_n_stages: 'из {n} этапов', overall_progress: 'Общий прогресс', current_stage_word: 'Этап',
    view_link: 'Смотреть →', all_services: 'Все услуги →',
    old_new_compare: 'Старая квартира и новая квартира', old_apt: 'Старая квартира', new_apt: 'Новая квартира',
    located_in_building: 'Вы находитесь в здании',
    size_sqm: 'Площадь (м²)', balcony_sqm: 'Балкон (м²)', storage_sqm: 'Кладовая (м²)',
    change_note: 'Возможны изменения в связи с планировочными ограничениями застройщика', change_note2: 'По данным, имеющимся в дирекции проекта', apt_of: 'Квартира', apt_word: 'кв.',
    tech_spec_title: 'Основные технические характеристики', building_docs: 'Документы здания', personal_docs: 'Личные документы', view_full_agreement: '📋 Посмотреть полное соглашение / Скачать', link_to_website: 'Ссылка на сайт', full_article: 'Полная статья →', all_word: 'Все',
    we_are_at_stage: 'Мы на этапе', project_completed: 'Проект завершён!', project_starting: 'Проект начинается', no_stages_yet: 'Пока нет этапов',
    send_to_manager_btn: '✉️ Сообщение менеджеру проекта', ann_search_placeholder: '🔍 Поиск сообщения по слову или дате (например 23.8)',
    send_msg_modal_title: '✉️ Отправить сообщение менеджеру проекта', send_to_label: 'Отправить:', all_project_managers: 'Все менеджеры проекта',
    msg_placeholder: 'Напишите ваше сообщение здесь...', send_msg_btn: 'Отправить сообщение', sending_msg: 'Отправка...', cancel_btn: 'Отмена', msg_sent: '✅ Сообщение отправлено!',
    no_gallery_images: 'Нет изображений в этой категории', files_search_placeholder: '🔍 Поиск файла по имени или дате (например протокол)', no_matching_files: 'Совпадающих файлов не найдено',
    personal_note: 'Немного личного', projects_heading: 'Проекты', press_heading: 'Пресса',
  },
  // Amharic — authored directly rather than through the tr() AI-translation
  // pipeline used for free text below. Worth a native-speaker proofread
  // before relying on it, same caveat as any machine-produced Amharic.
  am: {
    tab_home: 'ቤት', tab_myApt: 'የእኔ አፓርታማ', tab_newComp: 'አዲስ ካሳ', tab_stages: 'ደረጃዎች',
    tab_announcements: 'ማስታወቂያዎች', tab_gallery: 'ማዕከለ-ስዕላት', tab_events: 'ዝግጅቶች',
    event_rsvp_question: 'ትገኛለህ/ትገኛለሽ?', event_attending: '✅ መገኘትህን አረጋግጠሃል', event_not_attending: '❌ እንደማትገኝ ገልጸሃል',
    event_btn_attending: '✅ እገኛለሁ', event_btn_not_attending: '❌ አልገኝም', event_change_answer: 'መልስ ቀይር',
    event_btn_unknown: 'እስካሁን አላውቅም', event_unknown: 'እስካሁን እንደማታውቅ ገልጸሃል',
    no_events: 'ምንም ዝግጅት የለም',
    tab_contacts: 'እውቂያዎች', tab_files: 'ፋይሎች', tab_about: 'ስለ ገንቢው', tab_about_manhelet: 'ስለ አስተዳደር',
    status_pending: 'ገና አልጀመረም', status_active: 'በሂደት ላይ', status_completed: 'ተጠናቅቋል',
    hello: 'ሰላም', logout: 'ውጣ', logout_mobile: 'ውጣ', back_to_projects: 'ወደ ፕሮጀክቶች ዝርዝር',
    my_apt_title: 'የአፓርታማዬ ዝርዝሮች', apt_data: 'የአፓርታማ መረጃ',
    col_current: 'የአሁኑ', col_new: 'አዲስ',
    apt_size: 'የአፓርታማ ስፋት', floor: 'ወለል', balcony: 'አዲስ የፀሐይ በረንዳ ስፋት',
    parking: 'ማቆሚያ (ታቡ)', storage: 'መጋዘን (ታቡ)',
    project: 'ፕሮጀክት', address: 'አድራሻ', apt_number: 'የአፓርታማ ቁጥር', name_label: 'ስም',
    per_plan: 'በሚፀድቀው ዕቅድ መሠረት',
    ann_general: '📢 አጠቃላይ', ann_personal: '👤 የግል', no_ann: 'በዚህ ምድብ ውስጥ መልዕክቶች የሉም',
    file_general: 'አጠቃላይ', file_personal: 'የግል', no_files: 'እስካሁን ፋይሎች የሉም',
    view: '👁 ይመልከቱ', download: '⬇ አውርድ',
    no_contacts: 'እስካሁን እውቂያዎች የሉም',
    last_ann: '📢 የመጨረሻ ማስታወቂያ', current_stage: '📊 የአሁኑ የፕሮጀክት ደረጃ',
    tasks: 'ተግባራት', task_pending: '⏳ በመጠባበቅ ላይ', task_done: '✅ ተጠናቅቋል',
    building_specs: 'የሕንፃ ዝርዝር', apt_specs: 'የአፓርታማ ዝርዝር',
    no_content: 'እስካሁን ይዘት የለም',
    to_website: 'ወደ ድህረ ገጽ 🌐', to_article: 'ወደ ሙሉ ጽሁፍ 🌐',
    company_desc: '👑 የኩባንያ መግለጫ', projects_label: '📌 ፕሮጀክቶች', press_label: '📰 ከፕሬስ',
    stages_count: 'የፕሮጀክት ደረጃዎች', of_n_stages: 'ከ{n} ደረጃዎች ውስጥ', overall_progress: 'አጠቃላይ እድገት', current_stage_word: 'ደረጃ',
    view_link: 'ለማየት ←', all_services: 'ሁሉም አገልግሎቶች ←',
    old_new_compare: 'የቀድሞ አፓርታማ ከአዲሱ አፓርታማ ጋር ማወዳደር', old_apt: 'የቀድሞ አፓርታማ', new_apt: 'አዲሱ አፓርታማ',
    located_in_building: 'እርስዎ በሚከተለው ሕንፃ ውስጥ ይገኛሉ',
    size_sqm: 'ስፋት (ካሬ ሜትር)', balcony_sqm: 'በረንዳ (ካሬ ሜትር)', storage_sqm: 'መጋዘን (ካሬ ሜትር)',
    change_note: 'በገንቢው የዕቅድ ገደቦች ምክንያት ለውጦች ሊኖሩ ይችላሉ', change_note2: 'በፕሮጀክት አስተዳደር ውስጥ ባለው መረጃ መሠረት', apt_of: 'አፓርታማ የ', apt_word: 'አፓርታማ',
    tech_spec_title: 'ዋና ቴክኒካዊ ዝርዝሮች', building_docs: 'የሕንፃ ሰነዶች', personal_docs: 'የግል ሰነዶች', view_full_agreement: '📋 ሙሉ ስምምነቱን ይመልከቱ / ያውርዱ', link_to_website: 'የድህረ ገጽ አገናኝ', full_article: 'ሙሉ ጽሁፍ ←', all_word: 'ሁሉም',
    we_are_at_stage: 'እኛ በሚከተለው ደረጃ ላይ ነን', project_completed: 'ፕሮጀክቱ ተጠናቅቋል!', project_starting: 'ፕሮጀክቱ በመጀመር ላይ ነው', no_stages_yet: 'እስካሁን ደረጃዎች የሉም',
    send_to_manager_btn: '✉️ ለፕሮጀክት ስራ አስኪያጅ መልዕክት', ann_search_placeholder: '🔍 በቃል ወይም በቀን ማስታወቂያ ይፈልጉ (ለምሳሌ 23.8)',
    send_msg_modal_title: '✉️ ለፕሮጀክት ስራ አስኪያጅ መልዕክት መላክ', send_to_label: 'ላክ ወደ:', all_project_managers: 'ሁሉም የፕሮጀክት ስራ አስኪያጆች',
    msg_placeholder: 'መልዕክትዎን እዚህ ይጻፉ...', send_msg_btn: 'መልዕክት ላክ', sending_msg: 'በመላክ ላይ...', cancel_btn: 'ይቅር', msg_sent: '✅ መልዕክቱ ተልኳል!',
    no_gallery_images: 'በዚህ ምድብ ውስጥ ምስሎች የሉም', files_search_placeholder: '🔍 በስም ወይም በቀን ፋይል ይፈልጉ (ለምሳሌ ፕሮቶኮል)', no_matching_files: 'ምንም ተመሳሳይ ፋይሎች አልተገኙም',
    personal_note: 'ትንሽ የግል', projects_heading: 'ፕሮጀክቶች', press_heading: 'ፕሬስ',
  },
};

const GALLERY_CATS = ['הכל', 'הדמיות פרויקטים', 'כנסים ומפגשים', 'בשכונה'];

// Picks the Claude-translated field (e.g. title_en/title_ru) when the tenant's
// selected language isn't Hebrew and a translation exists; falls back to the
// original Hebrew field otherwise (untranslated content, or lang === 'he').
function localize(obj, field, lang) {
  if (lang && lang !== 'he' && obj[`${field}_${lang}`]) return obj[`${field}_${lang}`];
  // Amharic has no dedicated DB column (en/ru do) — route it through the
  // generic on-demand translator instead of falling back to Hebrew.
  if (lang === 'am') return tr(obj[field], lang);
  return obj[field];
}

// ── Generic free-text translation (addresses, project names, gallery captions,
// contact names/roles, about-section content — anything with no dedicated
// DB column for translations). Module-level cache survives across the whole
// tab session; a short debounce batches every tr() call from one render pass
// into a single API request instead of one per string.
const _trCache = new Map(); // key: `${lang}::${text}` -> translated text
const _trPending = { texts: new Set(), lang: null, timer: null };
const _trSubscribers = new Set();
function _trBumpVersion() { _trSubscribers.forEach(fn => fn()); }
function _trFlush() {
  const lang = _trPending.lang;
  const list = Array.from(_trPending.texts);
  _trPending.texts = new Set();
  _trPending.timer = null;
  if (!list.length || !lang) return;
  api.post('/portal/translate-text', { texts: list, lang })
    .then(r => {
      list.forEach((txt, i) => _trCache.set(`${lang}::${txt}`, (r.data.translations && r.data.translations[i]) || txt));
      _trBumpVersion();
    })
    .catch(() => {
      // Do NOT cache the Hebrew fallback on failure — caching it here would
      // permanently poison this string for the rest of the session (the Map
      // never expires), so a single flaky request would silently block that
      // text from ever translating again until a full page reload.
      _trBumpVersion();
    });
}
// Reads (and lazily queues) a translation. Returns the Hebrew original
// immediately while the batch is in flight — the subscribing component
// re-renders once the cache fills in via useAutoTranslateSync().
function tr(text, lang) {
  if (!text || !lang || lang === 'he') return text;
  const key = `${lang}::${text}`;
  if (_trCache.has(key)) return _trCache.get(key);
  _trPending.lang = lang;
  _trPending.texts.add(text);
  if (!_trPending.timer) _trPending.timer = setTimeout(_trFlush, 120);
  return text;
}
// Call once, unconditionally, near the top of a component that uses tr() —
// forces a re-render whenever any translation batch resolves.
function useAutoTranslateSync() {
  const [, forceUpdate] = useState(0);
  useEffect(() => {
    const fn = () => forceUpdate(n => n + 1);
    _trSubscribers.add(fn);
    return () => _trSubscribers.delete(fn);
  }, []);
}

// תב"ע is a planning-law acronym with no real translation — transliterate it
// literally instead of letting the AI translator guess at an English gloss.
const CATEGORY_LABEL_OVERRIDE = { 'תב"ע': { en: 'TB"A', ru: 'ТБ"А', am: 'ቲቢ"ኤ' } };
function categoryLabel(cat, lang) {
  if (lang && lang !== 'he' && CATEGORY_LABEL_OVERRIDE[cat]?.[lang]) return CATEGORY_LABEL_OVERRIDE[cat][lang];
  return tr(cat, lang);
}

function stripExt(name) { return name ? name.replace(/\.[^/.]+$/, '') : ''; }
// A file's stored name sometimes lacks its extension (legacy uploads, or admin
// renames that stripped it) — download it with the real extension from the S3
// URL, or the browser has no extension to key off and mangles duplicate-name
// suffixes (inserting " (1)" inside the filename instead of before the ext).
function downloadFilename(displayName, url) {
  const urlExt = (url.match(/\.([a-zA-Z0-9]+)(?:\?|$)/) || [])[1];
  const hasExt = /\.[a-zA-Z0-9]{2,5}$/.test(displayName || '');
  return hasExt || !urlExt ? (displayName || 'file') : `${displayName || 'file'}.${urlExt}`;
}
function imgUrl(url) {
  if (!url || url.startsWith('data:')) return url;
  // Strip any existing ?auth= param
  const clean = url.split('?')[0];
  return clean.startsWith('/uploads') ? `https://mabat.communityltd.co.il${clean}` : clean;
}
function RichText({ text }) {
  if (!text) return null;
  return (
    <span style={{ whiteSpace: 'pre-wrap' }}>
      {text.split(/(\*\*[^*]+\*\*)/).map((seg, i) =>
        seg.startsWith('**') && seg.endsWith('**')
          ? <strong key={i}>{seg.slice(2, -2)}</strong>
          : seg
      )}
    </span>
  );
}

const TENANT_RSVP_STATUS_INFO = {
  attending: { bg: '#dcfce7', text: '#15803d' },
  not_attending: { bg: '#fee2e2', text: '#b91c1c' },
};

// event_date is a naive "YYYY-MM-DD HH:mm:ss" wall-clock string (no
// timezone) — parsing it with `new Date(...)` and letting toLocaleString
// apply the browser's own timezone is unreliable across browsers, so format
// it directly from its components instead.
function formatEventDateFull(raw) {
  const m = String(raw || '').match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
  if (!m) return '';
  const [, y, mo, d, h, mi] = m;
  const dateStr = new Date(+y, +mo - 1, +d).toLocaleDateString('he-IL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  return `${dateStr} בשעה ${h}:${mi}`;
}

function EventsSection({ phone, projectName, t }) {
  const [events, setEvents] = useState([]);
  const [saving, setSaving] = useState(null); // event_id currently saving
  // The DB default for "never answered" is also 'unknown', so an explicit
  // "still don't know" click needs its own tracking to show a confirmation
  // instead of silently looking identical to not having answered at all.
  const [unknownAcked, setUnknownAcked] = useState(() => new Set());

  useEffect(() => {
    if (!phone || !projectName) return;
    api.get(`/portal/events/for-tenant/${encodeURIComponent(projectName)}/${encodeURIComponent(phone)}`, { headers: getTenantHeaders() })
      .then(r => {
        const list = r.data || [];
        setEvents(list);
        setUnknownAcked(new Set(list.filter(e => e.status === 'unknown' && e.responded_at).map(e => e.event_id)));
      }).catch(() => {});
  }, [phone, projectName]);

  async function respond(eventId, status) {
    setSaving(eventId);
    try {
      await api.post(`/portal/events/rsvp/${encodeURIComponent(projectName)}/${encodeURIComponent(phone)}`, { event_id: eventId, status }, { headers: getTenantHeaders() });
      setEvents(p => p.map(e => e.event_id === eventId ? { ...e, status } : e));
      setUnknownAcked(prev => {
        const next = new Set(prev);
        if (status === 'unknown') next.add(eventId); else next.delete(eventId);
        return next;
      });
    } catch {}
    setSaving(null);
  }

  if (events.length === 0) return <p style={{ color: '#9ca3af', textAlign: 'center' }}>{t('no_events')}</p>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {events.map(ev => (
        <div key={ev.event_id} style={{ background: 'white', borderRadius: 14, padding: 18, border: '1px solid #e5e7eb', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <div style={{ fontWeight: 700, color: '#1f2937', fontSize: '1.02rem' }}>{ev.title}</div>
          {ev.event_date && (
            <div style={{ color: '#6b7280', fontSize: '0.85rem', marginTop: 2 }}>
              {formatEventDateFull(ev.event_date)}
            </div>
          )}
          {ev.description && <div style={{ color: '#374151', fontSize: '0.88rem', marginTop: 8 }}>{ev.description}</div>}
          {ev.pdf_url && (
            <a href={ev.pdf_url} target="_blank" rel="noreferrer" style={{ display: 'inline-block', marginTop: 8, color: '#1d4ed8', fontWeight: 600, fontSize: '0.85rem', textDecoration: 'underline' }}>
              📄 מודעת הכנס
            </a>
          )}

          {ev.status && ev.status !== 'unknown' ? (
            <div style={{ marginTop: 12 }}>
              <div style={{
                display: 'inline-block', borderRadius: 10, padding: '8px 14px', fontWeight: 700, fontSize: '0.9rem',
                background: TENANT_RSVP_STATUS_INFO[ev.status]?.bg, color: TENANT_RSVP_STATUS_INFO[ev.status]?.text,
              }}>
                {ev.status === 'attending' ? t('event_attending') : t('event_not_attending')}
              </div>
              <button onClick={() => setEvents(p => p.map(e => e.event_id === ev.event_id ? { ...e, status: 'unknown' } : e))}
                style={{ display: 'block', marginTop: 6, background: 'none', border: 'none', color: '#9ca3af', fontSize: '0.78rem', textDecoration: 'underline', cursor: 'pointer' }}>
                {t('event_change_answer')}
              </button>
            </div>
          ) : unknownAcked.has(ev.event_id) ? (
            <div style={{ marginTop: 12 }}>
              <div style={{ display: 'inline-block', borderRadius: 10, padding: '8px 14px', fontWeight: 700, fontSize: '0.9rem', background: '#fef9c3', color: '#a16207' }}>
                🤷 {t('event_unknown')}
              </div>
              <button onClick={() => setUnknownAcked(prev => { const n = new Set(prev); n.delete(ev.event_id); return n; })}
                style={{ display: 'block', marginTop: 6, background: 'none', border: 'none', color: '#9ca3af', fontSize: '0.78rem', textDecoration: 'underline', cursor: 'pointer' }}>
                {t('event_change_answer')}
              </button>
            </div>
          ) : (
            <>
              <div style={{ fontWeight: 600, color: '#1f2937', marginTop: 10, marginBottom: 8 }}>{t('event_rsvp_question')}</div>
              <div style={{ display: 'flex', gap: 10 }}>
                <button disabled={saving === ev.event_id} onClick={() => respond(ev.event_id, 'attending')}
                  style={{ flex: 1, background: '#15803d', color: 'white', border: 'none', padding: '10px 0', borderRadius: 10, cursor: 'pointer', fontWeight: 700 }}>
                  {t('event_btn_attending')}
                </button>
                <button disabled={saving === ev.event_id} onClick={() => respond(ev.event_id, 'not_attending')}
                  style={{ flex: 1, background: '#dc2626', color: 'white', border: 'none', padding: '10px 0', borderRadius: 10, cursor: 'pointer', fontWeight: 700 }}>
                  {t('event_btn_not_attending')}
                </button>
              </div>
              <button disabled={saving === ev.event_id} onClick={() => respond(ev.event_id, 'unknown')}
                style={{ width: '100%', marginTop: 8, background: '#fef9c3', color: '#a16207', border: 'none', padding: '9px 0', borderRadius: 10, cursor: 'pointer', fontWeight: 700, fontSize: '0.9rem' }}>
                🤷 {t('event_btn_unknown')}
              </button>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

const THREAD_KEY = 'התכתבות';
function AnnouncementsSection({ announcements, t, projectName, lang }) {
  const [cat, setCat] = useState('כללי');
  const [showMsgModal, setShowMsgModal] = useState(false);
  const [workers, setWorkers] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState('');
  const [msgText, setMsgText] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const myPhone = (localStorage.getItem('tenantPhone') || '').replace(/[\s\-]/g, '');
  const myName = localStorage.getItem('tenantName') || '';

  function isForMe(a) {
    if (!a.recipient || !a.recipient.startsWith('specific:')) return true;
    const recipientPhones = a.recipient.replace('specific:', '').split(',').map(p => p.replace(/[\s\-]/g, '')).filter(Boolean);
    return recipientPhones.includes(myPhone);
  }
  const visibleAnnouncements = announcements.filter(isForMe);
  function getEffectiveCat(a) {
    if (a.recipient && a.recipient.startsWith('specific:')) return 'אישי';
    return a.category || 'כללי';
  }
  const [annSearch, setAnnSearch] = useState('');
  function announcementMatchesSearch(a, q) {
    if (!q) return true;
    const query = q.trim().toLowerCase();
    if (!query) return true;
    const text = `${a.title || ''} ${a.body || ''}`.toLowerCase();
    const words = query.split(/\s+/).filter(Boolean);
    if (words.every(w => text.includes(w))) return true;
    if (!a.published_at) return false;
    const d = new Date(a.published_at.replace(' ', 'T'));
    const dateStr = d.toLocaleDateString('he-IL'); // e.g. 23.8.2026
    return dateStr.includes(query);
  }
  const filtered = visibleAnnouncements.filter(a => getEffectiveCat(a) === cat && announcementMatchesSearch(a, annSearch));
  const tabs = [
    { key: 'כללי', label: t('ann_general') },
    { key: 'אישי', label: t('ann_personal') },
    { key: THREAD_KEY, label: '💬 ההתכתבות שלי' },
  ];
  // my messages to the project managers and their answers
  const [thread, setThread] = useState([]);
  const unseenReplies = thread.filter(m => m.reply_text && !m.reply_seen_at).length;
  // conversations: a root message, its answer, then the follow-ups that continue it
  const threadIds = new Set(thread.map(m => m.id));
  const threadRoots = thread.filter(m => !m.parent_id || !threadIds.has(m.parent_id));
  const childrenOf = id => thread.filter(m => m.parent_id === id).sort((x, y) => String(x.created_at).localeCompare(String(y.created_at)));
  const [followTo, setFollowTo] = useState(null);
  const [followText, setFollowText] = useState('');
  const [followSending, setFollowSending] = useState(false);
  const fmtT = d => d ? new Date(String(d).replace(' ', 'T') + 'Z').toLocaleString('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jerusalem' }) : '';
  async function sendFollowUp(parent) {
    if (!followText.trim() || followSending) return;
    setFollowSending(true);
    try {
      if (localStorage.getItem('tenantIsAdminPreview') !== '1') {
        await api.post('/portal/tenant-message', { project_name: projectName, from_phone: myPhone, from_name: myName, to_worker: null, message: followText.trim(), parent_id: parent.id }, { headers: getTenantHeaders() });
      }
      setFollowTo(null); setFollowText(''); loadThread();
    } catch {} finally { setFollowSending(false); }
  }
  function renderThreadNode(m) {
    const kids = childrenOf(m.id);
    return (
      <div key={m.id} style={{ marginBottom: kids.length ? 12 : 0 }}>
        <div style={{ fontSize: '0.75rem', color: '#9ca3af', marginBottom: 4 }}>ההודעה שלך · {fmtT(m.created_at)}</div>
        <div style={{ background: '#f9fafb', borderRadius: 12, padding: '10px 12px', color: '#4b5563', whiteSpace: 'pre-wrap', marginBottom: 10 }}>{m.message}</div>
        {m.reply_text ? (
          <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 12, padding: '10px 12px', marginBottom: 10 }}>
            <div style={{ fontSize: '0.75rem', color: '#1d4ed8', fontWeight: 700, marginBottom: 4 }}>התשובה{m.reply_by ? ' מ' + m.reply_by : ''} · {fmtT(m.replied_at)}</div>
            <div style={{ color: '#111827', whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{m.reply_text}</div>
          </div>
        ) : (
          <div style={{ fontSize: '0.82rem', color: '#a4864f' }}>⏳ ממתין לתשובה ממנהל הפרויקט</div>
        )}
        {kids.map(k => <div key={k.id} style={{ marginTop: 10, paddingInlineStart: 14, borderInlineStart: '3px solid #e5e7eb' }}>{renderThreadNode(k)}</div>)}
        {m.reply_text && kids.length === 0 && (followTo === m.id ? (
          <div style={{ marginTop: 4 }}>
            <textarea value={followText} onChange={e => setFollowText(e.target.value)} rows={3} placeholder="כתוב תגובה למנהל הפרויקט..."
              style={{ width: '100%', boxSizing: 'border-box', padding: 10, borderRadius: 10, border: '1.5px solid #d1d5db', fontFamily: 'inherit', fontSize: '0.92rem', resize: 'vertical' }} />
            <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
              <button onClick={() => sendFollowUp(m)} disabled={followSending || !followText.trim()}
                style={{ background: '#1a4a8a', color: 'white', border: 'none', borderRadius: 10, padding: '8px 18px', fontWeight: 700, cursor: 'pointer', opacity: (followSending || !followText.trim()) ? 0.6 : 1 }}>{followSending ? 'שולח...' : 'שלח תגובה'}</button>
              <button onClick={() => { setFollowTo(null); setFollowText(''); }}
                style={{ background: 'white', color: '#6b7280', border: '1px solid #d1d5db', borderRadius: 10, padding: '8px 16px', cursor: 'pointer' }}>ביטול</button>
            </div>
          </div>
        ) : (
          <button onClick={() => { setFollowTo(m.id); setFollowText(''); }}
            style={{ background: 'white', color: '#1a4a8a', border: '1.5px solid #1a4a8a', borderRadius: 10, padding: '6px 16px', fontWeight: 700, cursor: 'pointer', fontSize: '0.85rem' }}>↩ הגב</button>
        ))}
      </div>
    );
  }
  const loadThread = useCallback(() => {
    if (!myPhone) return;
    api.get(`/portal/tenant-replies?all=1&phone=${encodeURIComponent(myPhone)}&project=${encodeURIComponent(projectName)}`, { headers: tenantHeaders() })
      .then(r => setThread(r.data || [])).catch(() => {});
  }, [myPhone, projectName]); // eslint-disable-line
  useEffect(() => { loadThread(); }, [loadThread]);
  useEffect(() => {
    if (cat !== THREAD_KEY || !unseenReplies) return;
    api.post('/portal/tenant-replies/seen', { phone: myPhone }, { headers: tenantHeaders() })
      .then(() => setThread(prev => prev.map(m => m.reply_text && !m.reply_seen_at ? { ...m, reply_seen_at: 'now' } : m))).catch(() => {});
  }, [cat, unseenReplies]); // eslint-disable-line

  function tenantHeaders() {
    const t = localStorage.getItem('tenantToken');
    return t ? { Authorization: `Bearer ${t}` } : {};
  }

  async function openMsgModal() {
    setShowMsgModal(true); setSent(false); setMsgText(''); setSelectedWorker('');
    try {
      const r = await api.get(`/portal/project-workers/${encodeURIComponent(projectName)}`, { headers: tenantHeaders() });
      setWorkers(r.data || []);
      if (r.data?.length === 1) setSelectedWorker(r.data[0].userName);
    } catch {}
  }

  async function sendMsg() {
    if (!msgText.trim()) return;
    setSending(true);
    try {
      if (localStorage.getItem('tenantIsAdminPreview') !== '1') {
        await api.post('/portal/tenant-message', {
          project_name: projectName, from_phone: myPhone, from_name: myName,
          to_worker: selectedWorker || null, message: msgText.trim()
        }, { headers: getTenantHeaders() });
      } // admin "view as tenant" preview — don't actually send
      setSent(true);
      setTimeout(() => { setShowMsgModal(false); loadThread(); setCat(THREAD_KEY); }, 1500);
    } catch {} finally { setSending(false); }
  }

  return (
    <div>
      {/* Filter pills + כפתור שליחה */}
      <div style={{ display: 'flex', direction: 'rtl', justifyContent: 'flex-start', alignItems: 'center', gap: 10, marginBottom: 18, flexWrap: 'wrap' }}>
        {tabs.map(({ key, label }) => {
          const count = key === THREAD_KEY ? thread.length : visibleAnnouncements.filter(a => getEffectiveCat(a) === key).length;
          const active = cat === key;
          return (
            <button key={key} onClick={() => setCat(key)} style={{
              padding: '8px 18px', borderRadius: 16, border: 'none', cursor: 'pointer',
              fontWeight: 600, fontSize: '0.8rem',
              background: active ? '#c98a3f' : 'white',
              color: active ? 'white' : '#a4864f',
            }}>
              {label} ({count}){key === THREAD_KEY && unseenReplies > 0 && <span style={{ marginInlineStart: 6, background: '#dc2626', color: 'white', borderRadius: 10, padding: '1px 7px', fontSize: '0.7rem' }}>{unseenReplies} חדש</span>}
            </button>
          );
        })}
        <button onClick={openMsgModal} style={{
          padding: '8px 16px', borderRadius: 16, border: 'none', cursor: 'pointer',
          fontWeight: 600, fontSize: '0.8rem', background: '#1a4a8a', color: 'white',
        }}>
          {t('send_to_manager_btn')}
        </button>
      </div>

      {/* חיפוש הודעה — לפי מילה בהודעה או תאריך */}
      <div style={{ marginBottom: 16 }}>
        <input
          value={annSearch}
          onChange={e => setAnnSearch(e.target.value)}
          placeholder={t('ann_search_placeholder')}
          style={{
            width: '100%', padding: '10px 14px', borderRadius: 12, border: '1px solid #e3d5ac',
            fontSize: '0.85rem', outline: 'none', boxSizing: 'border-box', direction: 'rtl',
          }}
        />
      </div>

      {/* Modal שליחת הודעה */}
      {showMsgModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: 'white', borderRadius: 16, padding: 28, width: '100%', maxWidth: 420, direction: 'rtl' }}>
            <div style={{ fontWeight: 700, fontSize: '1.1rem', marginBottom: 20, color: '#1a4a8a' }}>{t('send_msg_modal_title')}</div>
            {sent ? (
              <div style={{ textAlign: 'center', color: '#15803d', fontSize: '1rem', padding: 20 }}>{t('msg_sent')}</div>
            ) : (<>
              {workers.length > 1 && (
                <div style={{ marginBottom: 14 }}>
                  <div style={{ fontSize: '0.85rem', color: '#6b7280', marginBottom: 6 }}>{t('send_to_label')}</div>
                  <select value={selectedWorker} onChange={e => setSelectedWorker(e.target.value)}
                    style={{ width: '100%', padding: '10px 12px', borderRadius: 10, border: '1.5px solid #d1d5db', fontSize: '0.95rem' }}>
                    <option value="">{t('all_project_managers')}</option>
                    {workers.map(w => (
                      <option key={w.userName} value={w.userName}>{w.workerFirstName} {w.workerLastName}</option>
                    ))}
                  </select>
                </div>
              )}
              <textarea value={msgText} onChange={e => setMsgText(e.target.value)}
                placeholder={t('msg_placeholder')}
                style={{ width: '100%', padding: '12px', borderRadius: 10, border: '1.5px solid #d1d5db', fontSize: '0.95rem', minHeight: 100, resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit' }}
              />
              <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
                <button onClick={sendMsg} disabled={sending || !msgText.trim()} style={{
                  flex: 1, padding: '11px', borderRadius: 10, border: 'none', cursor: 'pointer',
                  background: '#1a4a8a', color: 'white', fontWeight: 700, fontSize: '0.95rem',
                  opacity: (sending || !msgText.trim()) ? 0.6 : 1
                }}>{sending ? t('sending_msg') : t('send_msg_btn')}</button>
                <button onClick={() => setShowMsgModal(false)} style={{
                  padding: '11px 18px', borderRadius: 10, border: '1.5px solid #d1d5db', cursor: 'pointer',
                  background: 'white', color: '#6b7280', fontWeight: 600
                }}>{t('cancel_btn')}</button>
              </div>
            </>)}
          </div>
        </div>
      )}

      {cat === THREAD_KEY && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {thread.length === 0 && (
            <p style={{ color: '#a4864f', textAlign: 'center', padding: 40, background: 'white', borderRadius: 18, margin: 0 }}>עוד לא שלחת הודעה למנהל הפרויקט.</p>
          )}
          {threadRoots.map(root => (
            <div key={root.id} style={{ background: 'white', borderRadius: 18, padding: '16px 18px' }}>
              {renderThreadNode(root)}
            </div>
          ))}
        </div>
      )}

      <div style={{ display: cat === THREAD_KEY ? 'none' : 'flex', flexDirection: 'column', gap: 12 }}>
        {filtered.length === 0 && (
          <p style={{ color: '#a4864f', textAlign: 'center', padding: 40, background: 'white', borderRadius: 18, margin: 0 }}>{t('no_ann')}</p>
        )}
        {filtered.map(a => (
          <div key={a.id} style={{ display: 'flex', gap: 14, alignItems: 'flex-start', background: 'white', borderRadius: 18, padding: '18px 20px' }}>
            <div style={{ width: 42, height: 42, borderRadius: '50%', background: '#f3e3c8', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              {a.priority === 'urgent'
                ? <svg width="19" height="19" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="8" stroke="#c98a3f" strokeWidth="1.6"/><path d="M12 8v5M12 15.5v.5" stroke="#c98a3f" strokeWidth="1.7" strokeLinecap="round"/></svg>
                : <svg width="19" height="19" viewBox="0 0 24 24" fill="none"><path d="M6 14V10.5C6 7.5 8.5 5 12 5C15.5 5 18 7.5 18 10.5V14L19.3 16.3C19.6 16.9 19.2 17.5 18.6 17.5H5.4C4.8 17.5 4.4 16.9 4.7 16.3L6 14Z" stroke="#c98a3f" strokeWidth="1.6"/></svg>
              }
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: '1rem', color: '#4a3a24', marginBottom: 6 }}>{localize(a, 'title', lang)}</div>
              <div style={{ fontSize: '0.83rem', color: '#7a6a4a', lineHeight: 1.6 }}>{localize(a, 'body', lang)}</div>
              {a.file_url && (
                <a href={a.file_url.startsWith('http') ? a.file_url : window.location.origin + a.file_url} target="_blank" rel="noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 10, background: '#f3e3c8', color: '#8a6a2f', fontWeight: 600, fontSize: '0.82rem', padding: '6px 12px', borderRadius: 8, textDecoration: 'none' }}>
                  📎 {a.file_name || 'קובץ מצורף'}
                </a>
              )}
              <div style={{ fontSize: '0.75rem', color: '#a4864f', marginTop: 8 }}>{a.published_at ? new Date(a.published_at.replace(' ', 'T')).toLocaleString('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }) : ''}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function GallerySection({ gallery, lang, hideFromAllCategory }) {
  const [cat, setCat] = useState('הכל');
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    const handler = e => { if (e.key === 'Escape') setLightbox(null); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  const dynamicCats = ['הכל', ...Array.from(new Set(gallery.map(g => g.category).filter(Boolean)))];

  // "הכל" hides a specific category (e.g. signing-event photos) — it still
  // has its own tab and shows normally once picked directly, it's just not
  // mixed into the general "everything" view.
  const allGallery = hideFromAllCategory ? gallery.filter(g => g.category !== hideFromAllCategory) : gallery;
  const filtered = cat === 'הכל' ? allGallery : gallery.filter(g => g.category === cat);

  function lbMove(dir) {
    setLightbox(lb => {
      const idx = (lb.idx + dir + filtered.length) % filtered.length;
      return { item: filtered[idx], idx };
    });
  }
  const lbTouchRef = useRef(null);
  function lbTouchStart(e) { lbTouchRef.current = e.touches[0].clientX; }
  function lbTouchEnd(e) {
    if (lbTouchRef.current == null) return;
    const dx = e.changedTouches[0].clientX - lbTouchRef.current;
    lbTouchRef.current = null;
    if (Math.abs(dx) < 40) return;
    lbMove(dx < 0 ? 1 : -1);
  }

  const [featured, ...rest] = filtered;

  return (
    <div>
      {/* Underline tabs */}
      <div style={{ display: 'flex', gap: 24, borderBottom: '1px solid #ece5d5', marginBottom: 22, overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
        {dynamicCats.map(c => {
          const count = c === 'הכל' ? allGallery.length : gallery.filter(g => g.category === c).length;
          const active = cat === c;
          return (
            <button key={c} onClick={() => setCat(c)} style={{
              background: 'none', border: 'none', cursor: 'pointer', padding: '0 0 14px',
              fontWeight: active ? 600 : 500, fontSize: '0.88rem',
              color: active ? '#161d2e' : '#a89f88',
              borderBottom: active ? '2px solid #b8862f' : '2px solid transparent',
              marginBottom: -1, whiteSpace: 'nowrap', flexShrink: 0,
            }}>
              {tr(c, lang)} ({count})
            </button>
          );
        })}
      </div>

      {filtered.length === 0 && <p style={{ color: '#a4864f', textAlign: 'center', padding: 40 }}>{tr('אין תמונות בקטגוריה זו', lang)}</p>}

      {/* Featured row — first image large, next two stacked */}
      {filtered.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: rest.length >= 2 ? '2fr 1fr' : '1fr', gap: 10, marginBottom: 10 }}>
          <div style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setLightbox({ item: featured, idx: 0 })}>
            <img src={imgUrl(featured.url)} alt={stripExt(featured.caption) || ''}
              style={{ width: '100%', height: 260, objectFit: 'cover', objectPosition: featured.object_position || 'center', borderRadius: 8, display: 'block' }}
              onError={e => { e.target.style.display = 'none'; }} />
            {featured.caption && (
              <div style={{ position: 'absolute', bottom: 0, right: 0, left: 0, background: 'linear-gradient(0deg,rgba(0,0,0,.55),transparent)', padding: '14px 16px', borderRadius: '0 0 8px 8px', pointerEvents: 'none' }}>
                <div style={{ fontWeight: 600, fontSize: '0.82rem', color: '#fff' }}>{stripExt(featured.caption)}</div>
              </div>
            )}
          </div>
          {rest.length >= 2 && (
            <div style={{ display: 'grid', gridTemplateRows: '1fr 1fr', gap: 10 }}>
              {rest.slice(0, 2).map((g, i) => (
                <div key={g.id} style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setLightbox({ item: g, idx: i + 1 })}>
                  <img src={imgUrl(g.url)} alt={stripExt(g.caption) || ''}
                    style={{ width: '100%', height: 125, objectFit: 'cover', objectPosition: g.object_position || 'center', borderRadius: 8, display: 'block' }}
                    onError={e => { e.target.style.display = 'none'; }} />
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Main grid — 6 cols desktop, 3 mobile */}
      {rest.length > 2 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: 10 }}>
          {rest.slice(2).map((g, i) => (
            <div key={g.id} style={{ cursor: 'pointer' }} onClick={() => setLightbox({ item: g, idx: i + 3 })}>
              <img src={imgUrl(g.url)} alt={stripExt(g.caption) || ''}
                style={{ width: '100%', height: 120, objectFit: 'cover', objectPosition: g.object_position || 'center', borderRadius: 6, display: 'block' }}
                onError={e => { e.target.style.display = 'none'; }} />
              {g.caption && <div style={{ fontWeight: 500, fontSize: '0.72rem', color: '#8a8570', marginTop: 5, textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{tr(stripExt(g.caption), lang)}</div>}
            </div>
          ))}
        </div>
      )}

      {/* Lightbox */}
      {lightbox && (
        <div onClick={() => setLightbox(null)} style={{
          position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, background: 'rgba(0,0,0,0.92)', zIndex: 9999,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div
            onClick={e => e.stopPropagation()}
            onTouchStart={lbTouchStart}
            onTouchEnd={lbTouchEnd}
            style={{ position: 'relative', maxWidth: '96vw', maxHeight: '90vh', display: 'flex', flexDirection: 'column', alignItems: 'center', touchAction: 'pan-y' }}
          >
            {filtered.length > 1 && (
              <button onClick={e => { e.stopPropagation(); lbMove(1); }}
                style={{ position: 'absolute', right: 8, top: '40%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.45)', border: 'none', borderRadius: '50%', color: '#fff', fontSize: '1.6rem', width: 44, height: 44, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2 }}>‹</button>
            )}
            {filtered.length > 1 && (
              <button onClick={e => { e.stopPropagation(); lbMove(-1); }}
                style={{ position: 'absolute', left: 8, top: '40%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.45)', border: 'none', borderRadius: '50%', color: '#fff', fontSize: '1.6rem', width: 44, height: 44, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2 }}>›</button>
            )}
            <img src={imgUrl(lightbox.item.url)} alt="" style={{ maxWidth: '96vw', maxHeight: '80vh', objectFit: 'contain', borderRadius: 8 }} />
            {lightbox.item.caption && <div style={{ color: '#e5e7eb', marginTop: 12, fontSize: '0.95rem' }}>{stripExt(lightbox.item.caption)}</div>}
            <div style={{ color: '#9ca3af', fontSize: '0.8rem', marginTop: 4 }}>{lightbox.idx + 1} / {filtered.length}</div>
          </div>
          <button onClick={() => setLightbox(null)} style={{ position: 'absolute', top: 16, left: 16, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', fontSize: '1.4rem', width: 40, height: 40, borderRadius: '50%', cursor: 'pointer' }}>✕</button>
        </div>
      )}
    </div>
  );
}

function getTenantHeaders() {
  const t = localStorage.getItem('tenantToken');
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export default function TenantPortal() {
  usePwaManifest('/manifest-tenant.json');
  useAutoTranslateSync(); // re-renders this component whenever a tr() batch resolves
  const { projectName } = useParams();
  const navigate = useNavigate();
  const name = decodeURIComponent(projectName);
  // Aura-branded projects (ד' החדשה / סקייליין בת ים) use the beige/gold tenant
  // theme instead of the default dark-green one, matching their admin hub.
  // Skyline uses its own navy-and-gold pair (matching the SKYLINE logo), and
  // ד' החדשה uses navy-and-white (matching ITS logo) — both reuse the "Aura"
  // layout below (IS_AURA_TENANT), just with different theme constants.
  const IS_SKYLINE_TENANT = name === 'סקייליין בת ים';
  const IS_JD_TENANT = name === 'ד החדשה';
  const TENANT_THEME = IS_SKYLINE_TENANT ? '#1B2A4A' : (IS_JD_TENANT ? '#000D91' : '#1F5C33');
  const TENANT_THEME_LIGHT = IS_SKYLINE_TENANT ? '#D4AF37' : (IS_JD_TENANT ? '#c3d8f2' : '#c8e6b4');
  const IS_AURA_TENANT = IS_JD_TENANT;
  const TENANT_TILE_BG = IS_SKYLINE_TENANT ? '#1B2A4A' : (IS_AURA_TENANT ? '#ffffff' : '#6FAE4E');
  const TENANT_TILE_TEXT = IS_SKYLINE_TENANT ? '#D4AF37' : (IS_AURA_TENANT ? '#000D91' : 'white');
  const [tab, setTabRaw] = useState(() => localStorage.getItem('tenantTab') || 'home');
  const tenantPhone = localStorage.getItem('tenantPhone') || '';
  const [hasEvents, setHasEvents] = useState(false);
  useEffect(() => {
    if (!tenantPhone) return;
    api.get(`/portal/events/for-tenant/${encodeURIComponent(name)}/${encodeURIComponent(tenantPhone)}`, { headers: getTenantHeaders() })
      .then(r => setHasEvents((r.data || []).length > 0)).catch(() => {});
  }, [name, tenantPhone]);
  const visibleTabs = TABS.filter(tb => tb.id !== 'events' || hasEvents);
  const [showLogoutChoice, setShowLogoutChoice] = useState(false);

  function fullLogout() {
    ['tenantPhone','tenantToken','tenantName','tenantProject','tenantProjects','tenantBuildingAddress','tenantBuildingFull','tenantApartmentNumber','tenantBAddr','tenantBNum','tenantAptNum','tenantTab','tenantMultiApt','tenantIsAdminPreview'].forEach(k => localStorage.removeItem(k));
    navigate('/portal');
  }
  function backToProjectList() {
    localStorage.removeItem('tenantProject');
    navigate('/tenant-projects');
  }
  // Only worth asking "log out vs. back to list" when there's actually a list
  // to go back to — more than one project, or more than one apartment within
  // this one. A tenant with a single project+apartment just logs straight out.
  function hasMultipleAccess() {
    let projectsCount = 0;
    try { projectsCount = (JSON.parse(localStorage.getItem('tenantProjects') || '[]') || []).length; } catch {}
    return projectsCount > 1 || localStorage.getItem('tenantMultiApt') === '1';
  }
  function onLogoutClick() {
    if (hasMultipleAccess()) setShowLogoutChoice(true);
    else fullLogout();
  }

  const handleIdleLogout = useCallback(() => {
    ['tenantPhone','tenantToken','tenantName','tenantProject','tenantProjects','tenantBuildingAddress','tenantBuildingFull','tenantApartmentNumber','tenantBAddr','tenantBNum','tenantAptNum','tenantTab','tenantIsAdminPreview'].forEach(k => localStorage.removeItem(k));
    navigate('/portal');
  }, [navigate]);
  useIdleLogout(60 * 60 * 1000, handleIdleLogout); // ניתוק אוטומטי אחרי שעה של חוסר פעילות
  const logTenantAction = (actionType, details = {}) => {
    if (localStorage.getItem('tenantIsAdminPreview') === '1') return; // admin "view as tenant" — not real tenant activity
    const phone = localStorage.getItem('tenantPhone') || '';
    const name = localStorage.getItem('tenantName') || phone;
    if (!phone) return;
    api.post('/portal/log-tenant-activity', { phone, tenantName: name, projectName: decodeURIComponent(projectName), actionType, details: { ...details, phone } }).catch(() => {});
  };
  const setTab = (newTab) => {
    setTabRaw(newTab);
    localStorage.setItem('tenantTab', newTab);
    window.history.pushState({ tab: newTab }, '');
    const TAB_NAMES = { home: 'בית', 'my-apartment': 'הדירה שלי', stages: 'שלבים', announcements: 'הודעות', gallery: 'גלריה', contacts: 'אנשי קשר', files: 'קבצים', about: 'אודות' };
    logTenantAction('tenant_tab_view', { tab: TAB_NAMES[newTab] || newTab });
  };
  useEffect(() => {
    window.history.replaceState({ tab: tab }, '');
    const onPop = e => { if (e.state?.tab) setTabRaw(e.state.tab); };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  const [heroLightbox, setHeroLightbox] = useState(null);
  const [heroIndex, setHeroIndex] = useState(0);
  const [heroPaused, setHeroPaused] = useState(false);
  const heroTouchXRef = useRef(null);
  const [homeSettings, setHomeSettings] = useState({});
  const [stages, setStages] = useState([]);
  const [overall, setOverall] = useState(0);
  const [announcements, setAnnouncements] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [allProjectNames, setAllProjectNames] = useState([]);
  const [tenantBuildingFetched, setTenantBuildingFetched] = useState(localStorage.getItem('tenantBuildingAddress') || '');
  const [tenantNameFetched, setTenantNameFetched] = useState(localStorage.getItem('tenantName') || '');
  const [aptDetails, setAptDetails] = useState({});
  const [floorplan, setFloorplan] = useState({});
  const [projectComp, setProjectComp] = useState({});
  const [buildingSpecs, setBuildingSpecs] = useState({});
  const [buildingSpecsTama, setBuildingSpecsTama] = useState({});
  const [files, setFiles] = useState([]);
  const [filesSubTab, setFilesSubTab] = useState('general');
  const [filesCatFilter, setFilesCatFilter] = useState(null);
  const [filesSearch, setFilesSearch] = useState('');
  const [tenantTasks, setTenantTasks] = useState([]);
  const [aboutData, setAboutData] = useState({ founder: {}, projects: [], press: [] });
  const [aboutManheletData, setAboutManheletData] = useState({ manhelet: {}, projects: [], press: [] });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [lang, setLang] = useState(() => localStorage.getItem('portalLang') || 'he');
  const [tenantPhoto, setTenantPhoto] = useState('');
  const [tenantPhotoPos, setTenantPhotoPos] = useState('50% 50%');
  const [tenantPhotoOriginal, setTenantPhotoOriginal] = useState('');
  const [tenantPhotoCrop, setTenantPhotoCrop] = useState(''); // "scale,x,y" relative to the saved original
  const [showPhotoMenu, setShowPhotoMenu] = useState(false);
  const [showReposition, setShowReposition] = useState(false);
  const [cropImg, setCropImg] = useState(null); // base64 of selected image for crop UI
  const [cropScale, setCropScale] = useState(1);
  const [cropPos, setCropPos] = useState({ x: 0, y: 0 });
  const cropOriginalFileRef = React.useRef(null); // raw File — only set for a brand-new upload
  const cropDragRef = React.useRef(null);
  const cropImgRef = React.useRef(null);
  const cropCircleRef = React.useRef(null);
  const cropPosLive = React.useRef({ x: 0, y: 0 });
  const cropScaleLive = React.useRef(1);

  React.useEffect(() => {
    const el = cropCircleRef.current;
    if (!el || !cropImg) return;
    const applyTransform = (x, y, s) => {
      if (cropImgRef.current) cropImgRef.current.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) scale(${s})`;
    };
    const onTouchStart = e => {
      e.preventDefault();
      if (e.touches.length >= 2) {
        const dx = e.touches[0].clientX - e.touches[1].clientX, dy = e.touches[0].clientY - e.touches[1].clientY;
        cropDragRef.current = { pinch: true, lastDist: Math.hypot(dx, dy), startScale: cropScaleLive.current };
      } else {
        const t = e.touches[0];
        cropDragRef.current = { pinch: false, sx: t.clientX - cropPosLive.current.x, sy: t.clientY - cropPosLive.current.y };
      }
    };
    const onTouchMove = e => {
      e.preventDefault();
      if (e.touches.length >= 2) {
        if (!cropDragRef.current || !cropDragRef.current.pinch) {
          const dx = e.touches[0].clientX - e.touches[1].clientX, dy = e.touches[0].clientY - e.touches[1].clientY;
          cropDragRef.current = { pinch: true, lastDist: Math.hypot(dx, dy), startScale: cropScaleLive.current };
        }
        const dx = e.touches[0].clientX - e.touches[1].clientX, dy = e.touches[0].clientY - e.touches[1].clientY;
        const dist = Math.hypot(dx, dy);
        const s = Math.max(0.05, Math.min(3, cropDragRef.current.startScale * (dist / cropDragRef.current.lastDist)));
        cropScaleLive.current = s;
        applyTransform(cropPosLive.current.x, cropPosLive.current.y, s);
      } else if (e.touches.length === 1) {
        if (!cropDragRef.current || cropDragRef.current.pinch) {
          const t = e.touches[0];
          cropDragRef.current = { pinch: false, sx: t.clientX - cropPosLive.current.x, sy: t.clientY - cropPosLive.current.y };
        }
        const t = e.touches[0];
        const nx = t.clientX - cropDragRef.current.sx, ny = t.clientY - cropDragRef.current.sy;
        cropPosLive.current = { x: nx, y: ny };
        applyTransform(nx, ny, cropScaleLive.current);
      }
    };
    const onTouchEnd = e => {
      // No React state sync here on purpose — saveCrop() reads straight from
      // cropPosLive/cropScaleLive (the same refs updated during the drag), so state
      // only needs to reflect the gesture at all once, at modal open. Calling setState
      // here forced a full re-render of this large component on every touch-end,
      // which is what made the UI feel like it froze right when lifting the finger.
      if (e.touches.length === 0) {
        cropDragRef.current = null;
      } else if (e.touches.length === 1) {
        const t = e.touches[0];
        cropDragRef.current = { pinch: false, sx: t.clientX - cropPosLive.current.x, sy: t.clientY - cropPosLive.current.y };
      }
    };
    el.addEventListener('touchstart', onTouchStart, { passive: false });
    el.addEventListener('touchmove', onTouchMove, { passive: false });
    el.addEventListener('touchend', onTouchEnd);
    return () => { el.removeEventListener('touchstart', onTouchStart); el.removeEventListener('touchmove', onTouchMove); el.removeEventListener('touchend', onTouchEnd); };
  }, [cropImg]);
  const [stageExpanded, setStageExpanded] = useState({});
  useEffect(() => {
    if (!tenantPhone) return;
    api.get(`/portal/tenant-photo?phone=${encodeURIComponent(tenantPhone)}`, { headers: getTenantHeaders() })
      .then(r => {
        if (r.data.url) { setTenantPhoto(r.data.url); localStorage.setItem('tenantPhotoUrl', r.data.url); }
        if (r.data.pos) { setTenantPhotoPos(r.data.pos); localStorage.setItem('tenantPhotoPos', r.data.pos); }
        setTenantPhotoOriginal(r.data.original || '');
        setTenantPhotoCrop(r.data.crop || '');
      })
      .catch(() => {});
  }, [tenantPhone]);
  const tenantPhotoInputRef = React.useRef();
  const t = key => (TRANSLATIONS[lang] || TRANSLATIONS.he)[key] || key;
  const dir = lang === 'he' ? 'rtl' : 'ltr';
  // A phone tied to multiple apartments (multi-unit tenant, or a contact linked to
  // another owner's unit) can resolve to a different tenant name per project — use
  // the per-project-fetched value, falling back to the cached one until it loads.
  const tenantName = tenantNameFetched;
  // Use the fetched value (updates when API returns) or cached localStorage value
  const tenantBuilding = tenantBuildingFetched;
  const heroImages = (homeSettings.images || []).filter(im => im && im.url);

  // Auto-advance the home hero carousel; pauses when the tenant clicks the image
  // or swipes (heroPaused), and stops entirely if there's only one image.
  useEffect(() => {
    if (heroImages.length <= 1 || heroPaused) return;
    const timer = setInterval(() => setHeroIndex(i => (i + 1) % heroImages.length), 4500);
    return () => clearInterval(timer);
  }, [heroImages.length, heroPaused]);
  useEffect(() => { setHeroIndex(0); setHeroPaused(false); }, [name]);

  useEffect(() => {
    if (!localStorage.getItem('tenantProject')) navigate('/portal');
  }, [navigate]);

  useEffect(() => { localStorage.setItem('tenantTab', tab); }, [tab]);

  useEffect(() => {
    const enc = encodeURIComponent(name);
    // Disambiguates which apartment to show when this phone has more than one
    // unit in this same project (picked earlier in TenantProjects.jsx).
    const bAddr = localStorage.getItem('tenantBAddr') || '';
    const bNum = localStorage.getItem('tenantBNum') || '';
    const aptNumSel = localStorage.getItem('tenantAptNum') || '';
    const aptQS = (bAddr && bNum && aptNumSel) ? `&bAddr=${encodeURIComponent(bAddr)}&bNum=${encodeURIComponent(bNum)}&aptNum=${encodeURIComponent(aptNumSel)}` : '';
    api.get(`/portal/stages/${enc}`).then(r => setStages(r.data)).catch(() => {});
    api.get(`/portal/overall/${enc}`).then(r => setOverall(r.data.overall_pct)).catch(() => {});
    const phone = localStorage.getItem('tenantPhone') || '';
    api.get(`/portal/announcements/${enc}?phone=${encodeURIComponent(phone)}`).then(r => setAnnouncements(r.data)).catch(() => {});
    api.get(`/portal/gallery/${enc}`).then(r => setGallery(r.data)).catch(() => {});
    api.get(`/portal/contacts/${enc}`).then(r => setContacts(r.data)).catch(() => {});
    api.get(`/portal/files/${enc}?phone=${encodeURIComponent(localStorage.getItem('tenantPhone') || '')}${aptQS}`).then(r => setFiles(r.data)).catch(() => {});
    Promise.all([
      api.get(`/portal/about/founder/${enc}`).then(r => r.data).catch(() => ({})),
      api.get(`/portal/about/projects/${enc}`).then(r => r.data).catch(() => []),
      api.get(`/portal/about/press/${enc}`).then(r => r.data).catch(() => []),
    ]).then(([founder, projects, press]) => setAboutData({ founder, projects, press }));
    Promise.all([
      api.get(`/portal/about/manhelet/${enc}`).then(r => r.data).catch(() => ({})),
      api.get(`/portal/about/manhelet-projects/${enc}`).then(r => r.data).catch(() => []),
      api.get(`/portal/about/manhelet-press/${enc}`).then(r => r.data).catch(() => []),
    ]).then(([manhelet, projects, press]) => setAboutManheletData({ manhelet, projects, press }));
    api.get('/portal/project-names').then(r => setAllProjectNames(r.data || [])).catch(() => {});
    api.get(`/portal/home-settings/${enc}`).then(r => setHomeSettings(r.data || {})).catch(() => {});
    // Fetch apartment details for this tenant
    if (phone) {
      const normPhone = phone.replace(/[\s\-]/g, '');
      api.get(`/portal/apartment-details/${encodeURIComponent(normPhone)}?projectName=${encodeURIComponent(name)}${aptQS}`, { headers: getTenantHeaders() }).then(r => setAptDetails(r.data || {})).catch(() => {});
      api.get(`/portal/my-floorplan/${encodeURIComponent(normPhone)}?projectName=${encodeURIComponent(name)}${aptQS}`, { headers: getTenantHeaders() }).then(r => setFloorplan(r.data || {})).catch(() => {});
    }
    // Fetch building specs (per project) — TAMA buildings (11,20,22,24) can have their own spec
    api.get(`/portal/building-specs/${enc}/_project_`).then(r => setBuildingSpecs(r.data || {})).catch(() => {});
    api.get(`/portal/building-specs/${enc}/_tama_`).then(r => setBuildingSpecsTama(r.data || {})).catch(() => {});
    // Fetch project-level compensations
    api.get(`/portal/project-comp/${enc}`).then(r => setProjectComp(r.data || {})).catch(() => {});
    // Fetch tenant tasks
    if (phone) {
      const normPhone = phone.replace(/[\s\-]/g, '');
      api.get(`/portal/tenant-tasks/${encodeURIComponent(normPhone)}?projectName=${encodeURIComponent(name)}`, { headers: getTenantHeaders() }).then(r => setTenantTasks(r.data || [])).catch(() => {});
    }
    // Always fetch building address to keep it up-to-date
    if (phone) {
      api.get(`/portal/tenant-project?phone=${encodeURIComponent(phone)}&projectName=${encodeURIComponent(name)}${aptQS}`, { headers: getTenantHeaders() })
        .then(r => {
          const addr = r.data.buildingAddress || '';
          const fullAddr = r.data.buildingFullAddress || addr;
          localStorage.setItem('tenantBuildingAddress', addr);
          localStorage.setItem('tenantBuildingFull', fullAddr);
          localStorage.setItem('tenantApartmentNumber', r.data.apartmentNumber || '');
          setTenantBuildingFetched(addr);
          if (r.data.name) {
            localStorage.setItem('tenantName', r.data.name);
            setTenantNameFetched(r.data.name);
          }
        }).catch(err => {
          // 403 here means this specific project isn't in OTP_ALLOWED_PROJECTS
          // (e.g. the tenant also has a unit in a project not launched yet) —
          // bounce back to the project picker instead of silently rendering a
          // page with no real data for it.
          if (err.response?.status === 403) {
            alert(err.response.data?.error || 'הפרויקט הזה אינו זמין כרגע בפורטל');
            localStorage.removeItem('tenantProject');
            navigate('/tenant-projects');
          } else if (err.response?.status === 404) {
            // The tenant's access was revoked (e.g. a contact removed from the
            // access-exceptions list) — this specific apartment link no longer
            // matches, so don't keep rendering stale cached apartment data.
            alert('הגישה לדירה זו הוסרה');
            localStorage.removeItem('tenantProject');
            navigate('/tenant-projects');
          }
        });
    }
  }, [name]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  function switchLang(l) {
    setLang(l);
    localStorage.setItem('portalLang', l);
  }

  const statusLabels = { pending: t('status_pending'), active: t('status_active'), completed: t('status_completed') };

  function LangSwitcher({ style }) {
    const [langMenuOpen, setLangMenuOpen] = useState(false);
    // Windows browsers (Chrome/Edge on Windows) have no bundled color-flag emoji
    // font — regional-indicator emoji like 🇮🇱 render as plain "IL" text there
    // (mobile OSes render them fine). Small inline SVGs render identically on
    // every platform, so those are used instead of the emoji.
    const FlagIL = () => (
      <svg width="18" height="13" viewBox="0 0 18 13"><rect width="18" height="13" fill="#fff" /><rect y="1.5" width="18" height="2" fill="#0038b8" /><rect y="9.5" width="18" height="2" fill="#0038b8" /><path d="M9 4.2l1.8 3.1H7.2z" fill="none" stroke="#0038b8" strokeWidth="0.6" /><path d="M9 8.8L7.2 5.7h3.6z" fill="none" stroke="#0038b8" strokeWidth="0.6" /></svg>
    );
    const FlagUS = () => (
      <svg width="18" height="13" viewBox="0 0 18 13">
        {Array.from({ length: 13 }).map((_, i) => <rect key={i} y={i} width="18" height="1" fill={i % 2 === 0 ? '#B22234' : '#fff'} />)}
        <rect width="7.2" height="7" fill="#3C3B6E" />
      </svg>
    );
    const FlagRU = () => (
      <svg width="18" height="13" viewBox="0 0 18 13"><rect width="18" height="4.33" fill="#fff" /><rect y="4.33" width="18" height="4.33" fill="#0039A6" /><rect y="8.66" width="18" height="4.34" fill="#D52B1E" /></svg>
    );
    const FlagET = () => (
      <svg width="18" height="13" viewBox="0 0 18 13"><rect width="18" height="4.33" fill="#078930" /><rect y="4.33" width="18" height="4.33" fill="#FCDD09" /><rect y="8.66" width="18" height="4.34" fill="#DA121A" /><circle cx="9" cy="6.5" r="2.6" fill="#0F47AF" /></svg>
    );
    // Amharic is only offered for ד' החדשה, whose tenants requested it.
    const LANGS = [
      { code: 'he', label: 'עב', Flag: FlagIL }, { code: 'en', label: 'EN', Flag: FlagUS }, { code: 'ru', label: 'RU', Flag: FlagRU },
      ...(name === 'ד החדשה' ? [{ code: 'am', label: 'AM', Flag: FlagET }] : []),
    ];
    const current = LANGS.find(l => l.code === lang) || LANGS[0];
    return (
      <div style={{ position: 'relative', ...style }}>
        <button onClick={() => setLangMenuOpen(o => !o)} style={{
          display: 'flex', alignItems: 'center', gap: 5, padding: '3px 9px', borderRadius: 6, border: 'none', cursor: 'pointer',
          fontWeight: 700, fontSize: '0.78rem', background: 'rgba(255,255,255,0.15)', color: '#fff',
        }}>
          <current.Flag /><span>{current.label}</span><span style={{ fontSize: '0.65rem' }}>{langMenuOpen ? '▲' : '▼'}</span>
        </button>
        {langMenuOpen && (
          <>
            <div onClick={() => setLangMenuOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 999 }} />
            <div style={{
              position: 'absolute', top: '110%', insetInlineEnd: 0, zIndex: 1000,
              background: 'white', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.18)', overflow: 'hidden', minWidth: 90,
            }}>
              {LANGS.map(({ code, label, Flag }) => (
                <button key={code} onClick={() => { switchLang(code); setLangMenuOpen(false); }} style={{
                  display: 'flex', alignItems: 'center', gap: 6, width: '100%', padding: '8px 12px', border: 'none', cursor: 'pointer',
                  fontWeight: lang === code ? 700 : 400, fontSize: '0.82rem',
                  background: lang === code ? '#f0f2f5' : 'white', color: '#1f2937', textAlign: 'right',
                }}>
                  <Flag /><span>{label}</span>
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    );
  }

  function goBack() {
    localStorage.removeItem('tenantProject');
    navigate('/tenant-projects');
  }

  const grouped = stages.reduce((acc, s) => {
    const cat = s.category || 'כללי';
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(s);
    return acc;
  }, {});

  const logo = PROJECT_LOGOS[name];
  // The header badge is tiny (36-42px) — the full wordmark logo (mostly
  // whitespace + text) shrinks to an unreadable speck there, so a
  // tightly-cropped icon-only version is used just for that circle.
  const HEADER_BADGE_LOGOS = { 'ג החדשה': '/logos/jaffag_square.png', 'אייזיקחריף': '/logos/jaffag_square.png' };
  const headerLogo = HEADER_BADGE_LOGOS[name] || logo;

  function openCrop(file) {
    if (!file) return;
    cropOriginalFileRef.current = file; // new upload — this raw file becomes the saved "original"
    const reader = new FileReader();
    reader.onload = e => {
      const img = new window.Image();
      img.onload = () => {
        const fit = Math.min(240 / img.width, 240 / img.height);
        setCropImg(e.target.result);
        setCropScale(fit);
        cropScaleLive.current = fit;
        setCropPos({ x: 0, y: 0 });
        cropPosLive.current = { x: 0, y: 0 };
        setShowPhotoMenu(false);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  // Re-open the full original photo (before it was cropped to a square) so the tenant
  // can reframe it — only possible when we saved the original at upload time. Restores
  // the exact scale/position used last time, so it opens showing the current framing,
  // not a reset-to-center view.
  function openCropFromOriginal() {
    cropOriginalFileRef.current = null; // re-edit — do NOT overwrite the stored original
    const url = imgUrl(tenantPhotoOriginal);
    const saved = tenantPhotoCrop ? tenantPhotoCrop.split(',').map(Number) : null;
    const img = new window.Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const fit = Math.min(240 / img.width, 240 / img.height);
      const scale = saved && !isNaN(saved[0]) ? saved[0] : fit;
      const pos = saved && !isNaN(saved[1]) ? { x: saved[1], y: saved[2] } : { x: 0, y: 0 };
      setCropImg(url);
      setCropScale(scale);
      cropScaleLive.current = scale;
      setCropPos(pos);
      cropPosLive.current = pos;
      setShowPhotoMenu(false);
    };
    img.src = url;
  }

  function saveCrop() {
    const size = 300;
    const canvas = document.createElement('canvas');
    canvas.width = size; canvas.height = size;
    const ctx = canvas.getContext('2d');
    ctx.beginPath(); ctx.arc(size/2, size/2, size/2, 0, Math.PI*2); ctx.clip();
    const img = new window.Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      // Read from the LIVE REFS, not the cropScale/cropPos React state — touch drag/pinch
      // updates the refs + DOM style directly for smooth 60fps dragging and only syncs
      // state on touch-end. Reading state here risked using a stale pre-gesture value if
      // save was triggered before that sync landed.
      const scale = cropScaleLive.current;
      const livePos = cropPosLive.current;
      // The live preview box is 240px; the output canvas is `size` (300px). livePos.x/y are
      // recorded in the preview's screen pixels (unaffected by zoom — see the preview's
      // CSS transform), so to reproduce the same relative framing on the larger canvas we
      // scale the drag offset by the box-size ratio, NOT by the zoom `scale` itself.
      const boxRatio = size / 240;
      const w = img.width * scale * boxRatio, h = img.height * scale * boxRatio;
      const x = (size - w) / 2 + livePos.x * boxRatio;
      const y = (size - h) / 2 + livePos.y * boxRatio;
      ctx.drawImage(img, x, y, w, h);
      const b64 = canvas.toDataURL('image/jpeg', 0.9);
      setTenantPhoto(b64);
      localStorage.setItem('tenantPhotoUrl', b64);
      setTenantPhotoPos('50% 50% 1');
      localStorage.setItem('tenantPhotoPos', '50% 50% 1');
      setCropImg(null);
      // Upload to server — also send the raw original when this is a brand-new upload
      canvas.toBlob(blob => {
        const fd = new FormData();
        fd.append('photo', blob, 'photo.jpg');
        fd.append('phone', tenantPhone);
        fd.append('crop', `${scale},${livePos.x},${livePos.y}`);
        if (cropOriginalFileRef.current) fd.append('original', cropOriginalFileRef.current);
        if (localStorage.getItem('tenantIsAdminPreview') !== '1') {
          api.post('/portal/tenant-photo', fd, { headers: { ...getTenantHeaders(), 'Content-Type': 'multipart/form-data' } })
            .then(r => { if (r.data.originalUrl) setTenantPhotoOriginal(r.data.originalUrl); })
            .catch(() => {});
        } // admin "view as tenant" preview — keep the local edit visible, don't persist it
        setTenantPhotoCrop(`${scale},${livePos.x},${livePos.y}`);
        cropOriginalFileRef.current = null;
      }, 'image/jpeg', 0.9);
    };
    img.src = cropImg;
  }

  const photoTransform = parsePhotoTransform(tenantPhotoPos);
  const photoImgStyle = {
    position: 'absolute', top: '50%', left: '50%',
    width: `${photoTransform.scale * 100}%`, height: `${photoTransform.scale * 100}%`,
    transform: `translate(-50%, -50%) translate(${(photoTransform.x - 50) * -1}%, ${(photoTransform.y - 50) * -1}%)`,
    objectFit: 'cover', display: 'block',
  };

  const TenantAvatar = ({ size = 42 }) => (
    <div style={{ position: 'relative', flexShrink: 0 }}>
      <div onClick={() => setShowPhotoMenu(true)} title="לחץ לשינוי תמונה"
        style={{ width: size, height: size, borderRadius: '50%', border: '2px solid rgba(255,255,255,0.5)', overflow: 'hidden', cursor: 'pointer', background: '#374151', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        {tenantPhoto
          ? <img src={tenantPhoto} alt="" style={photoImgStyle} />
          : <span style={{ fontSize: size * 0.45, fontWeight: 700, color: 'rgba(255,255,255,0.7)', lineHeight: 1 }}>{(tenantName || '').trim().charAt(0) || '?'}</span>
        }
      </div>
      <input ref={tenantPhotoInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={e => openCrop(e.target.files[0])} />

      {/* Photo menu — shows full image with action buttons below */}
      {showPhotoMenu && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 24 }} onClick={() => setShowPhotoMenu(false)}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 24 }} onClick={e => e.stopPropagation()}>
            {/* Full-size image */}
            <div style={{ width: 240, height: 240, borderRadius: '50%', overflow: 'hidden', border: '3px solid white', background: '#374151', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
              {tenantPhoto
                ? <img src={tenantPhoto} alt="" style={photoImgStyle} />
                : <span style={{ fontSize: 100, fontWeight: 700, color: 'rgba(255,255,255,0.7)', lineHeight: 1 }}>{(tenantName || '').trim().charAt(0) || '?'}</span>
              }
            </div>
            {/* Action buttons */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, minWidth: 220, direction: 'rtl' }}>
              {tenantPhoto && (
                <button onClick={() => { (tenantPhotoOriginal && tenantPhotoCrop) ? openCropFromOriginal() : (setShowPhotoMenu(false), setShowReposition(true)); }}
                  style={{ padding: '13px', borderRadius: 10, border: 'none', background: '#4c7a4f', color: 'white', fontWeight: 600, cursor: 'pointer', fontSize: '1rem' }}>
                  ✏️ ערוך מיקום
                </button>
              )}
              <button onClick={() => tenantPhotoInputRef.current?.click()} style={{ padding: '13px', borderRadius: 10, border: 'none', background: '#1a4a8a', color: 'white', fontWeight: 600, cursor: 'pointer', fontSize: '1rem' }}>📷 החלף תמונה</button>
              {tenantPhoto && <button onClick={() => { setTenantPhoto(''); localStorage.removeItem('tenantPhotoUrl'); if (localStorage.getItem('tenantIsAdminPreview') !== '1') api.post('/portal/tenant-photo/delete', { phone: tenantPhone }, { headers: getTenantHeaders() }).catch(() => {}); setShowPhotoMenu(false); }} style={{ padding: '13px', borderRadius: 10, border: 'none', background: '#dc2626', color: 'white', fontWeight: 600, cursor: 'pointer', fontSize: '1rem' }}>🗑️ מחק תמונה</button>}
              <button onClick={() => setShowPhotoMenu(false)} style={{ padding: '13px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.1)', color: 'white', cursor: 'pointer', fontSize: '1rem' }}>ביטול</button>
            </div>
          </div>
        </div>
      )}

      {/* Reposition modal — zoom + drag existing photo to change its crop */}
      {showReposition && tenantPhoto && (
        <RepositionModal
          src={tenantPhoto}
          initialPos={tenantPhotoPos}
          onCancel={() => setShowReposition(false)}
          onSave={pos => {
            setTenantPhotoPos(pos);
            localStorage.setItem('tenantPhotoPos', pos);
            if (localStorage.getItem('tenantIsAdminPreview') !== '1') {
              api.post('/portal/tenant-photo/position', { phone: tenantPhone, pos }, { headers: getTenantHeaders() }).catch(() => {});
            }
            setShowReposition(false);
          }}
        />
      )}

      {/* Crop modal */}
      {cropImg && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
          <div style={{ color: 'white', fontWeight: 600, fontSize: '1rem' }}>גרור להזזה • צבוט לשינוי גודל</div>
          {/* Circle crop preview */}
          <div ref={cropCircleRef} style={{ width: 240, height: 240, borderRadius: '50%', overflow: 'hidden', border: '3px solid white', position: 'relative', cursor: 'grab', background: '#222', touchAction: 'none' }}
            onMouseDown={e => { cropDragRef.current = { sx: e.clientX - cropPosLive.current.x, sy: e.clientY - cropPosLive.current.y }; }}
            onMouseMove={e => { if (!cropDragRef.current) return; const nx = e.clientX - cropDragRef.current.sx, ny = e.clientY - cropDragRef.current.sy; cropPosLive.current = { x: nx, y: ny }; if (cropImgRef.current) cropImgRef.current.style.transform = `translate(calc(-50% + ${nx}px), calc(-50% + ${ny}px)) scale(${cropScaleLive.current})`; }}
            onMouseUp={() => { cropDragRef.current = null; setCropPos({ ...cropPosLive.current }); }}
            onMouseLeave={() => { cropDragRef.current = null; setCropPos({ ...cropPosLive.current }); }}
          >
            <img ref={cropImgRef} src={cropImg} alt="" style={{ position: 'absolute', top: '50%', left: '50%', transform: `translate(calc(-50% + ${cropPos.x}px), calc(-50% + ${cropPos.y}px)) scale(${cropScale})`, transformOrigin: 'center', maxWidth: 'none', userSelect: 'none', pointerEvents: 'none' }} draggable={false} />
          </div>
          <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.8rem', marginTop: 4 }}>🤏 צבוט עם שתי אצבעות לשינוי גודל</div>
          <div style={{ display: 'flex', gap: 12 }}>
            <button onClick={saveCrop} style={{ padding: '12px 28px', borderRadius: 10, border: 'none', background: '#c98a3f', color: 'white', fontWeight: 700, cursor: 'pointer', fontSize: '1rem' }}>✓ שמור תמונה</button>
            <button onClick={() => setCropImg(null)} style={{ padding: '12px 20px', borderRadius: 10, border: 'none', background: '#444', color: 'white', cursor: 'pointer', fontSize: '1rem' }}>ביטול</button>
          </div>
        </div>
      )}
    </div>
  );

  // ── Shared tab content ──────────────────────────────────────────────────────
  const tabContent = (
    <div style={{ flex: 1, padding: isMobile ? '16px 16px 100px' : '24px 32px 110px', minWidth: 0 }}>

      {/* Home */}
      {tab === 'home' && (() => {
        const activeStage = stages.find(s => s.status === 'active') || stages.find(s => s.status === 'pending');
        const completedStages = stages.filter(s => s.status === 'completed').length;
        const STAGE_PARENTS = new Set([
          'תכנון ואישור התב"ע מול העירייה',
          'תכנון ואישור התבע מול העירייה',
          'דיון להפקדה בועדה המקומית ומתן תוקף',
        ]);
        const leafStages = stages.filter(s => !STAGE_PARENTS.has(s.name));
        const totalStages = leafStages.length;
        const completedLeafCount = leafStages.filter(s => s.status === 'completed').length;
        const currentStageNum = activeStage ? (completedLeafCount + 1) : completedLeafCount;
        return (
          <div style={{ fontFamily: "'Rubik', system-ui, sans-serif" }}>
            {/* Hero carousel — auto-advances through up to 10 images; clicking the
                image or swiping pauses auto-advance so the tenant can stay put. */}
            {heroImages.length > 0 && (<>
              <div
                style={{ position: 'relative', marginBottom: 20, borderRadius: 12, overflow: 'hidden' }}
                onTouchStart={e => { heroTouchXRef.current = e.touches[0].clientX; }}
                onTouchEnd={e => {
                  const startX = heroTouchXRef.current;
                  heroTouchXRef.current = null;
                  if (startX == null) return;
                  const dx = e.changedTouches[0].clientX - startX;
                  if (Math.abs(dx) < 40) return; // tap, not swipe — handled by onClick below
                  setHeroPaused(true);
                  setHeroIndex(i => {
                    const dir = dx < 0 ? 1 : -1; // swipe left → next, swipe right → previous
                    return (i + dir + heroImages.length) % heroImages.length;
                  });
                }}
              >
                {heroImages.map((im, i) => (
                  <img key={i} src={imgUrl(im.url)} alt="" onClick={() => { setHeroPaused(true); setHeroLightbox(i); }}
                    style={{
                      width: '100%', height: isMobile ? 200 : 380, display: i === heroIndex ? 'block' : 'none',
                      objectFit: 'cover', objectPosition: im.pos || 'center', cursor: 'pointer',
                    }}
                    onError={e => { e.target.style.display = 'none'; }} />
                ))}
                {heroImages.length > 1 && (
                  <div style={{ position: 'absolute', bottom: 10, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 6 }}>
                    {heroImages.map((_, i) => (
                      <div key={i} onClick={e => { e.stopPropagation(); setHeroPaused(true); setHeroIndex(i); }}
                        style={{ width: 7, height: 7, borderRadius: '50%', cursor: 'pointer', background: i === heroIndex ? 'white' : 'rgba(255,255,255,0.5)', boxShadow: '0 0 3px rgba(0,0,0,0.4)' }} />
                    ))}
                  </div>
                )}
                {heroPaused && heroImages.length > 1 && (
                  <button onClick={() => setHeroPaused(false)} title="המשך גלילה אוטומטית"
                    style={{ position: 'absolute', top: 10, left: 10, background: 'rgba(0,0,0,0.45)', border: 'none', borderRadius: '50%', width: 32, height: 32, color: 'white', fontSize: '0.9rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>▶</button>
                )}
              </div>
              {heroLightbox !== null && (
                <div onClick={() => setHeroLightbox(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.88)', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
                  <button onClick={() => setHeroLightbox(null)} style={{ position: 'absolute', top: 16, left: 16, background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', fontSize: '1.4rem', borderRadius: '50%', width: 40, height: 40, cursor: 'pointer' }}>✕</button>
                  <div onClick={e => e.stopPropagation()} style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                    <button onClick={e => { e.stopPropagation(); setHeroLightbox(idx => (idx + 1) % heroImages.length); }} style={{ position: 'absolute', right: -20, top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.45)', border: 'none', color: 'white', fontSize: '1.8rem', borderRadius: '50%', width: 44, height: 44, cursor: 'pointer', zIndex: 1 }}>‹</button>
                    <img src={imgUrl(heroImages[heroLightbox].url)} alt="" style={{ maxWidth: '88vw', maxHeight: '80vh', objectFit: 'contain', borderRadius: 8, display: 'block' }} />
                    <button onClick={e => { e.stopPropagation(); setHeroLightbox(idx => (idx - 1 + heroImages.length) % heroImages.length); }} style={{ position: 'absolute', left: -20, top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.45)', border: 'none', color: 'white', fontSize: '1.8rem', borderRadius: '50%', width: 44, height: 44, cursor: 'pointer', zIndex: 1 }}>›</button>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {heroImages.map((_, i) => <div key={i} onClick={e => { e.stopPropagation(); setHeroLightbox(i); }} style={{ width: 8, height: 8, borderRadius: '50%', background: i === heroLightbox ? 'white' : 'rgba(255,255,255,0.4)', cursor: 'pointer' }} />)}
                  </div>
                </div>
              )}
            </>)}

            {/* Stat strip */}
            <div style={{ display: 'flex', background: IS_AURA_TENANT ? '#e8ebf9' : TENANT_THEME, borderRadius: 12, marginBottom: 20, overflow: 'hidden' }}>
              {[
                { value: totalStages || '—', label: t('stages_count') },
                { value: totalStages ? `${t('current_stage_word')} ${currentStageNum}` : '—', label: t('of_n_stages').replace('{n}', totalStages) },
                { value: `${overall}%`, label: t('overall_progress') },
              ].map((item, i, arr) => (
                <div key={i} style={{ flex: 1, textAlign: 'center', padding: '18px 8px', borderLeft: i < arr.length - 1 ? (IS_AURA_TENANT ? '1px solid rgba(0,0,0,.08)' : '1px solid rgba(255,255,255,.12)') : 'none' }}>
                  <div style={{ fontSize: isMobile ? '1.3rem' : '1.6rem', fontWeight: 700, color: IS_SKYLINE_TENANT ? '#D4AF37' : IS_JD_TENANT ? TENANT_THEME : '#E09548', lineHeight: 1.1 }}>{item.value}</div>
                  <div style={{ fontSize: '0.72rem', color: IS_SKYLINE_TENANT ? '#D4AF37' : (IS_AURA_TENANT ? '#5a6b9a' : '#d4e8c2'), marginTop: 4 }}>{item.label}</div>
                </div>
              ))}
            </div>

            {/* Content: announcements + quick grid */}
            <div style={{ display: 'flex', gap: 16, alignItems: 'stretch', flexDirection: isMobile ? 'column' : 'row' }}>

              {/* Left: cards */}
              <div style={{ flex: '1.4', display: 'flex', flexDirection: 'column', gap: 12, minWidth: 0 }}>
                {tenantTasks.length > 0 && (
                  <div style={{ background: 'white', border: '1px solid #ece5d5', borderRadius: 10, padding: '14px 18px', borderRight: `3px solid ${TENANT_THEME}` }}>
                    <div style={{ fontSize: '0.7rem', color: '#8a8570', fontWeight: 600, marginBottom: 10 }}>{t('tasks')}</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {tenantTasks.map(task => (
                        <div key={task.id} style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10 }}>
                          <div style={{ minWidth: 0 }}>
                            <div style={{ fontWeight: 700, color: '#161d2e', fontSize: '0.9rem' }}>{localize(task, 'title', lang)}</div>
                            {task.description && <div style={{ fontSize: '0.8rem', color: '#555', marginTop: 2 }}>{localize(task, 'description', lang)}</div>}
                          </div>
                          <span style={{ fontSize: '0.72rem', fontWeight: 600, background: task.status === 'done' ? '#eef3ea' : TENANT_THEME_LIGHT, color: task.status === 'done' ? '#4c7a4f' : TENANT_THEME, borderRadius: 99, padding: '3px 10px', whiteSpace: 'nowrap', flexShrink: 0 }}>
                            {task.status === 'done' ? t('task_done') : t('task_pending')}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {(() => {
                  const myPh = (localStorage.getItem('tenantPhone') || '').replace(/[\s\-]/g, '');
                  const visAnn = announcements.filter(a => {
                    if (!a.recipient || !a.recipient.startsWith('specific:')) return true;
                    return a.recipient.replace('specific:', '').split(',').map(p => p.replace(/[\s\-]/g, '')).filter(Boolean).includes(myPh);
                  });
                  return visAnn.length > 0 && (
                  <div onClick={() => setTab('announcements')} style={{
                    background: 'white', border: '1px solid #ece5d5', borderRadius: 10, padding: '16px 18px', borderRight: '3px solid #b8862f',
                    display: 'flex', alignItems: 'flex-start', gap: 12, flex: 1, cursor: 'pointer',
                    boxShadow: '0 0 0 1.5px #bfdbfe, 0 2px 8px rgba(29,78,216,0.12)',
                  }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '0.7rem', color: '#b8862f', fontWeight: 600, marginBottom: 4 }}>
                        {t('last_ann')} · {new Date(visAnn[0].published_at).toLocaleDateString('he-IL')}
                      </div>
                      <div style={{ fontWeight: 700, color: '#161d2e', fontSize: '0.95rem', marginBottom: 5 }}>{localize(visAnn[0], 'title', lang)}</div>
                      <div style={{ fontSize: '0.85rem', color: '#555', lineHeight: 1.55 }}>{localize(visAnn[0], 'body', lang)}</div>
                      {visAnn[0].file_url && (
                        <a href={visAnn[0].file_url.startsWith('http') ? visAnn[0].file_url : window.location.origin + visAnn[0].file_url} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 8, background: '#f3e3c8', color: '#8a6a2f', fontWeight: 600, fontSize: '0.8rem', padding: '5px 10px', borderRadius: 8, textDecoration: 'none' }}>
                          📎 {visAnn[0].file_name || 'קובץ מצורף'}
                        </a>
                      )}
                    </div>
                    <span style={{ color: '#b8862f', fontSize: '0.85rem', fontWeight: 600, flexShrink: 0 }}>{t('view_link')}</span>
                  </div>
                  );
                })()}

                {activeStage && (
                  <div onClick={() => setTab('stages')} style={{
                    background: 'white', border: '1px solid #ece5d5', borderRadius: 10, padding: '14px 18px',
                    display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer', flex: 1,
                    boxShadow: '0 0 0 1.5px #bfdbfe, 0 2px 8px rgba(29,78,216,0.12)',
                  }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '0.7rem', color: '#8a8570', fontWeight: 600, marginBottom: 3 }}>{t('current_stage')}</div>
                      <div style={{ fontWeight: 700, color: '#161d2e', fontSize: '0.9rem' }}>{localize(activeStage, 'name', lang)}</div>
                    </div>
                    <span style={{ background: '#eef3ea', color: '#4c7a4f', fontSize: '0.75rem', fontWeight: 600, padding: '5px 12px', borderRadius: 20, whiteSpace: 'nowrap' }}>
                      {statusLabels[activeStage.status]}
                    </span>
                    <span style={{ color: '#b8862f', fontSize: '0.85rem', fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}>{t('view_link')}</span>
                  </div>
                )}

                <div onClick={() => setTab('my-apartment')} style={{
                  background: 'white', border: '1px solid #ece5d5', borderRadius: 10, padding: '14px 18px',
                  display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer', flex: 1,
                  boxShadow: '0 0 0 1.5px #bfdbfe, 0 2px 8px rgba(29,78,216,0.12)',
                }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '0.7rem', color: '#8a8570', fontWeight: 600, marginBottom: 3 }}>{t('tab_myApt')}</div>
                    <div style={{ fontWeight: 700, color: '#161d2e', fontSize: '0.9rem' }}>
                      {tr(localStorage.getItem('tenantBuildingFull') || tenantBuilding || displayName(name), lang)}
                      {localStorage.getItem('tenantApartmentNumber') ? ` · ${t('apt_word')} ${localStorage.getItem('tenantApartmentNumber')}` : ''}
                    </div>
                  </div>
                  <span style={{ color: '#b8862f', fontSize: '0.85rem', fontWeight: 600 }}>{t('view_link')}</span>
                </div>
              </div>

              {/* Right: quick grid */}
              <div style={{ flex: 1, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12, minWidth: 0 }}>
                {[
                  { label: t('tab_myApt'),         goTab: 'my-apartment',  icon: <TileIcon name="home" color={TENANT_TILE_TEXT} />, bg: TENANT_TILE_BG },
                  { label: t('stages_count'),       goTab: 'stages',        icon: <TileIcon name="stages" color={TENANT_TILE_TEXT} />, bg: TENANT_TILE_BG },
                  { label: t('tab_announcements'),  goTab: 'announcements', icon: <TileIcon name="announcements" color={TENANT_TILE_TEXT} />, bg: TENANT_TILE_BG },
                  { label: t('tab_gallery'),        goTab: 'gallery',       icon: <TileIcon name="gallery" color={TENANT_TILE_TEXT} />, bg: TENANT_TILE_BG },
                  { label: t('tab_files'),          goTab: 'files',         icon: <TileIcon name="files" color={TENANT_TILE_TEXT} />, bg: TENANT_TILE_BG },
                  // The 📞 emoji PNG (TileIcon "contacts") renders as a plain
                  // black/grey receiver in this icon set — invisible on a
                  // dark tile background. An inline SVG can actually take a
                  // color, unlike the fixed-color emoji PNGs TileIcon uses.
                  { label: t('tab_contacts'), goTab: 'contacts', bg: TENANT_TILE_BG, icon: (
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                      <path d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.9 21 3 13.1 3 3c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.4 0 .8-.2 1L6.6 10.8z" fill="#e11d48" />
                    </svg>
                  ) },
                ].map(tile => (
                  <button key={tile.goTab} onClick={() => setTab(tile.goTab)}
                    style={{ background: tile.bg, border: '1px solid #ece5d5', borderRadius: 10, padding: '18px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, cursor: 'pointer', transition: 'transform 0.15s', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}
                    onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                    onMouseOut={e => e.currentTarget.style.transform = 'none'}>
                    {tile.icon || <span style={{ color: '#e8c477', fontSize: '0.85rem', fontWeight: 600 }}>{t('all_services')}</span>}
                    <span style={{ fontSize: '0.82rem', fontWeight: 600, color: TENANT_TILE_TEXT }}>{tile.label}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        );
      })()}

      {/* My Apartment */}
      {tab === 'my-apartment' && (() => {
        // "מסמכי בניין" now shows only Tabu deeds plus anything uploaded from
        // today onward — older letters/notices (e.g. "הודעה על כנס חתימות")
        // stay hidden without deleting the underlying files.
        const BUILDING_DOCS_CUTOFF = new Date(); BUILDING_DOCS_CUTOFF.setHours(0, 0, 0, 0);
        // Admins have uploaded this category under both the singular ("נסח
        // טאבו") and plural ("נסחי טאבו") spelling depending on the project —
        // match either so a real deed file doesn't silently disappear here.
        const buildingFiles = files.filter(f =>
          f.recipient && f.recipient.startsWith('building:') &&
          (f.category === 'נסחי טאבו' || f.category === 'נסח טאבו' || (f.created_at && new Date(f.created_at) >= BUILDING_DOCS_CUTOFF))
        );
        const personalFiles = files.filter(f => f.recipient && f.recipient.startsWith('specific:'));
        const aptNum = localStorage.getItem('tenantApartmentNumber') || '';
        const fullAddr = localStorage.getItem('tenantBuildingFull') || tenantBuilding || '';
        const GOLD = TENANT_THEME;
        const DARK = '#1a3320';
        const MUTED = '#4a7a52';
        const GOLD_BG = '#c8e6b4';
        const auth = localStorage.getItem('tenantToken') || localStorage.getItem('token') || '';

        // TAMA buildings at ברוך קרוא 11/20/22/24 have their own technical spec,
        // separate from the general project spec — fall back to the general one
        // if no TAMA-specific spec was entered yet.
        const isTamaBuilding = (aptDetails.building_address || '').replace(/\s+/g, '') === 'ברוךקרוא'
          && ['11', '20', '22', '24'].includes(String(aptDetails.building_number || '').trim());
        const usingTamaSpec = isTamaBuilding && Object.keys(buildingSpecsTama).some(k => buildingSpecsTama[k]);
        const activeSpec = usingTamaSpec ? buildingSpecsTama : buildingSpecs;

        // TAMA buildings (11,20,22,24) reuse the same DB columns with different
        // real-world meanings than the general spec.
        const SPEC_LABELS = usingTamaSpec ? {
          flooring: 'ריצוף מרפסת', bathroom_flooring: 'לובי כניסה ראשי', interior_doors: 'ריצוף מבואות קומתיות',
          ac: 'מעטפת וחיפוי הבניין', sanitary: 'חדר ממ"ד', ceiling_height: 'עבודות פיתוח',
          elevator: 'מעלית', entrance_door: 'דלת כניסה', windows_shutters: 'חלונות ותריסים', kitchen: 'מסתור כביסה',
        } : {
          flooring: 'ריצוף', bathroom_flooring: 'ריצוף אמבטיה', interior_doors: 'דלתות פנים',
          ac: 'מיזוג', sanitary: 'סניטריה', ceiling_height: 'גובה תקרה',
          elevator: 'מעלית', entrance_door: 'דלת כניסה', windows_shutters: 'חלונות ותריסים', kitchen: 'מטבח',
        };
        const specEntries = Object.entries(SPEC_LABELS).filter(([k]) => activeSpec[k]);

        function AuraFileRow({ f }) {
          const isPdf = f.mime_type === 'application/pdf';
          const isImg = f.mime_type && f.mime_type.startsWith('image/');
          const fileUrl = f.url.startsWith('http') ? f.url : window.location.origin + f.url;
          return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'white', borderRadius: 16, padding: '14px 18px', gap: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
                <div style={{ width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {isPdf ? <PdfIcon size={30} /> : isImg ? '🖼' : '📄'}
                </div>
                <span style={{ fontWeight: 600, fontSize: '0.88rem', color: DARK, wordBreak: 'break-word' }}>{tr(stripExt(f.original_name || f.name), lang)}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0 }}>
                <button onClick={() => { window.open(fileUrl, '_blank'); logTenantAction('tenant_file_view', { name: f.original_name || f.name }); }} title="צפה" style={{ border: 'none', background: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}><EyeIcon color={GOLD} /></button>
                <button onClick={() => { logTenantAction('tenant_file_download', { name: f.original_name || f.name }); fetch(fileUrl).then(r=>r.blob()).then(blob=>{ const a=document.createElement('a'); a.href=URL.createObjectURL(blob); a.download=downloadFilename(f.original_name||f.name, fileUrl); document.body.appendChild(a); a.click(); document.body.removeChild(a); setTimeout(()=>URL.revokeObjectURL(a.href),1000); }); }} title="הורד" style={{ border: 'none', background: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}><DownloadIcon color={GOLD} /></button>
              </div>
            </div>
          );
        }

        return (
          <div style={{ fontFamily: "'Rubik', system-ui, sans-serif" }}>

            {/* Hero card */}
            <div style={{ display: 'flex', gap: 16, alignItems: 'center', background: 'white', borderRadius: 20, padding: '20px 24px', marginBottom: 24 }}>
              {aptNum && (
                <div style={{ width: 64, height: 64, borderRadius: 16, background: '#E09548', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1.6rem', color: 'white', flexShrink: 0 }}>
                  {aptNum}
                </div>
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                {tenantName && <div style={{ fontSize: '0.78rem', color: '#a4864f', marginBottom: 3 }}>{t('apt_of')} {tr(tenantName, lang)}</div>}
                <div style={{ fontWeight: 700, fontSize: isMobile ? '1rem' : '1.2rem', color: DARK }}>
                  {tr(fullAddr.replace(name, displayName(name)), lang)}{aptNum ? ` · ${t('apt_word')} ${aptNum}` : ''}
                </div>
              </div>
            </div>

            {/* Building rendering (site aerial) + floorplan-with-your-apartment, side by side.
                Each card picks its own caption side independently, from its own marker's
                vertical position on its own image — the aerial "you are here" dot and the
                floorplan dot live on two unrelated images, so forcing them to match made the
                aerial caption jump to the bottom whenever the floorplan unit happened to be
                in the lower half, even though the aerial dot itself was still up top. */}
            {/* A project with no per-unit markers (empty markers array, e.g.
                a single consolidated building with no letter/number layout
                to point at) just shows the rendering as-is — no dot needed,
                so it doesn't require new_building_number to be set either. */}
            {(() => {
              const rendering = BUILDING_RENDERINGS[name];
              const noMarkers = rendering && rendering.markers.length === 0;
              const showAerial = rendering && (aptDetails.new_building_number || noMarkers);
              return (showAerial || floorplan.image_url) ? (
              <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 24 }}>
                {showAerial && (
                  <MarkerCard
                    title="📍 מיקום הבניין שלך"
                    image={rendering.image}
                    markers={noMarkers ? [] : rendering.markers.map(m => ({ key: m.num, top: m.top, left: m.left }))}
                    myKey={noMarkers ? null : aptDetails.new_building_number}
                    labelText="אתה כאן"
                    isMobile={isMobile}
                    overlayOnImage
                    lang={lang}
                  />
                )}
                {floorplan.image_url && (
                  <MarkerCard
                    title="🗺️ תוכנית הדירה שלך"
                    image={floorplan.image_url}
                    markers={(floorplan.markers || []).map(m => ({
                      key: m.letter, top: m.top_pct, left: m.left_pct,
                      rectLeft: m.rect_left_pct, rectTop: m.rect_top_pct, rectWidth: m.rect_width_pct, rectHeight: m.rect_height_pct,
                      polygon: m.polygon_pct,
                      labelTop: m.label_top_pct, labelLeft: m.label_left_pct,
                    }))}
                    myKey={floorplan.apartment_letter}
                    isMobile={isMobile}
                    labelText="זו התוכנית של הדירה שלך"
                    // Same on-image pill+line style as the aerial card, for
                    // every floorplan — TAMA buildings (11/20/22/24) rely on
                    // the admin having dragged the label to an explicit safe
                    // spot in the floorplan editor (labelTop/labelLeft) so it
                    // doesn't land on the drawing; regular buildings fall
                    // back to the auto-computed near-edge position.
                    overlayOnImage
                    lang={lang}
                    {...(['1', '2', '3', '4', '5', '8', '9', '10', '11', '12'].includes(String(aptDetails.new_building_number))
                      || ((aptDetails.building_address || '').replace(/\s+/g, '') === 'ברוךקרוא' && ['11', '20', '22', '24'].includes(String(aptDetails.building_number || '').trim()))
                      ? { polygonColor: '#7B1E2B', polygonFill: 'rgba(123,30,43,0.30)' } : {})}
                  />
                )}
              </div>
              ) : null;
            })()}

            {/* Apartment comparison (current vs new) — uses projectComp for new values */}
            {(aptDetails.current_size || projectComp.size_addition || projectComp.floor_type || projectComp.balcony_addition || projectComp.parking_tabu || projectComp.storage_addition) && (() => {
              const curSize = parseFloat(aptDetails.current_size) || 0;
              const addSize = parseFloat(projectComp.size_addition) || 0;
              const newSize = curSize + addSize;
              const displayNewSize = addSize ? String(newSize % 1 === 0 ? newSize : newSize.toFixed(1)) : null;
              const sizeDiff = addSize && curSize ? `+${addSize % 1 === 0 ? addSize : addSize.toFixed(1)}` : null;
              // TAMA buildings at ברוך קרוא 11/20/22/24 keep the same floor in the
              // new building — show the current floor as-is instead of the
              // project-wide "middle third" formula. (isTamaBuilding is hoisted above.)
              const floorNew = (() => {
                // A new_floor of "8-13" etc. means the exact floor within the new
                // building isn't decided yet — show the generic "middle third,
                // higher floor" wording instead of a raw range a tenant can't
                // interpret. Only a single concrete floor number is shown as-is.
                if (aptDetails.new_floor) {
                  return String(aptDetails.new_floor).includes('-')
                    ? 'בשליש האמצעי של הבניין החדש ובקומה גבוהה יותר'
                    : aptDetails.new_floor;
                }
                if (isTamaBuilding) return aptDetails.current_floor || null;
                if (!projectComp.floor_type) return null;
                if (projectComp.floor_type === 'middle_third') return 'שליש אמצעי של הבניין';
                if (projectComp.floor_type === 'pending') return 'טרם נקבע';
                if (projectComp.floor_type === 'addition') {
                  const add = parseFloat(projectComp.new_floor) || 0;
                  const cur = parseFloat(aptDetails.current_floor);
                  return isNaN(cur) ? (add ? `+${add} קומות` : null) : String(cur + add);
                }
                if (projectComp.floor_type === 'floor_other') return projectComp.new_floor || null;
                return null;
              })();
              const fmtN = v => { const s = String(v ?? ''); if (!s || s === 'NaN' || s === 'null' || s === '__other__') return '0'; if (s === 'בהתאם לתנאי ההסכם') return 'בהתאם לתנאי ההסכם'; const n = parseFloat(s); return isNaN(n) ? (s || '0') : (n % 1 === 0 ? String(n) : n.toFixed(1)); };
              // TAMA buildings at ברוך קרוא 11/20/22/24 don't include parking in
              // the plan — hide that row entirely for tenants in those buildings.
              const isTamaNoParking = isTamaBuilding;
              const compRows = [
                { label: t('size_sqm'), cur: fmtN(aptDetails.current_size || '0'), nw: displayNewSize, show: !!(curSize || addSize) },
                { label: t('floor'), cur: aptDetails.current_floor || '—', nw: floorNew, show: !!(aptDetails.current_floor || floorNew) },
                { label: t('balcony_sqm'), cur: fmtN(aptDetails.current_balcony ?? '0'), nw: fmtN(projectComp.balcony_addition || '0'), show: true },
                { label: t('parking'), cur: fmtN(aptDetails.current_parking ?? '0'), nw: fmtN(projectComp.parking_tabu || '0'), show: !isTamaNoParking },
                { label: t('storage_sqm'), cur: fmtN(aptDetails.current_storage ?? '0'), nw: fmtN(projectComp.storage_addition || '0'), show: true },
              ].filter(r => r.show);
              return (
                <div style={{ marginBottom: 24 }}>
                  {aptDetails.new_building_number && name === 'ג החדשה' && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
                      <div style={{ background: '#7B1E2B', color: 'white', fontWeight: 800, fontSize: '0.95rem', padding: '9px 26px', borderRadius: 999, boxShadow: '0 4px 14px rgba(123,30,43,0.35)' }}>
                        {t('located_in_building')} {aptDetails.new_building_number}
                      </div>
                    </div>
                  )}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 44px 1fr', gap: 0, marginBottom: 8 }}>
                    <div style={{ textAlign: 'center', fontSize: '0.8rem', fontWeight: 700, color: MUTED, paddingBottom: 8 }}>{t('old_apt')}</div>
                    <div />
                    <div style={{ textAlign: 'center', fontSize: '0.8rem', fontWeight: 700, color: GOLD, paddingBottom: 8 }}>{t('new_apt')}</div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {compRows.map((r, i) => (
                      <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 44px 1fr', gap: 0, alignItems: 'stretch' }}>
                        <div style={{ background: '#e8f5de', borderRadius: 14, padding: '14px 18px', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <div style={{ fontSize: '0.72rem', color: MUTED, marginBottom: 6, fontWeight: 600 }}>{r.label}</div>
                          <div style={{ fontSize: '1.25rem', fontWeight: 700, color: DARK }}>{tr(r.cur, lang)}</div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#ccc', fontSize: '1.8rem', lineHeight: 1 }}>←</div>
                        <div style={{ background: GOLD_BG, borderRadius: 14, padding: '14px 18px', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <div style={{ fontSize: '0.72rem', color: GOLD, marginBottom: 6, fontWeight: 600 }}>{r.label}</div>
                          <div style={{ fontSize: '1.25rem', fontWeight: 700, color: DARK }}>
                            {tr(r.nw, lang) || '—'}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 10, fontSize: '0.78rem', color: '#6b7280', lineHeight: 1.5 }}>
                    <span style={{ fontWeight: 700 }}>*</span> {t('change_note2')}{isMobile ? <br /> : <>&nbsp;&nbsp;</>}<span style={{ fontWeight: 700 }}>**</span> {t('change_note')}
                  </div>
                </div>
              );
            })()}

            {/* Agreement PDF — the button just jumps to Files pre-filtered by
                category, it never actually links to buildingSpecs.agreement_pdf_url
                itself. That field required a SEPARATE upload duplicating a file
                admins had usually already uploaded to Files under the same
                category — so also show the button when such a file already
                exists there, instead of forcing a redundant re-upload. */}
            {(() => {
              const _addr = (localStorage.getItem('tenantBuildingAddress') || '').replace(/\s/g, '');
              const _full = localStorage.getItem('tenantBuildingFull') || '';
              const _num  = _full.replace(localStorage.getItem('tenantBuildingAddress') || '', '').trim();
              const isChizukBtn = _addr === 'ברוךקרוא' && ['11','20','22','24'].includes(_num);
              const agreementCategory = isChizukBtn ? 'הסכם פינוי בינוי חיזוק ותוספות' : 'הסכם פינוי בינוי';
              const hasAgreementFile = buildingSpecs.agreement_pdf_url || files.some(f => f.category === agreementCategory);
              if (!hasAgreementFile) return null;
              return (
                <div style={{ marginBottom: 20 }}>
                  <button onClick={() => {
                    setTab('files');
                    if (isChizukBtn) {
                      setFilesSubTab('personal');
                      setFilesCatFilter('הסכם פינוי בינוי חיזוק ותוספות');
                    } else {
                      setFilesSubTab('general');
                      setFilesCatFilter('הסכם פינוי בינוי');
                    }
                  }}
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#1d4ed8', color: 'white', padding: '10px 20px', borderRadius: 10, fontWeight: 700, fontSize: '0.9rem', border: 'none', cursor: 'pointer' }}>
                    {t('view_full_agreement')}
                  </button>
                </div>
              );
            })()}

            {/* Building specs */}
            {specEntries.length > 0 && (
              <div style={{ marginBottom: 24 }}>
                <div style={{ fontWeight: 700, fontSize: '1rem', color: DARK, marginBottom: 12 }}>{t('tech_spec_title')}</div>
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)', gap: 10 }}>
                  {specEntries.map(([k, label]) => (
                    <div key={k} style={{ background: 'white', borderRadius: 14, padding: '16px 18px' }}>
                      <div style={{ fontSize: '0.72rem', fontWeight: 600, color: GOLD, marginBottom: 5 }}>{tr(label, lang)}</div>
                      <div style={{ fontSize: '0.82rem', color: MUTED, lineHeight: 1.55 }}><RichText text={tr(activeSpec[k], lang)} /></div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Building files */}
            {buildingFiles.length > 0 && (
              <div style={{ marginBottom: 24 }}>
                <div style={{ fontWeight: 700, fontSize: '1rem', color: DARK, marginBottom: 12 }}>{t('building_docs')}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {buildingFiles.map(f => <AuraFileRow key={f.id} f={f} />)}
                </div>
              </div>
            )}

            {/* Personal files — only if sent to this specific tenant */}
            {personalFiles.length > 0 && (
              <div style={{ marginBottom: 24 }}>
                <div style={{ fontWeight: 700, fontSize: '1rem', color: DARK, marginBottom: 12 }}>{t('personal_docs')}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>{personalFiles.map(f => <AuraFileRow key={f.id} f={f} />)}</div>
              </div>
            )}

          </div>
        );
      })()}

      {/* New Compensations */}
      {tab === 'new-comp' && (() => {
        const cur_size = parseFloat(aptDetails.current_size)    || 0;
        const cur_bal  = parseFloat(aptDetails.current_balcony) || 0;
        const cur_park = parseFloat(aptDetails.current_parking) || 0;
        const cur_stor = parseFloat(aptDetails.current_storage) || 0;
        const add_size = parseFloat(projectComp.size_addition)  || 0;
        const add_bal  = parseFloat(projectComp.balcony_addition)|| 0;
        const add_park = parseFloat(projectComp.parking_tabu)   || 0;
        const add_stor = parseFloat(projectComp.storage_addition)|| 0;
        const nw_size  = cur_size + add_size;
        const nw_bal   = cur_bal  + add_bal;
        const nw_park  = cur_park + add_park;
        const nw_stor  = cur_stor + add_stor;
        const fmt = v => { if (v == null || isNaN(v)) return '0'; return v % 1 === 0 ? String(v) : v.toFixed(1); };
        const fmtDiff = d => d === 0 ? null : (d > 0 ? `+${fmt(d)}` : fmt(d));
        const rows = [
          { label: `שטח דירה (מ"ר)`, cur: cur_size || '—', nw: add_size ? fmt(nw_size) : '—', diff: add_size && cur_size ? fmtDiff(add_size) : null, emoji: '📐' },
          { label: 'קומה',            cur: aptDetails.current_floor || '—', nw: aptDetails.new_floor || (projectComp.new_floor || 'בהתאם לתוכנית'), diff: null, emoji: '🏢' },
          { label: `שטח מרפסת (מ"ר)`, cur: fmt(cur_bal), nw: add_bal ? fmt(nw_bal) : '0', diff: add_bal ? fmtDiff(add_bal) : null, emoji: '🌅' },
          { label: 'חנייה בטאבו',     cur: fmt(cur_park), nw: add_park ? fmt(nw_park) : '0', diff: add_park ? fmtDiff(add_park) : null, emoji: '🚗' },
          { label: `מחסן בטאבו (מ"ר)`, cur: fmt(cur_stor), nw: add_stor ? fmt(nw_stor) : '0', diff: add_stor ? fmtDiff(add_stor) : null, emoji: '📦' },
        ];
        const hasData = projectComp.size_addition || projectComp.new_floor || projectComp.balcony_addition || projectComp.parking_tabu || projectComp.storage_addition;
        return (
          <div style={{ padding: '0 0 24px' }}>
            <div style={{ fontWeight: 700, fontSize: '1.1rem', color: DARK, marginBottom: 4 }}>✨ תמורות חדשות</div>
            <div style={{ fontSize: '0.8rem', color: MUTED, marginBottom: 20 }}>הנתונים שיתקבלו בדירה החדשה</div>
            {!hasData ? (
              <div style={{ background: 'white', borderRadius: 14, padding: 24, textAlign: 'center', color: MUTED, fontSize: '0.9rem' }}>
                הנתונים טרם הוזנו על ידי הצוות
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {rows.map((r, i) => (
                  <div key={i} style={{ background: 'white', borderRadius: 14, padding: '14px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontSize: '1.4rem' }}>{r.emoji}</span>
                      <div>
                        <div style={{ fontSize: '0.72rem', color: MUTED, fontWeight: 600 }}>{r.label}</div>
                        <div style={{ fontSize: '0.82rem', color: DARK, marginTop: 2 }}>
                          <span style={{ color: MUTED }}>{tr(r.cur, lang)}</span>
                          <span style={{ margin: '0 6px', color: '#ccc' }}>←</span>
                          <span style={{ fontWeight: 700, color: DARK }}>{tr(r.nw, lang)}</span>
                          {r.diff && <span style={{ marginRight: 8, fontSize: '0.75rem', fontWeight: 700, color: r.diff.startsWith('+') ? '#15803d' : '#dc2626', background: r.diff.startsWith('+') ? '#f0fdf4' : '#fef2f2', borderRadius: 6, padding: '2px 7px' }}>{r.diff}</span>}
                        </div>
                      </div>
                    </div>
                    <div style={{ textAlign: 'left', minWidth: 60 }}>
                      <div style={{ fontSize: '1.3rem', fontWeight: 800, color: GOLD }}>{tr(r.nw, lang)}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })()}

      {/* Stages */}
      {tab === 'stages' && (() => {
        const AURA_CAT = {
          'תב"ע':                      { header: '#7F3DE8', rowBg: '#F5F3FE', border: '#e4dcf8' },
          'תכנית עיצוב אדריכלי':       { header: '#344FD3', rowBg: '#F0F6FE', border: '#d8e4f8' },
          'היתר בנייה':                { header: '#5B4FE8', rowBg: '#F1EFFE', border: '#ddd6fb' },
        };
        const DEFAULT_AURA = { header: '#c98a3f', rowBg: '#fdf8f0', border: '#ecdfc4' };

        const BADGE = {
          completed: { bg: '#eef3ea', color: '#4c7a4f', label: 'הושלם' },
          active:    { bg: '#f3e3c8', color: '#c98a3f', label: 'בביצוע' },
          pending:   { bg: '#f6f1e6', color: '#a4864f', label: 'טרם התחיל' },
        };

        const circumference = 251;
        const offset = Math.round(circumference * (1 - overall / 100));
        const currentStage = stages.find(s => s.status === 'active') || stages.find(s => s.status === 'pending');

        return (
          <div>
            {/* Progress ring */}
            <div style={{ background: 'white', borderRadius: 20, padding: '22px 26px', marginBottom: 20, display: 'flex', gap: 20, alignItems: 'center' }}>
              <div style={{ position: 'relative', width: 96, height: 96, flexShrink: 0 }}>
                <svg width="96" height="96" viewBox="0 0 96 96">
                  <circle cx="48" cy="48" r="40" fill="none" stroke="#f3e3c8" strokeWidth="10" />
                  <circle cx="48" cy="48" r="40" fill="none" stroke="#c98a3f" strokeWidth="10"
                    strokeDasharray={String(circumference)} strokeDashoffset={String(offset)}
                    strokeLinecap="round" transform="rotate(-90 48 48)" />
                </svg>
                <div style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1.2rem', color: '#c98a3f' }}>{overall}%</div>
              </div>
              <div>
                <div style={{ fontSize: '0.78rem', color: '#a4864f', marginBottom: 4 }}>{t('overall_progress')}</div>
                <div style={{ fontWeight: 700, fontSize: '1.1rem', color: '#4a3a24' }}>
                  {currentStage ? `${t('we_are_at_stage')} ${localize(currentStage, 'name', lang)}` : overall === 100 ? t('project_completed') : t('project_starting')}
                </div>
              </div>
            </div>

            {stages.length === 0 && <p style={{ color: '#a4864f', textAlign: 'center', marginTop: 40 }}>{t('no_stages_yet')}</p>}
            {stages.length > 0 && <div style={{ fontWeight: 700, fontSize: '1.05rem', color: '#4a3a24', marginBottom: 14 }}>{t('stages_count')}</div>}

            {(() => {
              const groupedEntries = Object.entries(grouped);
              // The connecting timeline line spans the WHOLE project, not each category on
              // its own — so "first"/"last" are computed across every category's visible
              // top-level stages combined, in render order, not reset per category.
              // ד' החדשה wants a flat תב"ע list, no parent/child grouping.
              const useHierarchy = name !== 'ד החדשה';
              const allVisibleStagesFlat = groupedEntries.flatMap(([, catStages]) =>
                catStages.filter(s => !(useHierarchy && ALL_CHILD_NAMES_TENANT.has(s.name) && catStages.some(p => (STAGE_HIERARCHY[p.name] || []).includes(s.name))))
              );
              const globalFirstId = allVisibleStagesFlat[0]?.id;
              const globalLastId = allVisibleStagesFlat[allVisibleStagesFlat.length - 1]?.id;

              return groupedEntries.map(([cat, catStages], catIdx) => {
              const clr = AURA_CAT[cat] || DEFAULT_AURA;
              const allDone = catStages.every(s => s.status === 'completed');
              const anyActive = catStages.some(s => s.status === 'active');
              const catBadge = allDone ? BADGE.completed : anyActive ? BADGE.active : BADGE.pending;
              const catLabel = allDone ? statusLabels.completed : anyActive ? statusLabels.active : statusLabels.pending;
              const isLastCategory = catIdx === groupedEntries.length - 1;

              return (
                <React.Fragment key={cat}>
                <div style={{ background: 'white', borderRadius: 20, padding: '18px 22px', marginBottom: isLastCategory ? 14 : 0, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                  {/* Category header */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, padding: '10px 14px', background: clr.header, borderRadius: 12 }}>
                    <span style={{ color: 'white', fontWeight: 700, fontSize: '0.95rem' }}>{categoryLabel(cat, lang)}</span>
                    <span style={{ background: catBadge.bg, color: catBadge.color, fontWeight: 600, fontSize: '0.75rem', borderRadius: 14, padding: '5px 14px' }}>{catLabel}</span>
                  </div>

                  {/* Stage rows */}
                  {(() => {
                    let visIdx = 0;
                    const rows = [];
                    catStages.forEach(s => {
                      if (useHierarchy && ALL_CHILD_NAMES_TENANT.has(s.name) && catStages.some(p => (STAGE_HIERARCHY[p.name] || []).includes(s.name))) return;
                      const isFirstVisible = globalFirstId === s.id;
                      const isLastVisible = globalLastId === s.id;
                      const childNames = useHierarchy ? (STAGE_HIERARCHY[s.name] || []) : [];
                      const childStages = childNames.map(n => catStages.find(x => x.name === n)).filter(Boolean);
                      const isExp = !!stageExpanded[s.id];
                      const idx = visIdx++;
                      const isDone = s.status === 'completed';
                      const isAct = s.status === 'active';
                      const badge = isDone ? BADGE.completed : isAct ? BADGE.active : BADGE.pending;
                      const circleBg = isDone ? '#4c7a4f' : isAct ? '#f3e3c8' : '#f6f1e6';
                      const circleColor = isDone ? '#fff' : isAct ? '#c98a3f' : '#a4864f';

                      rows.push(
                        <div key={s.id}>
                          <div style={{ display: 'flex', alignItems: 'stretch', gap: 12, padding: '11px 22px', minHeight: 58, borderTop: `1px solid ${clr.border}`, background: clr.rowBg, marginLeft: -22, marginRight: -22 }}>
                            {/* Timeline column — an in-flow (not absolutely positioned) vertical line that
                                keeps the circle perfectly centered between two equal flex spacers. Adjacent
                                rows' spacers touch at the shared row border, so the line reads as one
                                continuous stroke from the first stage to the last, with a downward arrow
                                capping only the very last one. Absolute/percent positioning was tried first
                                but collapsed to zero height in longer categories — flex:1 spacers can't. */}
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 28, flexShrink: 0, alignSelf: 'stretch' }}>
                              {/* flex:1 alone can resolve to 0 (collapsing the line to an
                                  invisible sliver) if the browser doesn't treat this column's
                                  stretched height as independently determinate — minHeight is a
                                  floor that guarantees a visible bar either way. */}
                              {isFirstVisible
                                ? <div style={{ flex: 1, minHeight: 16 }} />
                                : <div style={{ width: 4, flex: 1, minHeight: 16, background: clr.header }} />}
                              <div style={{ width: 28, height: 28, borderRadius: '50%', background: circleBg, color: circleColor, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.78rem', flexShrink: 0 }}>
                                {isDone ? '✓' : idx + 1}
                              </div>
                              {isLastVisible
                                ? (isFirstVisible
                                    ? <div style={{ flex: 1, minHeight: 16 }} />
                                    : (
                                      <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <div style={{ width: 4, height: 10, background: clr.header }} />
                                        <div style={{ width: 0, height: 0, borderLeft: '7px solid transparent', borderRight: '7px solid transparent', borderTop: `11px solid ${clr.header}` }} />
                                      </div>
                                    ))
                                : <div style={{ width: 4, flex: 1, minHeight: 16, background: clr.header }} />}
                            </div>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', minWidth: 0 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                                <span style={{ color: '#4a3a24', fontWeight: 600, fontSize: '0.88rem' }}>{localize(s, 'name', lang)}</span>
                                {childStages.length > 0 && (
                                  <button onClick={() => setStageExpanded(e => ({ ...e, [s.id]: !e[s.id] }))}
                                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: clr.header, fontSize: '0.9rem', padding: 0, flexShrink: 0 }}>
                                    {isExp ? '▲' : '▼'}
                                  </button>
                                )}
                              </div>
                              <span style={{ background: badge.bg, color: badge.color, fontWeight: 600, fontSize: '0.72rem', borderRadius: 14, padding: '5px 14px', flexShrink: 0 }}>
                                {isDone ? statusLabels.completed : isAct ? statusLabels.active : statusLabels.pending}
                              </span>
                            </div>
                          </div>
                          {isExp && childStages.map(child => {
                            const cd = child.status === 'completed';
                            const ca = child.status === 'active';
                            const cb = cd ? BADGE.completed : ca ? BADGE.active : BADGE.pending;
                            const ccBg = cd ? '#4c7a4f' : ca ? '#f3e3c8' : '#f6f1e6';
                            const ccClr = cd ? '#fff' : ca ? '#c98a3f' : '#a4864f';
                            return (
                              <div key={child.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 22px 9px 40px', borderTop: `1px solid ${clr.border}`, background: clr.rowBg, marginLeft: -22, marginRight: -22 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                  <div style={{ width: 22, height: 22, borderRadius: '50%', background: ccBg, color: ccClr, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.7rem', flexShrink: 0 }}>
                                    {cd ? '✓' : '·'}
                                  </div>
                                  <span style={{ color: '#4a3a24', fontWeight: 500, fontSize: '0.84rem' }}>{localize(child, 'name', lang)}</span>
                                </div>
                                <span style={{ background: cb.bg, color: cb.color, fontWeight: 600, fontSize: '0.7rem', borderRadius: 14, padding: '4px 12px', flexShrink: 0 }}>{cd ? statusLabels.completed : ca ? statusLabels.active : statusLabels.pending}</span>
                              </div>
                            );
                          })}
                        </div>
                      );
                    });
                    return rows;
                  })()}
                </div>
                {/* Bridges the line across the gap between category cards so it reads as one
                    continuous stroke for the whole project, not one per category. */}
                {!isLastCategory && (
                  <div style={{ display: 'flex', height: 14, padding: '0 22px' }}>
                    <div style={{ width: 28, flexShrink: 0, display: 'flex', justifyContent: 'center' }}>
                      <div style={{ width: 4, height: '100%', background: clr.header }} />
                    </div>
                  </div>
                )}
                </React.Fragment>
              );
              });
            })()}
          </div>
        );
      })()}

      {/* Announcements */}
      {tab === 'announcements' && (
        <AnnouncementsSection announcements={announcements} t={t} projectName={projectName} lang={lang} />
      )}

      {/* Events / RSVP */}
      {tab === 'events' && (
        <EventsSection phone={tenantPhone} projectName={name} t={t} />
      )}

      {/* Gallery */}
      {tab === 'gallery' && <GallerySection gallery={gallery} lang={lang} hideFromAllCategory="אירועי חתימות" />}

      {/* Contacts */}
      {tab === 'contacts' && (
        <div>
          {contacts.length === 0 && <p style={{ color: '#9ca3af', textAlign: 'center' }}>{t('no_contacts')}</p>}
          {(() => {
            const CAT_COLORS = {
              'יזם': '#7c3aed',
              'מנהלת הדיירים': '#1d4ed8',
              'עורך דין יזם': '#0f766e',
              'עורך דין דיירים': '#b45309',
              'עורך דין': '#b45309',
              'שמאי דיירים': '#be185d',
              'שמאי': '#be185d',
            };
            const DEFAULT_CAT_COLOR = '#475569';
            // Contact filtering by building:
            // Category "שמאי תנין 1" → show only to tenants whose buildingAddress = "תנין 1"
            // Category "שמאי דיירים"  → show to tenants NOT in a building that has a specific override
            // The building address stored at login is used as the filter key.
            const GENERIC_QUALIFIERS = new Set(['דיירים', 'יזם', 'יזמים', 'דיירות', 'כללי', 'פרויקט', 'מטעם הדיירים', 'מטעם היזם']);
            const allCatList = [...new Set(contacts.map(c => c.category).filter(Boolean))];

            // Detect all non-generic suffixes (= building/project names used in categories)
            const suffixToCats = {};
            allCatList.forEach(catA => {
              allCatList.forEach(catB => {
                if (catA === catB) return;
                const wA = catA.split(' '), wB = catB.split(' ');
                let shared = 0;
                for (let i = 0; i < Math.min(wA.length, wB.length); i++) {
                  if (wA[i] === wB[i]) shared++; else break;
                }
                if (shared > 0 && shared < wA.length) {
                  const sfx = wA.slice(shared).join(' ');
                  if (!suffixToCats[sfx]) suffixToCats[sfx] = new Set();
                  suffixToCats[sfx].add(catA);
                }
              });
            });
            // Specific suffixes: appear 2+ times and are NOT generic qualifiers
            const specificSuffixes = new Set(
              Object.entries(suffixToCats)
                .filter(([sfx, cats]) => cats.size >= 2 && !GENERIC_QUALIFIERS.has(sfx))
                .map(([sfx]) => sfx)
            );

            // The suffix matching this tenant's building:
            // e.g. tenantBuilding="תנין", suffix="תנין 1" → "תנין 1".includes("תנין") = true
            const myBuildingSuffix = [...specificSuffixes].find(sfx => tenantBuilding && sfx.includes(tenantBuilding)) || '';

            // Filter by building: show contact if building is null/empty OR matches tenant's building
            // (must run BEFORE the specific-category detection below, since a category
            // override should only hide the generic card when the override contact
            // ACTUALLY reaches this tenant — e.g. "עורך דין תנין" tagged building="תנין 1"
            // must only suppress the generic lawyer card for building 1, not for every
            // tenant on the same street).
            const tenantBuildingFull = localStorage.getItem('tenantBuildingFull') || tenantBuilding || '';
            const visibleContacts = contacts.filter(c =>
              !c.building || c.building === tenantBuildingFull || tenantBuildingFull.includes(c.building) || c.building.includes(tenantBuildingFull)
            );

            // Categories specific to THIS tenant's building — only from contacts that
            // already passed the building filter above.
            const projectSuffix = myBuildingSuffix ? ' ' + myBuildingSuffix : (' ' + name);
            const projectSpecificCats = new Set(
              visibleContacts.filter(c => c.category && myBuildingSuffix && c.category.endsWith(' ' + myBuildingSuffix)).map(c => c.category)
            );
            const coveredBases = new Set(
              [...projectSpecificCats].map(cat => cat.slice(0, cat.length - (' ' + myBuildingSuffix).length).trim())
            );
            // Only the generic TENANT-side card (e.g. "עורך דין מטעם הדיירים") should be
            // replaced by a building-specific override — a shared first word or two
            // ("עורך דין") is not enough, or "עורך דין יזם" (the developer's own lawyer,
            // a completely different role) gets wrongly swallowed too.
            const TENANT_GENERIC_SUFFIX = ' מטעם הדיירים';
            function shouldShowCat(cat) {
              if (!cat) return true;
              if (projectSpecificCats.has(cat)) return true; // this tenant's building → show
              // hide if ends with a specific suffix that is NOT this tenant's building
              for (const sfx of specificSuffixes) {
                if (sfx !== myBuildingSuffix && cat.endsWith(' ' + sfx)) return false;
              }
              // hide the generic tenant-side card only when this building has its own
              // override for that exact same role
              if (cat.endsWith(TENANT_GENERIC_SUFFIX)) {
                const base = cat.slice(0, cat.length - TENANT_GENERIC_SUFFIX.length).trim();
                if (coveredBases.has(base)) return false;
              }
              return true;
            }
            function displayCat(cat) {
              if (cat && myBuildingSuffix && cat.endsWith(' ' + myBuildingSuffix))
                return cat.slice(0, cat.length - (' ' + myBuildingSuffix).length).trim();
              return cat;
            }
            const grouped = visibleContacts.filter(c => shouldShowCat(c.category)).reduce((acc, c) => {
              const cat = c.category || 'כללי';
              if (!acc[cat]) acc[cat] = [];
              acc[cat].push(c);
              return acc;
            }, {});
            const catMinOrder = {};
            Object.keys(grouped).forEach(cat => {
              catMinOrder[cat] = Math.min(...grouped[cat].map(c => c.sort_order ?? 999));
            });
            const entries = Object.keys(grouped).sort((a, b) => {
              const diff = (catMinOrder[a] ?? 999) - (catMinOrder[b] ?? 999);
              if (diff !== 0) return diff;
              const ai = CONTACT_CAT_ORDER.indexOf(a), bi = CONTACT_CAT_ORDER.indexOf(b);
              if (ai === -1 && bi === -1) return 0;
              if (ai === -1) return 1; if (bi === -1) return -1;
              return ai - bi;
            }).map(cat => [cat, grouped[cat]]);
            const iconBtn = (href, bg, icon, title, isGradient) => (
              <a href={href} target="_blank" rel="noreferrer" title={title}
                style={{ width: 38, height: 38, borderRadius: '50%', background: isGradient ? bg : bg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', textDecoration: 'none', flexShrink: 0 }}>
                {icon}
              </a>
            );
            return (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 20 }}>
                {entries.map(([cat, list]) => (
                  <div key={cat} style={{ background: 'white', borderRadius: 20, padding: '22px 24px' }}>
                    <div style={{ fontWeight: 700, fontSize: '0.9rem', color: '#000', marginBottom: 18 }}>{tr(displayCat(cat), lang)}</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
                      {list.map((c) => {
                        const initials = (c.name || '?').charAt(0).toUpperCase();
                        const phoneNum = c.mobile || c.phone;
                        const mobileNum = c.mobile || (c.phone && /^05/.test(c.phone.replace(/\s/g, '')) ? c.phone : null);
                        const waPhoneNum = mobileNum ? mobileNum.replace(/\D/g, '').replace(/^0/, '972') : null;
                        const socialBtn = (href, bg, svgEl) => (
                          <a key={href} href={href} target="_blank" rel="noreferrer"
                            style={{ width: 32, height: 32, borderRadius: '50%', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, textDecoration: 'none' }}>
                            {svgEl}
                          </a>
                        );
                        const igGrad = 'linear-gradient(135deg,#f58529,#dd2a7b 40%,#8134af 70%,#515bd4)';
                        return (
                          <div key={c.id}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                              <div style={{ width: 42, height: 42, borderRadius: '50%', background: '#ffffff', color: '#c98a3f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1rem', flexShrink: 0, overflow: 'hidden', border: '1px solid #eee' }}>
                                {c.avatar_url
                                  ? <img src={c.avatar_url} alt={initials} style={{ width: '100%', height: '100%', objectFit: 'contain', transform: avatarTransform(c.avatar_pos, c.avatar_zoom) }}
                                      onError={e => { e.target.style.display = 'none'; e.target.parentNode.innerText = initials; }} />
                                  : c.website
                                  ? <img src={`https://www.google.com/s2/favicons?domain=${encodeURIComponent(c.website)}&sz=64`}
                                      alt={initials} style={{ width: 28, height: 28, objectFit: 'contain' }}
                                      onError={e => { e.target.style.display = 'none'; e.target.parentNode.innerText = initials; }} />
                                  : initials}
                              </div>
                              <div>
                                <div style={{ fontWeight: 600, fontSize: '0.95rem', color: '#8a8570', lineHeight: 1.3 }}>{tr(c.name || '', lang)}</div>
                                {c.role && <div style={{ fontSize: '0.78rem', color: '#000', marginTop: 2, fontWeight: 500 }}>{tr(c.role, lang)}</div>}
                                {(c.phone || c.mobile) && <div style={{ fontSize: '0.8rem', color: '#a4864f', marginTop: 3 }} dir="ltr">{c.mobile || c.phone}</div>}
                              </div>
                            </div>
                            <div style={{ display: 'flex', gap: 10, marginTop: 12, paddingRight: 54 }}>
                              {c.instagram && socialBtn(c.instagram, igGrad, <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="5" stroke="#fff" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="#fff" strokeWidth="2"/><circle cx="17.3" cy="6.7" r="1.1" fill="#fff"/></svg>)}
                              {c.facebook && socialBtn(c.facebook, '#1877f2', <svg width="13" height="13" viewBox="0 0 24 24" fill="#fff"><path d="M15 8h-2c-.8 0-1 .3-1 1v2h3l-.5 3H12v8H9v-8H7v-3h2V9c0-2.2 1.3-4 4-4h2v3z"/></svg>)}
                              {waPhoneNum && socialBtn(`https://wa.me/${waPhoneNum}`, '#25d366', <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff"><path d="M12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.3 5L2 22l5.2-1.3c1.4.8 3.1 1.3 4.8 1.3 5.5 0 10-4.5 10-10S17.5 2 12 2zm5.4 14.2c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .1-1.7-.1-.4-.1-1-.3-1.6-.6-2.9-1.2-4.7-4.2-4.9-4.4-.1-.2-1.2-1.6-1.2-3s.7-2.2 1-2.5c.3-.3.6-.3.8-.3h.6c.2 0 .4 0 .6.5.2.5.7 1.8.8 1.9.1.2.1.3 0 .5-.1.2-.1.3-.3.5-.1.2-.3.4-.4.5-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.4 2.5 1.5.3.1.5.1.7-.1.2-.2.7-.8.9-1.1.2-.3.4-.2.6-.1.2.1 1.5.7 1.8.8.3.1.4.2.5.3.1.2.1.9-.1 1.5z"/></svg>)}
                              {phoneNum && socialBtn(`tel:${phoneNum}`, '#1a7a5e', <svg width="15" height="15" viewBox="0 0 24 24" fill="#fff"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.9 21 3 13.1 3 3.6c0-.6.4-1 1-1h3.4c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg>)}
                              {c.website && socialBtn(c.website, '#2f9ea3', <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="1.7"/><path d="M3 12H21M12 3C14.5 5.5 15.8 8.5 15.8 12C15.8 15.5 14.5 18.5 12 21C9.5 18.5 8.2 15.5 8.2 12C8.2 8.5 9.5 5.5 12 3Z" stroke="#fff" strokeWidth="1.5"/></svg>)}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            );
          })()}
        </div>
      )}

      {/* Files */}
      {tab === 'files' && (() => {
        function stripExt(name) { return name ? name.replace(/\.[^/.]+$/, '') : ''; }
        function fileIcon(mime) {
          if (!mime) return '📄';
          if (mime.startsWith('image/')) return '🖼️';
          if (mime === 'application/pdf') return <PdfIcon size={22} />;
          if (mime.includes('word')) return '📝';
          if (mime.includes('excel') || mime.includes('spreadsheet')) return '📊';
          return '📄';
        }
        function formatSize(bytes) {
          if (!bytes) return '';
          if (bytes < 1024) return bytes + ' B';
          if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
          return (bytes / 1024 / 1024).toFixed(1) + ' MB';
        }
        const _addr = (localStorage.getItem('tenantBuildingAddress') || '').replace(/\s/g, '');
        const _full = localStorage.getItem('tenantBuildingFull') || '';
        const _num  = _full.replace(localStorage.getItem('tenantBuildingAddress') || '', '').trim();
        const isChizuk = _addr === 'ברוךקרוא' && ['11','20','22','24'].includes(_num);
        const personalFiles = files.filter(f => f.recipient && (f.recipient.startsWith('specific:') || f.recipient.startsWith('building:')));
        const generalFiles = files.filter(f => (!f.recipient || f.recipient === 'all') && !(isChizuk && f.category === 'הסכם פינוי בינוי'));
        const baseFiles = filesSubTab === 'personal' ? personalFiles : generalFiles;
        const allCats = [...new Set(baseFiles.map(f => f.category).filter(Boolean))];
        function fileMatchesSearch(f, q) {
          if (!q) return true;
          const query = q.trim().toLowerCase();
          if (!query) return true;
          const name = (f.original_name || f.name || '').toLowerCase();
          // Match each search word independently (any order) rather than requiring
          // the whole query as one contiguous substring — "פרוטוקול 2" should still
          // find a file named "2 פרוטוקול ישיבה".
          const words = query.split(/\s+/).filter(Boolean);
          if (words.every(w => name.includes(w))) return true;
          const d = f.file_date || f.display_date || f.created_at;
          if (!d) return false;
          const dateStr = new Date(d).toLocaleDateString('he-IL');
          return words.every(w => dateStr.includes(w));
        }
        const activeFiles = baseFiles.filter(f => (!filesCatFilter || f.category === filesCatFilter) && fileMatchesSearch(f, filesSearch));
        const grouped = activeFiles.reduce((acc, f) => {
          const cat = (filesSubTab === 'personal' && !f.category) ? '' : (f.category || 'בניין');
          if (!acc[cat]) acc[cat] = [];
          acc[cat].push(f);
          return acc;
        }, {});
        const FILE_CAT_COLORS = {
          'הסכמים': '#b8862f', 'מצגות': '#7f8fd3', 'מפרט טכני': '#8a8570',
          'נציגים': '#b8862f', 'כללי': '#b8862f', 'general': '#b8862f',
        };
        const fileCatColor = cat => FILE_CAT_COLORS[cat] || '#b8862f';
        return (
          <div>
            {/* tabs + category filter — right aligned */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginBottom: 16 }}>
              <div style={{ display: 'flex', gap: 24, borderBottom: '1px solid #ece5d5', width: '100%', marginBottom: 12, paddingBottom: 0 }}>
                {[{ id: 'general', label: `${t('file_general')} (${generalFiles.length})` }, { id: 'personal', label: `${t('file_personal')} (${personalFiles.length})` }].map(ft => {
                  const active = filesSubTab === ft.id;
                  return (
                    <button key={ft.id} onClick={() => { setFilesSubTab(ft.id); setFilesCatFilter(null); }} style={{
                      background: 'none', border: 'none', cursor: 'pointer', fontWeight: active ? 600 : 500,
                      fontSize: '0.88rem', color: active ? '#161d2e' : '#a89f88',
                      borderBottom: active ? '2px solid #8a8570' : '2px solid transparent',
                      paddingBottom: 14, marginBottom: -1,
                    }}>{ft.label}</button>
                  );
                })}
              </div>
              {allCats.length > 1 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  <button onClick={() => setFilesCatFilter(null)} style={{ padding: '4px 14px', borderRadius: 99, border: '1px solid', fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer', background: !filesCatFilter ? '#8a8570' : 'transparent', color: !filesCatFilter ? '#fff' : '#8a8570', borderColor: '#8a8570' }}>{t('all_word')}</button>
                  {allCats.map(cat => (
                    <button key={cat} onClick={() => setFilesCatFilter(filesCatFilter === cat ? null : cat)} style={{ padding: '4px 14px', borderRadius: 99, border: '1px solid', fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer', background: filesCatFilter === cat ? '#8a8570' : 'transparent', color: filesCatFilter === cat ? '#fff' : '#8a8570', borderColor: '#8a8570' }}>{tr(cat, lang)}</button>
                  ))}
                </div>
              )}
            </div>
            <div style={{ marginBottom: 16 }}>
              <input
                value={filesSearch}
                onChange={e => setFilesSearch(e.target.value)}
                placeholder={t('files_search_placeholder')}
                style={{ width: '100%', padding: '10px 14px', borderRadius: 12, border: '1px solid #e3d5ac', fontSize: '0.85rem', outline: 'none', boxSizing: 'border-box', direction: 'rtl' }}
              />
            </div>
            {activeFiles.length === 0 && <p style={{ color: '#9ca3af', textAlign: 'center' }}>{baseFiles.length === 0 ? t('no_files') : t('no_matching_files')}</p>}
            {Object.entries(grouped).map(([cat, catFiles]) => (
              <div key={cat || '_'} style={{ marginBottom: 26 }}>
                {cat && <div style={{ display: 'flex', alignItems: 'center', gap: 8, borderRight: `3px solid ${fileCatColor(cat)}`, paddingRight: 12, marginBottom: 10 }}>
                  <span style={{ fontWeight: 700, fontSize: '1.05rem', color: '#161d2e' }}>{tr(cat, lang)}</span>
                </div>}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {[...catFiles].sort((a, b) => {
                    const da = new Date(a.file_date || a.display_date || a.created_at);
                    const db = new Date(b.file_date || b.display_date || b.created_at);
                    return db - da;
                  }).map((f, idx, arr) => {
                    const displayDate = f.file_date
                      ? new Date(f.file_date).toLocaleDateString('he-IL')
                      : f.display_date
                        ? new Date(f.display_date).toLocaleDateString('he-IL')
                        : new Date(f.created_at).toLocaleDateString('he-IL');
                    const fileUrl = f.url.startsWith('http') ? f.url : window.location.origin + f.url;
                    return (
                      <div key={f.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '13px 0', borderBottom: idx < arr.length - 1 ? '1px solid #f1ecdf' : 'none', gap: 10 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
                          <div style={{ width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><PdfIcon size={30} /></div>
                          <span style={{ fontWeight: 600, fontSize: '0.95rem', color: '#161d2e', wordBreak: 'break-word' }}>{tr(stripExt(f.original_name || f.name), lang)}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0 }}>
                          <span style={{ fontSize: '0.82rem', color: '#a89f88', whiteSpace: 'nowrap' }}>{displayDate}</span>
                          <button onClick={() => { window.open(fileUrl, '_blank'); logTenantAction('tenant_file_view', { name: f.original_name || f.name }); }} title="צפה" style={{ border: 'none', background: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}><EyeIcon /></button>
                          <button onClick={() => { logTenantAction('tenant_file_download', { name: f.original_name || f.name }); fetch(fileUrl).then(r=>r.blob()).then(blob=>{ const a=document.createElement('a'); a.href=URL.createObjectURL(blob); a.download=downloadFilename(f.original_name||f.name, fileUrl); document.body.appendChild(a); a.click(); document.body.removeChild(a); setTimeout(()=>URL.revokeObjectURL(a.href),1000); }); }} title="הורד" style={{ border: 'none', background: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}><DownloadIcon /></button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        );
      })()}

      {/* About */}
      {tab === 'about-manhelet' && (() => {
        const { manhelet, projects, press } = aboutManheletData;
        const hasContent = manhelet?.manhelet_name || manhelet?.description || projects?.length > 0 || press?.length > 0;
        if (!hasContent) return <div style={{ background: '#fbf6ee', minHeight: '100%', padding: 40, color: '#9ca3af', textAlign: 'center' }}>{t('no_content')}</div>;
        // Deliberately a single light card (photo + logo stacked, then text)
        // instead of AboutTab's dark hero band, so the two "About" tabs read
        // as visually distinct sections rather than the same layout twice.
        return (
          <div style={{ background: '#fbf6ee', minHeight: '100%', padding: isMobile ? 16 : '26px 36px 40px' }}>
            {(manhelet?.manhelet_name || manhelet?.description) && (
              <div style={{ background: 'white', borderRadius: 20, padding: isMobile ? 22 : 28, display: 'flex', gap: 24, flexWrap: 'wrap', marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, flexShrink: 0, margin: isMobile ? '0 auto' : 0 }}>
                  {manhelet.logo_url && (
                    <img src={imgUrl(manhelet.logo_url)} alt="" style={{ width: 72, height: 72, objectFit: 'contain' }} />
                  )}
                  {manhelet.photo_url && (
                    <div style={{ width: 140, height: 140, borderRadius: '50%', overflow: 'hidden' }}>
                      <img src={imgUrl(manhelet.photo_url)} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain', transform: avatarTransform(manhelet.photo_position, manhelet.photo_zoom) }} />
                    </div>
                  )}
                </div>
                <div style={{ flex: 1, minWidth: 200, textAlign: isMobile ? 'center' : 'right' }}>
                  {manhelet.manhelet_name && <div style={{ fontWeight: 700, fontSize: '1.3rem', color: '#1a3320' }}>{tr(manhelet.manhelet_name, lang)}</div>}
                  {manhelet.title && <div style={{ fontSize: '0.85rem', color: '#a4864f', marginTop: 4 }}>{tr(manhelet.title, lang)}</div>}
                  {manhelet.description && <div style={{ fontSize: '0.9rem', color: '#4a3a24', marginTop: 12, lineHeight: 1.8, whiteSpace: 'pre-wrap' }}>{tr(manhelet.description, lang)}</div>}
                </div>
              </div>
            )}
            {projects?.length > 0 && (
              <div style={{ background: 'white', borderRadius: 20, padding: 22, marginBottom: 16 }}>
                <div style={{ fontWeight: 700, fontSize: '1rem', color: '#4a3a24', marginBottom: 10 }}>{t('projects_heading')}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {projects.map(p => (
                    <a key={p.id} href={p.url || undefined} target={p.url ? '_blank' : undefined} rel="noreferrer"
                      style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fbf6ee', borderRadius: 14, padding: '12px 16px', textDecoration: 'none', cursor: p.url ? 'pointer' : 'default' }}>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: '0.95rem', color: '#4a3a24' }}>{tr(p.name, lang)}</div>
                        {p.city && <div style={{ fontSize: '0.8rem', color: '#a4864f', marginTop: 3 }}>{tr(p.city, lang)}</div>}
                      </div>
                      {p.url && <span style={{ fontWeight: 600, fontSize: '0.82rem', color: '#1d4ed8', whiteSpace: 'nowrap' }}>{t('link_to_website')}</span>}
                    </a>
                  ))}
                </div>
              </div>
            )}
            {press?.length > 0 && (
              <div style={{ background: 'white', borderRadius: 20, padding: 22 }}>
                <div style={{ fontWeight: 700, fontSize: '1rem', color: '#4a3a24', marginBottom: 10 }}>{t('press_heading')}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {press.map(item => (
                    <a key={item.id} href={item.url || undefined} target={item.url ? '_blank' : undefined} rel="noreferrer"
                      style={{ display: 'block', background: '#fbf6ee', borderRadius: 14, padding: '12px 16px', textDecoration: 'none', cursor: item.url ? 'pointer' : 'default' }}>
                      <div style={{ fontWeight: 600, fontSize: '0.9rem', color: '#4a3a24' }}>{tr(item.title, lang)}</div>
                      {(item.source || item.date_str) && <div style={{ fontSize: '0.75rem', color: '#a4864f', marginTop: 3 }}>{tr(item.source, lang)}{item.source && item.date_str && ' · '}{item.date_str}</div>}
                      {item.url && <div style={{ fontWeight: 600, fontSize: '0.8rem', color: '#1d4ed8', marginTop: 6 }}>{t('full_article')}</div>}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })()}

      {tab === 'about' && (() => {
        const { founder, projects, press } = aboutData;
        const hasContent = founder?.founder_name || founder?.description || projects?.length > 0 || press?.length > 0;
        if (!hasContent) return <div style={{ background: '#fbf6ee', minHeight: '100%', padding: 40, color: '#9ca3af', textAlign: 'center' }}>{t('no_content')}</div>;
        const newsIcon = <svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M4 5H20M4 12H20M4 19H14" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path></svg>;
        // Split description into paragraphs: p[0]=bio in hero, p[1]=personal card, p[2]=quote card
        const descParas = (founder?.description || '').split('\n---\n').filter(Boolean);
        const heroBio = descParas[0] || '';
        const personalText = founder?.personal || descParas[1] || '';
        const quoteText = founder?.quote || descParas[2] || '';
        if (isMobile) return (
          <div style={{ padding: '16px 16px 32px' }}>
            {/* Mobile: same dark hero band as desktop, stacked instead of side-by-side */}
            {(founder?.founder_name || founder?.description) && (
              <div style={{ background: '#161d2e', borderRadius: 20, padding: 24, textAlign: 'center', marginBottom: 16 }}>
                {founder.logo_url && (
                  <div style={{ width: 72, height: 72, borderRadius: 10, overflow: 'hidden', background: 'rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 10px' }}>
                    <img src={imgUrl(founder.logo_url)} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  </div>
                )}
                {founder.photo_url && <img src={imgUrl(founder.photo_url)} alt="" style={{ width: 128, height: 128, borderRadius: '50%', objectFit: 'cover', objectPosition: founder.photo_position || '50% 20%', display: 'block', margin: '0 auto' }} />}
                {founder.title && <div style={{ fontSize: '0.8rem', color: '#e8c477', marginTop: 12 }}>{tr(founder.title, lang)}</div>}
                {founder.founder_name && <div style={{ fontWeight: 700, fontSize: '1.3rem', color: '#fff', marginTop: 4 }}>{tr(founder.founder_name, lang)}</div>}
                {founder.description && <div style={{ fontSize: '0.88rem', color: '#c7c3b8', marginTop: 14, lineHeight: 1.7, textAlign: 'right', whiteSpace: 'pre-wrap' }}>{tr(founder.description, lang)}</div>}
              </div>
            )}
            {/* Mobile projects list */}
            {projects?.length > 0 && (
              <div style={{ marginBottom: 20 }}>
                <div style={{ fontWeight: 700, fontSize: '1rem', color: '#4a3a24', marginBottom: 10 }}>{t('projects_heading')}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {projects.map(p => (
                    <a key={p.id} href={p.url || undefined} target={p.url ? '_blank' : undefined} rel="noreferrer"
                      style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fff', borderRadius: 16, padding: '14px 18px',
                        textDecoration: 'none', cursor: p.url ? 'pointer' : 'default',
                        boxShadow: p.url ? '0 0 0 1.5px #bfdbfe, 0 2px 8px rgba(29,78,216,0.12)' : 'none',
                      }}>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: '0.95rem', color: '#4a3a24' }}>{tr(p.name, lang)}</div>
                        {p.city && <div style={{ fontSize: '0.8rem', color: '#a4864f', marginTop: 3 }}>{tr(p.city, lang)}</div>}
                      </div>
                      {p.url && <span style={{ fontWeight: 600, fontSize: '0.82rem', color: '#1d4ed8', whiteSpace: 'nowrap' }}>{t('link_to_website')}</span>}
                    </a>
                  ))}
                </div>
              </div>
            )}
            {/* Mobile press */}
            {press?.length > 0 && (
              <div>
                <div style={{ fontWeight: 700, fontSize: '1rem', color: '#4a3a24', marginBottom: 10 }}>{t('press_heading')}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {press.map(item => (
                    <a key={item.id} href={item.url || undefined} target={item.url ? '_blank' : undefined} rel="noreferrer"
                      style={{
                        display: 'block', background: 'white', borderRadius: 16, padding: '14px 18px', textDecoration: 'none',
                        cursor: item.url ? 'pointer' : 'default',
                        boxShadow: item.url ? '0 0 0 1.5px #bfdbfe, 0 2px 8px rgba(29,78,216,0.12)' : 'none',
                      }}>
                      <div style={{ fontWeight: 600, fontSize: '0.9rem', color: '#4a3a24' }}>{tr(item.title, lang)}</div>
                      {(item.source || item.date_str) && <div style={{ fontSize: '0.75rem', color: '#a4864f', marginTop: 3 }}>{tr(item.source, lang)}{item.source && item.date_str && ' · '}{item.date_str}</div>}
                      {item.url && <div style={{ fontWeight: 600, fontSize: '0.8rem', color: '#1d4ed8', marginTop: 6 }}>{t('full_article')}</div>}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
        return (
          <div style={{ background: '#fbf6ee', minHeight: '100%', padding: '26px 36px 40px' }}>
            {/* Hero band */}
            {(founder?.founder_name || founder?.description) && (
              <div style={{ background: '#161d2e', borderRadius: 20, overflow: 'hidden', display: 'flex', marginBottom: 16 }}>
                {founder.photo_url && (
                  <div style={{ width: 220, flexShrink: 0, background: 'linear-gradient(160deg,#1e2740,#161d2e)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24, gap: 10 }}>
                    {founder.logo_url && <img src={imgUrl(founder.logo_url)} alt="" style={{ width: 72, height: 72, objectFit: 'contain' }} />}
                    <img src={imgUrl(founder.photo_url)} alt="" style={{ width: 160, height: 160, borderRadius: '50%', objectFit: 'cover', objectPosition: founder.photo_position || '50% 20%' }} />
                  </div>
                )}
                <div style={{ flex: 1, padding: '28px 30px', color: '#fff' }}>
                  {founder.title && <div style={{ fontWeight: 400, fontSize: '0.82rem', color: '#e8c477', letterSpacing: '0.5px', marginBottom: 6 }}>{tr(founder.title, lang)}</div>}
                  {founder.founder_name && <div style={{ fontWeight: 700, fontSize: '1.7rem', color: '#fff' }}>{tr(founder.founder_name, lang)}</div>}
                  {heroBio && <div style={{ fontWeight: 400, fontSize: '0.95rem', color: '#c7c3b8', marginTop: 14, lineHeight: 1.8, whiteSpace: 'pre-line' }}>{tr(heroBio, lang)}</div>}
                </div>
              </div>
            )}
            {/* Personal + Quote two-column */}
            {(personalText || quoteText) && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                {personalText && (
                  <div style={{ background: '#fff', borderRadius: 16, padding: '22px 24px', borderRight: '4px solid #c98a3f' }}>
                    <div style={{ fontWeight: 700, fontSize: '0.88rem', color: '#c98a3f', marginBottom: 10 }}>{t('personal_note')}</div>
                    <div style={{ fontWeight: 400, fontSize: '0.95rem', color: '#5a4c33', lineHeight: 1.8, whiteSpace: 'pre-line' }}>{tr(personalText, lang)}</div>
                  </div>
                )}
                {quoteText && (
                  <div style={{ background: '#f3e3c8', borderRadius: 16, padding: '22px 24px' }}>
                    <div style={{ fontWeight: 700, fontSize: '1.8rem', color: '#c98a3f', lineHeight: 0.5, marginBottom: 6 }}>״</div>
                    <div style={{ fontWeight: 400, fontSize: '0.95rem', color: '#5a4c33', lineHeight: 1.8, fontStyle: 'italic', whiteSpace: 'pre-line' }}>{tr(quoteText, lang)}</div>
                  </div>
                )}
              </div>
            )}
            {/* Projects */}
            {projects?.length > 0 && (
              <div style={{ marginBottom: 28 }}>
                <div style={{ fontWeight: 700, fontSize: '1.1rem', color: '#4a3a24', marginBottom: 14 }}>{t('projects_heading')}</div>
                <div style={{ display: 'grid', gridTemplateColumns: `repeat(${projects.length}, 1fr)`, gap: 14 }}>
                  {projects.map(p => (
                    <a key={p.id} href={p.url || undefined} target={p.url ? '_blank' : undefined} rel="noreferrer"
                      style={{
                        display: 'block', background: '#fff', borderRadius: 16, overflow: 'hidden', textDecoration: 'none',
                        cursor: p.url ? 'pointer' : 'default',
                        boxShadow: p.url ? '0 0 0 1.5px #bfdbfe, 0 2px 8px rgba(29,78,216,0.12)' : 'none',
                      }}>
                      {p.image_url && <img src={imgUrl(p.image_url)} alt="" style={{ width: '100%', height: 130, objectFit: 'cover', display: 'block' }} />}
                      <div style={{ padding: '18px 20px' }}>
                        <div style={{ fontWeight: 600, fontSize: '1.05rem', color: '#4a3a24' }}>{tr(p.name, lang)}</div>
                        {p.city && <div style={{ fontWeight: 400, fontSize: '0.88rem', color: '#a4864f', marginTop: 5 }}>{tr(p.city, lang)}</div>}
                        {p.url && <div style={{ fontWeight: 600, fontSize: '0.85rem', color: '#1d4ed8', marginTop: 14 }}>{t('link_to_website')}</div>}
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            )}
            {/* Press */}
            {press?.length > 0 && (
              <div>
                <div style={{ fontWeight: 700, fontSize: '1.1rem', color: '#4a3a24', marginBottom: 14 }}>{t('press_heading')}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {press.map(item => (
                    <a key={item.id} href={item.url || undefined} target={item.url ? '_blank' : undefined} rel="noreferrer"
                      style={{
                        display: 'flex', alignItems: 'center', gap: 16, background: '#fff', borderRadius: 16, padding: '18px 22px',
                        textDecoration: 'none', cursor: item.url ? 'pointer' : 'default',
                        boxShadow: item.url ? '0 0 0 1.5px #bfdbfe, 0 2px 8px rgba(29,78,216,0.12)' : 'none',
                      }}>
                      <div style={{ width: 42, height: 42, borderRadius: '50%', background: '#f3e3c8', color: '#c98a3f', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{newsIcon}</div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 600, fontSize: '0.98rem', color: '#4a3a24' }}>{tr(item.title, lang)}</div>
                        {(item.source || item.date_str) && (
                          <div style={{ fontWeight: 400, fontSize: '0.82rem', color: '#a4864f', marginTop: 4 }}>{tr(item.source, lang)}{item.source && item.date_str && ' · '}{item.date_str}</div>
                        )}
                      </div>
                      {item.url && (
                        <span style={{ fontWeight: 600, fontSize: '0.88rem', color: '#1d4ed8', whiteSpace: 'nowrap' }}>{t('full_article')}</span>
                      )}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })()}
    </div>
  );

  const logoutChoiceModal = showLogoutChoice && (
    <div onClick={() => setShowLogoutChoice(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: 'white', borderRadius: 16, padding: 28, maxWidth: 340, width: '100%', textAlign: 'center', direction: dir }}>
        <div style={{ fontWeight: 700, fontSize: '1.05rem', color: '#1f2937', marginBottom: 20 }}>לאן לעבור?</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button onClick={backToProjectList} style={{ padding: '11px', borderRadius: 10, border: '1px solid #d1d5db', background: 'white', color: '#1f2937', fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer' }}>
            ↩ לרשימת הפרויקטים
          </button>
          <button onClick={fullLogout} style={{ padding: '11px', borderRadius: 10, border: 'none', background: '#dc2626', color: 'white', fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
            <LogoutIcon size={16} color="white" /> התנתק
          </button>
          <button onClick={() => setShowLogoutChoice(false)} style={{ padding: '9px', borderRadius: 10, border: 'none', background: 'none', color: '#9ca3af', fontSize: '0.85rem', cursor: 'pointer' }}>
            ביטול
          </button>
        </div>
      </div>
    </div>
  );

  // ── MOBILE layout ───────────────────────────────────────────────────────────
  if (isMobile) {
    return (
      <div style={{ minHeight: '100vh', background: '#f3f4f6', direction: dir, overflowX: 'hidden', width: '100%' }}>
        <div style={{ background: TENANT_THEME, color: 'white', padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'white', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
              {headerLogo && <img src={headerLogo} alt="" style={{ width: '70%', height: '70%', objectFit: 'contain' }} />}
            </div>
            <div style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
              <div style={{ fontWeight: 700, fontSize: '1rem' }}>{tr(displayName(name), lang)}</div>
              {tenantName && <div style={{ fontSize: '0.82rem', opacity: 0.85 }}>{t('hello')} {tr(tenantName, lang)}</div>}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={onLogoutClick}
                style={{ padding: '3px 10px', borderRadius: 6, border: '1px solid rgba(255,255,255,0.4)', background: 'rgba(255,255,255,0.1)', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '0.78rem', whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                <LogoutIcon size={14} color="white" /> {t('logout_mobile')}
              </button>
            </div>
            <LangSwitcher />
          </div>
        </div>
        <div style={{ background: 'white', display: 'flex', justifyContent: 'flex-start', borderBottom: '2px solid #e5e7eb', overflowX: 'auto', overflowY: 'hidden', touchAction: 'pan-x', WebkitOverflowScrolling: 'touch' }}>
          {visibleTabs.map(tb => (
            <button key={tb.id} onClick={() => setTab(tb.id)}
              style={{ padding: '11px 14px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: tab === tb.id ? 700 : 400, color: tab === tb.id ? '#1a4a8a' : '#6b7280', borderBottom: tab === tb.id ? '2px solid #1a4a8a' : '2px solid transparent', marginBottom: -2, whiteSpace: 'nowrap', fontSize: '0.85rem' }}>
              {t(tb.key)}
            </button>
          ))}
        </div>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          {tabContent}
        </div>

        {/* עוזר AI צף לדייר — היה קיים רק בפריסת הדסקטופ, אז בטלפון הכפתור
            פשוט לא הופיע כלל */}
        <TenantAIChat phone={tenantPhone} projectName={name} tenantName={tenantName} logo={logo} />
        {logoutChoiceModal}
      </div>
    );
  }

  // ── DESKTOP layout with sidebar ─────────────────────────────────────────────
  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5', direction: dir, display: 'flex', flexDirection: 'column' }}>

      {/* Top header */}
      <div style={{ background: TENANT_THEME, color: 'white', padding: '14px 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'white', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
            {headerLogo && <img src={headerLogo} alt="" style={{ width: '70%', height: '70%', objectFit: 'contain' }} />}
          </div>
          <div style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
            <div style={{ fontWeight: 700, fontSize: '1.05rem' }}>{tr(displayName(name), lang)}</div>
            {tenantName && <div style={{ fontSize: '0.82rem', opacity: 0.85 }}>{t('hello')} {tenantName}</div>}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
          <div style={{ display: 'flex', gap: 6 }}>
            <button onClick={onLogoutClick}
              style={{ padding: '3px 12px', borderRadius: 6, border: '1px solid rgba(255,255,255,0.4)', background: 'rgba(255,255,255,0.1)', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '0.78rem', whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
              <LogoutIcon size={14} color="white" /> {t('logout')}
            </button>
          </div>
          <LangSwitcher />
        </div>
      </div>

      {/* Body: sidebar + content */}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>

        {/* Sidebar (RIGHT side in RTL) */}
        <div style={{ width: 240, background: 'white', borderLeft: '1px solid #e5e7eb', display: 'flex', flexDirection: 'column', flexShrink: 0, padding: '16px 0' }}>
          {/* Project logo + name in sidebar */}
          {logo && (
            <div style={{ textAlign: 'center', padding: '0 16px 16px', borderBottom: '1px solid #f3f4f6', marginBottom: 8 }}>
              <img src={logo} alt={name} onClick={() => setTab('home')} style={{ maxHeight: 120, maxWidth: '100%', objectFit: 'contain', cursor: 'pointer' }} />
              <div style={{ fontSize: '0.8rem', color: '#6b7280', marginTop: 6, fontWeight: 600 }}>{tr(displayName(name), lang)}</div>
            </div>
          )}
          {visibleTabs.map(tb => (
            <button key={tb.id} onClick={() => setTab(tb.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '16px 22px', border: 'none', cursor: 'pointer', textAlign: dir === 'rtl' ? 'right' : 'left',
                background: tab === tb.id ? '#f5f3ff' : 'none',
                borderRight: dir === 'rtl' ? (tab === tb.id ? '4px solid #7c3aed' : '4px solid transparent') : undefined,
                borderLeft: dir === 'ltr' ? (tab === tb.id ? '4px solid #7c3aed' : '4px solid transparent') : undefined,
                color: tab === tb.id ? '#7c3aed' : '#374151',
                fontWeight: tab === tb.id ? 700 : 500,
                fontSize: '1.05rem', width: '100%',
                transition: 'background 0.15s',
              }}>
              <TileIcon name={tb.icon} size={20} color={tab === tb.id ? '#7c3aed' : '#374151'} />
              {t(tb.key)}
            </button>
          ))}
        </div>

        {/* Main content */}
        <div style={{ flex: 1, overflowY: 'auto', background: '#f0f2f5' }}>
          {tabContent}
        </div>

      </div>

      {/* עוזר AI צף לדייר */}
      <TenantAIChat phone={tenantPhone} projectName={name} tenantName={tenantName} logo={logo} />
      {logoutChoiceModal}

    </div>
  );
}

function TenantAIChat({ phone, projectName, tenantName, logo }) {
  const greeting = `שלום${tenantName ? ' ' + tenantName : ''}! אני העוזר החכם שלך לפרויקט "${projectName}".\nאפשר לשאול אותי על הדירה שלך, השטחים, השלבים, ההודעות ועוד.`;
  const freshChat = () => [{ role: 'assistant', text: greeting }];
  const [open, setOpen] = useState(false);
  // Server-synced (was localStorage-only, so a chat started on the phone never
  // showed up on the website and vice versa) — loaded once the widget is first
  // opened, so it's never stale across devices/sessions.
  const [messages, setMessages] = useState(freshChat());
  const [loaded, setLoaded] = useState(false);
  const [history, setHistory] = useState([]);
  const [view, setView] = useState('chat'); // 'chat' | 'history' | 'viewingPast'
  const [viewingPast, setViewingPast] = useState(null);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);

  // Draggable floating button — persisted per-device so a tenant who moves it
  // out of the way of something it was covering keeps it there next visit.
  const [btnPos, setBtnPos] = useState(() => {
    try { return JSON.parse(localStorage.getItem('aiChatBtnPos')) || { bottom: 24, left: 24 }; }
    catch { return { bottom: 24, left: 24 }; }
  });
  const dragRef = useRef(null); // { startX, startY, startBottom, startLeft, moved, curLeft, curBottom }
  const wasDragRef = useRef(false);
  const btnRef = useRef(null);

  function onBtnPointerDown(e) {
    dragRef.current = { startX: e.clientX, startY: e.clientY, startBottom: btnPos.bottom, startLeft: btnPos.left, moved: false, curLeft: btnPos.left, curBottom: btnPos.bottom };
    e.currentTarget.setPointerCapture(e.pointerId);
    // Fallback in case the browser ever fails to deliver pointerup/cancel to
    // the captured element itself — without this the drag still LOOKS like it
    // worked (the DOM style updated live) but the position is never saved, so
    // it silently reverts to the old spot on the next page refresh.
    window.addEventListener('pointerup', onBtnPointerUp);
    window.addEventListener('pointercancel', onBtnPointerUp);
  }
  function onBtnPointerMove(e) {
    if (!dragRef.current) return;
    e.preventDefault();
    const dx = e.clientX - dragRef.current.startX;
    const dy = e.clientY - dragRef.current.startY;
    if (Math.abs(dx) > 4 || Math.abs(dy) > 4) dragRef.current.moved = true;
    if (!dragRef.current.moved) return;
    const newLeft = Math.max(4, Math.min(window.innerWidth - 60, dragRef.current.startLeft + dx));
    const newBottom = Math.max(4, Math.min(window.innerHeight - 60, dragRef.current.startBottom - dy));
    dragRef.current.curLeft = newLeft;
    dragRef.current.curBottom = newBottom;
    // Move the button via direct DOM style during the drag — bypassing React
    // state/re-render per pixel is what makes this track the pointer smoothly
    // instead of only snapping to the final spot on release.
    if (btnRef.current) {
      btnRef.current.style.left = `${newLeft}px`;
      btnRef.current.style.bottom = `${newBottom}px`;
    }
  }
  function onBtnPointerUp() {
    if (!dragRef.current) return; // already handled by the other listener (element or window)
    wasDragRef.current = !!dragRef.current.moved;
    if (wasDragRef.current) {
      const p = { left: dragRef.current.curLeft, bottom: dragRef.current.curBottom };
      localStorage.setItem('aiChatBtnPos', JSON.stringify(p));
      setBtnPos(p);
    }
    dragRef.current = null;
    window.removeEventListener('pointerup', onBtnPointerUp);
    window.removeEventListener('pointercancel', onBtnPointerUp);
  }

  useEffect(() => {
    if (!open || loaded) return;
    api.get(`/portal/tenant-chat/${encodeURIComponent(phone)}?projectName=${encodeURIComponent(projectName)}`, { headers: getTenantHeaders() })
      .then(r => { if (r.data?.messages?.length) setMessages(r.data.messages); })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [open, loaded, phone, projectName]);

  useEffect(() => {
    // Only push to the server once there's an actual exchange — no point
    // persisting a lone unanswered greeting.
    if (!loaded || !messages.some(m => m.role === 'user')) return;
    if (localStorage.getItem('tenantIsAdminPreview') === '1') return; // admin preview — don't persist
    api.post(`/portal/tenant-chat/${encodeURIComponent(phone)}`, { projectName, messages: messages.slice(-40) }, { headers: getTenantHeaders() }).catch(() => {});
  }, [messages, loaded, phone, projectName]);

  useEffect(() => { if (open && view === 'chat') bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages, open, view]);

  async function startNewChat() {
    if (messages.some(m => m.role === 'user') && localStorage.getItem('tenantIsAdminPreview') !== '1') {
      await api.post(`/portal/tenant-chat/${encodeURIComponent(phone)}/new`, { projectName }, { headers: getTenantHeaders() }).catch(() => {});
    }
    setMessages(freshChat());
    setView('chat');
  }

  async function openHistory() {
    setView(v => v === 'history' ? 'chat' : 'history');
    try {
      const r = await api.get(`/portal/tenant-chat-history/${encodeURIComponent(phone)}?projectName=${encodeURIComponent(projectName)}`, { headers: getTenantHeaders() });
      setHistory(r.data || []);
    } catch {}
  }

  async function send() {
    const q = input.trim();
    if (!q || loading) return;
    setInput('');
    setMessages(m => [...m, { role: 'user', text: q }]);
    setLoading(true);
    try {
      // Disambiguates which apartment this phone means, for a phone linked to
      // more than one unit within the same project (set when the tenant
      // picked one on the project/apartment selection screen).
      const bAddr = localStorage.getItem('tenantBAddr') || '';
      const bNum = localStorage.getItem('tenantBNum') || '';
      const aptNum = localStorage.getItem('tenantAptNum') || '';
      const r = await api.post('/portal/tenant-ai-chat', { question: q, phone, projectName, bAddr, bNum, aptNum }, { headers: getTenantHeaders() });
      setMessages(m => [...m, { role: 'assistant', text: r.data.answer }]);
    } catch (err) {
      const msg = err?.response?.data?.answer || err?.response?.data?.error || err?.message || 'שגיאה לא ידועה';
      setMessages(m => [...m, { role: 'assistant', text: 'שגיאה: ' + msg }]);
    }
    setLoading(false);
  }

  return (
    <>
      {open && (
        <div style={{
          position: 'fixed', bottom: btnPos.bottom + 66, left: Math.min(btnPos.left, window.innerWidth - 356), zIndex: 9999,
          width: 'auto', maxWidth: 340, height: 'min(460px, 70vh)', borderRadius: 18,
          background: 'white', boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
          display: 'flex', flexDirection: 'column', overflow: 'hidden',
          direction: 'rtl',
        }}>
          <div style={{
            background: 'linear-gradient(135deg,#7c3aed,#4f46e5)', color: 'white',
            padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <img src="https://aura-tenant-portal-files.s3.us-east-1.amazonaws.com/home-images/1788079441278-iakp5i51gfe.png" alt="" style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover' }} />
              <div>
                <div style={{ fontWeight: 700, fontSize: '0.95rem' }}>עוזר AI אישי</div>
                <div style={{ fontSize: '0.72rem', opacity: 0.85 }}>{projectName}</div>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <button onClick={startNewChat} title="שיחה חדשה" style={{
                background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', fontSize: '1rem', cursor: 'pointer',
                width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>🆕</button>
              <button onClick={openHistory} title="היסטוריית שיחות" style={{
                background: view === 'history' ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.15)', border: 'none', color: 'white', fontSize: '1rem', cursor: 'pointer',
                width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>🕘</button>
              <button onClick={() => setOpen(false)} style={{
                background: 'none', border: 'none', color: 'white', fontSize: '1.2rem', cursor: 'pointer',
              }}>✕</button>
            </div>
          </div>

          {view === 'history' && (
            <div style={{ flex: 1, overflowY: 'auto', padding: '12px 14px', background: '#f8f7ff' }}>
              {history.length === 0 && <div style={{ textAlign: 'center', color: '#9ca3af', fontSize: '0.85rem', marginTop: 20 }}>אין עדיין שיחות קודמות</div>}
              {history.map(h => {
                const firstQ = h.messages.find(m => m.role === 'user')?.text || '';
                return (
                  <button key={h.id} onClick={() => { setViewingPast(h); setView('viewingPast'); }}
                    style={{ display: 'block', width: '100%', textAlign: 'right', background: 'white', border: '1px solid #e5e7eb', borderRadius: 10, padding: '10px 12px', marginBottom: 8, cursor: 'pointer' }}>
                    <div style={{ fontSize: '0.78rem', color: '#9ca3af', marginBottom: 3 }}>{new Date(h.updated_at).toLocaleString('he-IL')}</div>
                    <div style={{ fontSize: '0.85rem', color: '#1f2937', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{firstQ}</div>
                  </button>
                );
              })}
            </div>
          )}

          {view === 'viewingPast' && viewingPast && (
            <>
              <div style={{ padding: '8px 14px', background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '0.78rem', color: '#6b7280' }}>שיחה מ-{new Date(viewingPast.updated_at).toLocaleString('he-IL')}</span>
                <button onClick={() => setView('history')} style={{ background: 'none', border: 'none', color: '#6d28d9', fontSize: '0.8rem', cursor: 'pointer', fontWeight: 600 }}>← חזרה לרשימה</button>
              </div>
              <div style={{ flex: 1, overflowY: 'auto', padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 10, background: '#f8f7ff' }}>
                {viewingPast.messages.map((m, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: m.role === 'user' ? 'flex-start' : 'flex-end' }}>
                    <div style={{
                      maxWidth: '82%', padding: '9px 13px',
                      borderRadius: m.role === 'user' ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                      background: m.role === 'user' ? '#ede9fe' : 'white',
                      color: '#1f2937', fontSize: '0.875rem', lineHeight: 1.55,
                      boxShadow: '0 1px 3px rgba(0,0,0,0.07)', whiteSpace: 'pre-wrap',
                    }}>{m.text}</div>
                  </div>
                ))}
              </div>
            </>
          )}

          {view === 'chat' && (
          <div style={{ flex: 1, overflowY: 'auto', padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 10, background: '#f8f7ff' }}>
            {messages.map((m, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: m.role === 'user' ? 'flex-start' : 'flex-end' }}>
                <div style={{
                  maxWidth: '82%', padding: '9px 13px',
                  borderRadius: m.role === 'user' ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                  background: m.role === 'user' ? '#ede9fe' : 'white',
                  color: '#1f2937', fontSize: '0.875rem', lineHeight: 1.55,
                  boxShadow: '0 1px 3px rgba(0,0,0,0.07)', whiteSpace: 'pre-wrap',
                }}>
                  {renderChatMessage(m.text)}
                </div>
              </div>
            ))}
            {loading && (
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ background: 'white', borderRadius: '16px 16px 16px 4px', padding: '9px 13px', fontSize: '0.875rem', color: '#9ca3af' }}>מחשב...</div>
              </div>
            )}
            <div ref={bottomRef} />
          </div>
          )}

          {view === 'chat' && (
          <div style={{ padding: '10px 12px', borderTop: '1px solid #e5e7eb', display: 'flex', gap: 8, background: 'white' }}>
            <input
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && send()}
              placeholder="שאל אותי..."
              style={{
                flex: 1, border: '1px solid #d1d5db', borderRadius: 22,
                padding: '8px 14px', fontSize: '0.875rem', outline: 'none',
                direction: 'rtl', background: '#f9fafb',
              }}
            />
            {/* Points into the message log (away from the input), not back at
                the text field — the plain ➤ glyph pointed the wrong way in
                this RTL layout, flipping it fixes the direction without
                needing a different icon. */}
            <button onClick={send} disabled={loading} style={{
              background: 'linear-gradient(135deg,#7c3aed,#4f46e5)', border: 'none',
              borderRadius: '50%', width: 38, height: 38, color: 'white',
              cursor: loading ? 'default' : 'pointer', fontSize: '1rem',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
              transform: 'scaleX(-1)',
            }}>➤</button>
          </div>
          )}
        </div>
      )}

      <button
        ref={btnRef}
        onClick={() => { if (!wasDragRef.current) setOpen(o => !o); }}
        onPointerDown={onBtnPointerDown}
        onPointerMove={onBtnPointerMove}
        onPointerUp={onBtnPointerUp}
        title="עוזר AI — גרור להזזה"
        style={{
          position: 'fixed', bottom: btnPos.bottom, left: btnPos.left, zIndex: 9999, touchAction: 'none',
          width: 56, height: 56, borderRadius: '50%', border: 'none', outline: 'none', cursor: 'grab',
          background: open ? 'linear-gradient(135deg,#7c3aed,#4f46e5)' : 'transparent',
          backgroundColor: open ? undefined : 'transparent',
          padding: 0, overflow: 'hidden',
          WebkitAppearance: 'none', appearance: 'none',
          boxShadow: open ? '0 4px 18px rgba(124,58,237,0.45)' : 'none',
          filter: 'none',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '1.6rem', transition: 'transform .2s',
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
      >
        {open ? '✕' : <img src="https://aura-tenant-portal-files.s3.us-east-1.amazonaws.com/home-images/1788079441278-iakp5i51gfe.png" alt="" draggable={false} onDragStart={e => e.preventDefault()} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%', display: 'block', pointerEvents: 'none' }} />}
      </button>
    </>
  );
}
